(function() {
    var ui = fpUtil.getNamespace('ui', fp);

    fpUi = $.extend(ui, {
        preventDefault: function(event){
            event && event.preventDefault && event.preventDefault();
        },
        submitForm: function(form, serviceCall, payload, options) {
            if(fpUtil.isNull(options) && _.isString(payload)) {
                options = payload;
                payload = undefined;
            }

            payload = fpUtil.getValue(payload, {});
            options = fpUtil.getValue(options, {});

            if (_.isString(options)) options = {method: options};

            options = _.defaults(options, {
                method: fpConstants.apiMethods.POST
            });

            var $form = $(form),
                isValid = ($form.attr('fp-validate') !== 'false') ? fpUtil.validateForm($form, null, null, options) : true,
                formLoader;

            if(!isValid) return $.Deferred().reject();

            var $submitButtons = $form.find('button.fp-btn:not(.fp-btn-cancel):visible, input[type="submit"].fp-btn:not(.fp-btn-cancel):visible, a.fp-btn:not(.fp-btn-cancel):visible'),
                handleTransitions = {start: true, end: true};

            if(!_.isObject(options.handleTransitions)) {
                if(!fpUtil.getBoolean(options.handleTransitions, true)) {
                    handleTransitions.start = handleTransitions.end = false;
                }
            }
            else $.extend(handleTransitions, options.handleTransitions);

            if($submitButtons.length) {
                _.find(['button[type="submit"]', 'input[type="submit"]', 'button', '.fp-btn-primary'], function(item) {
                    $btnSubmit = $submitButtons.filter(item).first();
                    return $btnSubmit.length;
                });
                if(!$btnSubmit.length) $btnSubmit = $submitButtons.last();

                formLoader = new fpUi.Loading({
                    appendTo: $btnSubmit,
                    showOnInstantiate: true,
                    destroyOnHide: true
                });
            }

            var handleFormErrors = _.has(options, 'handleFormErrors') ? options.handleFormErrors : $form.data('handle-errors'),
                $error = fpUi.getFormError($form, options.formGroup).hide();

            if(fpUtil.isNull(handleFormErrors) && $error.length) handleFormErrors = true;
            else if(!fpUtil.isNull(handleFormErrors) && !$error.length) handleFormErrors = false;

            if(handleTransitions.start) {
                fpUtil.showProgress();
                this.disableForm($form);
            }

            if(handleFormErrors != null) options.handleErrors = false;

            this.getFormValues($form, $.extend({values: payload}, options));

            var hasError = false,
                promise;

            if(_.isObject(options.origItem)) {
                payload = fpUtil.getChanged(payload, options.origItem, true);
                if(!_.size(payload)) promise = $.when();
                else if(options.origItem.id) payload.id = options.origItem.id;
            }

            if(!promise) {
                if(_.isObject(serviceCall)) {
                    if(payload.id != null && !options.ensurePost) promise = serviceCall.update(payload, options);
                    else promise = serviceCall.post(payload, options);
                }
                else {
                    promise = fp.api(serviceCall, payload, options);
                }
            }

            return promise
                .fail(function(jqXHR, textStatus, errorThrown) {
                    hasError = true;

                    if(handleFormErrors) {
                        fpUtil.showError(errorThrown, $error, {
                            handleScroll: $form.data('handle-scroll')
                        });
                    }
                })
                .always(function() {
                    if(formLoader) formLoader.hide();
                    if((!hasError || fp.isUnloading || options.multiStep) && !handleTransitions.end) {
                        return;
                    }

                    fpUtil.hideProgress();
                    fpUi.enableForm($form);
                });
        }
        ,getFormAlert: function(form, formGroup) {
            var $alert = $(form).find('.fp-notification:not([data-role="notification-warning"])').hide();
            if(formGroup) {
                var $alertFormGroup = $alert.filter('[data-role*="form-group-' + formGroup + '"]');
                if($alertFormGroup.length) $alert = $alertFormGroup;
            }
            return $alert;
        }
        ,getFormError: function(form, formGroup) {
            var $error = $(form).find('.fp-error, .fp-notification:not([data-role="notification-warning"])').hide();
            if(formGroup) {
                var $errorFormGroup = $error.filter('[data-role*="form-group-' + formGroup + '"]');
                if($errorFormGroup.length) $error = $errorFormGroup;
            }
            return $error;
        }
        ,showFormError: function(error, form, formGroup) {
            fpUtil.showError(error, this.getFormError(form, formGroup));
        }
        ,getFormValues: function($element, options) {
            $element = $($element);
            if(!$element.length) return _.getObject(options && options.values);

            options = $.extend({
                prefix: 'fp-input-',
                formGroup: '',
                includeEmpty: false,
                includeDisplayNone: true,
                ignorePropWarning: false
            }, options);

            var altFormName = S.getString($element.attr('data-alt-name')),
                formGroup = S.getString($element.attr('data-form-group')),
                values = _.getObject(options.values),
                hasModel = _.isObject(options.model),
                $input,
                prop,
                value,
                type,
                dataType,
                isCheckbox,
                inputFormName,
                inputFormGroup,
                inputModelNs,
                ignoreModal;

            $element.find(fpUtil.formatString('input[name^="{0}"],textarea[name^="{0}"],select[name^="{0}"],input[data-input-name^="{0}"],textarea[data-input-name^="{0}"],select[data-input-name^="{0}"]', options.prefix))
                .each(function () {
                    $input = $(this);
                    type = S.getString(this.type).toLowerCase();
                    if($input.prop('disabled')) return;
                    if(!options.includeDisplayNone && type !== 'hidden' && !$input.filter(':visible').length) return;

                    inputFormName = $input.attr('data-form-name') || '';
                    if (inputFormName != altFormName) return;

                    inputFormGroup = $input.attr('data-form-group') || '';
                    //fp.log(inputFormGroup, formGroup, options.formGroup);
                    if (inputFormGroup != options.formGroup && inputFormGroup != formGroup) return;

                    value = fpUi.getInputValue($input);

                    prop = $input.attr('data-input-name') || $input.attr('name');
                    prop = prop.replace(options.prefix, '');
                    if(!options.ignorePropWarning && S(prop).contains('-')) {
                        fp.notifier.notify({
                            name: 'SubmitWarning',
                            message: fpUtil.formatString('SubmitWarning: A fp.ui.getFormValues warning has occurred (input name "{0}" has hyphen that was not replaced)', prop)
                        }, {
                            severity: 'warning'
                        });
                    }

                    inputModelNs = $input.attr('fp-model') || prop;
                    if (fpUtil.isNullOrEmpty(value)) {
                        if(hasModel && !_.has(values, prop) && !fpUtil.hasNamespace(inputModelNs, options.model)) {
                            return;
                        }

                        if(options.includeEmpty) values[prop] = value;
                        //else delete values[prop];

                        return;
                    }

                    // value transformations from display to server expected.  data types match server meta.
                    isCheckbox = type == 'radio' || type == 'checkbox';
                    dataType = $input.attr('data-type') || (isCheckbox ? 'boolean' : null);

                    if(dataType) {
                        if (_.contains(['date', 'timestamp'], dataType)) {
                            var displayFormat = $input.attr('data-display-format'),
                                serverFormat = $input.attr('data-server-format');

                            if (displayFormat && serverFormat) {
                                value = fp.moment(value, displayFormat).format(serverFormat);
                            }
                        }
                        else if (_.contains(['int', 'float', 'numeric'], dataType)) {
                            value = Number(value);
                        }
                        else if (_.contains(['bool', 'boolean'], dataType)) {
                            if(value.length) value = fpUtil.getBoolean(value, false);
                            ignoreModal = fpUtil.getBoolean($input.attr('data-ignore-modal'));

                            //checkboxes will always report false if not checked
                            //because of this, check if model is defined
                            //need to ignore modal when checkbox value always need to be send to api
                            if(isCheckbox && !value && hasModel && (!ignoreModal && !fpUtil.hasNamespace(inputModelNs, options.model))) {
                                return;
                            }
                        }
                    }
                    //else if(type == 'select-multiple' && !_.isArray(value)) {
                    //    value = value.length ? value.split(',') : [];
                    //}

                    values[prop] = value;
                });

            return values;
        }
        ,getInputValue: function($input) {
            var type = S.getString($input.prop('type')).toLowerCase(),
                value;

            if(type == 'radio' || type == 'checkbox') {
                var name = $input.attr('name'),
                    $group = name ? $($input[0].form).find(fpUtil.formatString('[name="{0}"]', name)) : $input,
                    $checked = $group.filter(':checked'),
                    dataType = S($input.attr('data-type'));

                if(type == 'radio') value = $checked.first().val();
                else if(dataType.eq('string', true)) {
                    value = [];
                    $checked.each(function() {
                        if(this.value) value.push(this.value);
                    });
                }
                else value = $checked.length > 0;

                if(dataType.startsWith('bool', true)) return value;
            }
            else {
                value = $input.val();

                if(fpConfig.localePhone.strip_formatting) {
                    var mask = $input.data('mask');
                    if (mask && mask.mask.length == value.length) {
                        value = mask.getCleanVal();
                    }
                }
            }

            return _.isArray(value) ? value : S(value).trim().s;
        }
        ,disableForm: function($form) {
            $form = $($form);
            if(!S($form.prop('tagName')).eq('form', true)) return;
            var $fieldSet = $form.find('> fieldset'),
                $doc = $(window.document),
                scrollTop = $doc.scrollTop();
            if(!$fieldSet.length) {
                $fieldSet = $form.wrapInner('<fieldset></fieldset>').find('> fieldset');
            }

            $fieldSet
                .attr('disabled', 'disabled')
                .addClass('fp-is-disabled');

            $doc.scrollTop(scrollTop);
        }
        ,enableForm: function($form) {
            $form = $($form);
            var $fieldset = $form.find('> fieldset'),
                $doc = $(window.document),
                scrollTop = $doc.scrollTop();
            if(!$fieldset.length) return;

            $form.append($fieldset.children());
            $fieldset.remove();

            $doc.scrollTop(scrollTop);
        }
        ,validateBarcode: function(selector, isValid) {
            var $this = $(selector),
                $invalidBarcode = $this.next('[data-role="invalid-barcode"]'),
                svgClass = S($this.attr('class')).replace('hidden', '').trim();

            if(isValid) {
                $this.attr('class', svgClass.s);
                $invalidBarcode.addClass('hidden');
                return;

            }

            $this.attr('class', svgClass.concat(' hidden').trim().s);
            if(!$invalidBarcode.length) {
                $('<div data-role="invalid-barcode"></div>')
                    .insertAfter($this)
                    .text($this.attr('jsbarcode-value'))
            }
            $invalidBarcode.removeClass('hidden');
        },
        blockUI: function(options) {
            //fp.log('blockUI', fp.documentReady);

            var $window = $(window);

            if (
                !fp.documentReady ||
                $window.data('blockUI.isBlocked')
            ) {
                return;
            }

            var promise,
                viewModule;
            if(!fp.initialized) promise = fpUtil.getPromiseFromEvent(fp.events.VIEW_MODULE_LOADED);
            else if (!(viewModule = fp.Module.getViewModule())) return;

            //prevent tabbing until module is rendered
            $(document).on('keydown', fp.ui.preventTabOnKeydown);

            $.when(promise)
                .done(function(event, viewModuleConfig) {
                    if(!(viewModuleConfig || viewModule)) return;

                    $.blockUI(options);

                    var $body = $(document.body).addClass('fp-block-ui');

                    if (!fp.initialized) {
                        $body.css({
                            'min-height': $(document).height() + 400
                        });
                    }

                    var scrollTop = $(window.document).scrollTop();
                    $window
                        .off('blockmsg.fp')
                        .on('resize.blockmsg.fp scroll.blockmsg.fp', _.throttle(function () {
                            $body.find('> .blockMsg').center();
                            if(scrollTop) {
                                $(document).scrollTop(scrollTop);
                                scrollTop = null;
                            }
                        }, 100))
                        .trigger('resize.blockmsg.fp');

                    fp.trigger(fp.events.UI_BLOCKED);
                });
        },
        unblockUI: function(options) {
            //if(!arguments[1]) return $.when();
            if(
                !fp.documentReady ||
                fp.isUnloading ||
                (!fp.loaded && !(options && options.force))
            ) {
                return;
            }
            //fp.log('unblockUI');

            $(document).off('keydown', fp.ui.preventTabOnKeydown);

            var $window = $(window);
            if($window.data('blockUI.isBlocked')) {

                $.unblockUI(options);

                $window.off('blockmsg.fp');

                $(document.body)
                    .removeClass('fp-block-ui')
                    .css({
                        'min-height': ''
                    });

                //fp.log('unblockUI');

                fp.trigger(fp.events.UI_UNBLOCKED);
            }
        }
        ,pauseLoading: function() {
            if($(window).data('blockUI.isBlocked')) {
                $(document.body)
                    .removeClass('fp-block-ui')
                    .find('> .blockUI')
                    .addClass('hidden');
            }
            fp.__$freshop.find('> .fp-nprogress').addClass('hidden');
        }
        ,unpauseLoading: function() {
            if($(window).data('blockUI.isBlocked')) {
                $(document.body)
                    .find('> .blockUI')
                    .removeClass('hidden')
                    .filter('.blockMsg').center();
            }
            fp.__$freshop.find('> .fp-nprogress').removeClass('hidden');
        }
        ,preInitModules: function(modules, $parent) {
            if(!modules) modules = fpConfig.modules;

            //check module route states to ensure proper authorization
            var stateManager = this.router.stateManager,
                state,
                authorized,
                $module,
                requiredStoreId,
                disableRequiredStore;

            if(fp.loaded) {
                delete fp.disableRequiredStore;
                delete fp.requiredStoreId;
            }

            _.each(modules, function(items, key) {
                authorized = true;
                state = stateManager.get(key);
                if(state) authorized = fpUtil.isAuthorized(state);

                items = _.isArray(items) ? items : [items];
                _.each(items, function(moduleConfig) {
                    moduleConfig.authorized = authorized;
                    if(!authorized) return;

                    moduleConfig.name = S(key).dasherize().s;
                    if(fpUtil.isJQuery($parent)) {
                        $module = $parent.find(moduleConfig.elementSelector);
                        if(!$module.length) $module = $parent.filter(moduleConfig.elementSelector);
                    }
                    else $module = $(moduleConfig.elementSelector);

                    if($module.length) {
                        if(!fpConfig.topShopStoreId && moduleConfig.topShopStoreId) {
                            fpConfig.topShopStoreId = moduleConfig.topShopStoreId;
                        }


                        if(fpConfig.enableRequiredStore) {
                            if(moduleConfig.requiredStoreId) {
                                requiredStoreId = moduleConfig.requiredStoreId;
                            }
                            else if(moduleConfig.disableRequiredStore) {
                                disableRequiredStore = true;
                            }
                        }
                    }
                });
            });

            if(disableRequiredStore) fp.disableRequiredStore = disableRequiredStore;
            if(fp.disableRequiredStore) delete fp.requiredStoreId;
            else fp.requiredStoreId = requiredStoreId;
        }
        ,loadModule: function(moduleConfig, parent, $parent) {
            //fp.Module.get(moduleConfig.name);
            //var $element = $(moduleConfig.elementSelector);
            //fp.log('moduleConfig', $.extend(true, {}, moduleConfig));

            var $elements = $(moduleConfig.elementSelector),
                baseModuleConfig = moduleConfig,
                promise;

            if(fpUtil.isJQuery($parent)) {
                $elements = $parent.find(moduleConfig.elementSelector);
                if(!$elements.length) $elements = $parent.filter(moduleConfig.elementSelector);
            }
            else {
                $elements = $(moduleConfig.elementSelector);
            }

            moduleConfig = $.extend(true, {}, moduleConfig);

            if(moduleConfig.inherit) {
                var inheritConfig = _.getObject(this.getModule(moduleConfig.inherit));
                //fp.log('inheritConfig', $.extend(true, {}, inheritConfig));
                promise = this.loadModule({
                        name: inheritConfig.name || moduleConfig.inherit,
                        elementSelector: moduleConfig.elementSelector,
                        layout: inheritConfig.layout || moduleConfig.layout,
                        version: inheritConfig.version || moduleConfig.version,
                        inherit: inheritConfig.inherit,
                        inheritConstructor: _.result(moduleConfig, 'superInheritContructor'),
                        disableInstantiate: true
                    },
                    parent
                );
            }

            promise = $.when(promise)
                .then(function() {
                    //var regExp = fpUtil.regExp.matchNonAlphanumeric;
                    //regExp.lastIndex = 0;

                    if(!moduleConfig.name) throw new Error('Module name is not defined');

                    var $element = $elements.first(),
                        //moduleKey = moduleConfig.name.replace(regExp, '-'),
                        modulePath = moduleConfig.name.split('/'),
                        template,
                        promiseLoadModule;

                    moduleConfig.layout = S.getString(moduleConfig.layout, 'layout-0');

                    if(modulePath.length == 1) modulePath.push(modulePath[0]);
                    modulePath.unshift('module');
                    if(moduleConfig.version > 1) modulePath.splice(modulePath.length-1, 0, 'v' + moduleConfig.version);
                    modulePath.splice(modulePath.length-1, 0, moduleConfig.layout.replace('-', '/'));
                    modulePath[modulePath.length-1] = modulePath[modulePath.length-1] + '.json';
                    moduleConfig.path = modulePath.join('/');
                    moduleConfig.basePath = moduleConfig.path.split('/layout')[0];

                    //removeIf(!debug)

                    //if(fpUi.router.routeManager.urlParams.enable_frontload_modules == 'true') {
                    //    var cacheKey = fpUtil.cache.key(moduleConfig.path).replace(fpUtil.formatString('-{0}-{1}',  moduleConfig.name, moduleConfig.layout), ''),
                    //        cachedModule =  fp.cache.module && fp.cache.module[cacheKey];
                    //
                    //    if(cachedModule) {
                    //        var moduleData = {};
                    //        if(_.has(cachedModule, moduleConfig.layout)) moduleData.html = cachedModule[moduleConfig.layout];
                    //        if(_.has(cachedModule, 'js')) moduleData.js = cachedModule.js;
                    //
                    //        promiseLoadModule = $.Deferred().resolve(moduleData).promise();
                    //    }
                    //}

                    //endRemoveIf(!debug)

                    if(!promiseLoadModule) {
                        promiseLoadModule = fp.api(moduleConfig.path, null, {cache: true, queue: true, apiKey: 'sdk'});
                    }

                    return promiseLoadModule
                        .then(function(moduleData) {
                            var deferred = $.Deferred();

                            if(_.size(moduleData)) {
                                var parsedHtmlData;

                                try {
                                    parsedHtmlData = fp.Component.parseHtml(moduleData.html, true);
                                }
                                catch (exc) {
                                    fp.notifier.notify(exc, {
                                        severity: 'error',
                                        metaData: {
                                            'meta data': {
                                                'Module Name': moduleConfig.name,
                                                'Module Selector': S.getString(moduleConfig.elementSelector).substr(0, 500),
                                                'Module Layout': moduleConfig.layout
                                            }
                                        }
                                    });
                                }

                                if(moduleConfig.renderModules) {
                                    var promiseChildModules = [],
                                        childModules = [],
                                        hashedChildModules = moduleConfig.modules = _.getObject(moduleConfig.modules),
                                        childModuleKey,
                                        promiseChildModule;

                                    _.each(parsedHtmlData.modules, function (childModuleConfig) {
                                        if (!_.isObject(childModuleConfig)) childModuleConfig = {name: childModuleConfig};

                                        childModuleKey = S(_.last(childModuleConfig.name.split('/'))).camelize().s;

                                        if (_.has(hashedChildModules, childModuleKey)) {
                                            $.extend(hashedChildModules[childModuleKey], childModuleConfig);
                                        }
                                        else hashedChildModules[childModuleKey] = childModuleConfig;
                                    });

                                    _.each(hashedChildModules, function (childModuleConfig) {
                                        if(!childModuleConfig.disableAutoLoad || (fp.isLocal() && childModuleConfig.enableAutoLoadLocal)) {
                                            //if(_.isString(childModuleConfig.layoutNamespace)) {
                                            //    childLayoutNamespace = fpUtil.getObjectFromNamespace(childModuleConfig.layoutNamespace, fpConfig);
                                            //    childModuleConfig.layout = childLayoutNamespace.layout || childModuleConfig.layout;
                                            //}

                                            //childModuleConfig.disableInstantiate = true;

                                            promiseChildModule = fpUi.loadModule(childModuleConfig)
                                                .then(function (data) {
                                                    childModules.push(data);
                                                });

                                            promiseChildModules.push(promiseChildModule);
                                        }
                                    });
                                }

                                var onLoadChildModules = function() {
                                    //fp.log('onLoadChildModules', moduleKey);
                                    var promiseInitModuleFromJson;

                                    $element.addClass('fp-core fp-module');

                                    const moduleConstructor = fp.Module.getConstructor(moduleConfig.name);

                                    try {
                                        if (moduleConstructor) {
                                            if(!moduleConfig.disableInstantiate) {
                                                template = _.template(parsedHtmlData.html);
                                                moduleData = new moduleConstructor($element, moduleConfig, template, parent);
                                            }
                                            else {
                                                moduleData = moduleConstructor;
                                            }
                                        }
                                        else {
                                            if (moduleData.css) {
                                                $('head').find('> link[data-group="freshop"]')
                                                    .last()
                                                    .after(fpUtil.formatString('<style type="text/css" data-group="freshop" data-name="{0}">{1}</style>', moduleConfig.name, moduleData.css));
                                            }

                                            //fp.log('moduleConfig', moduleConfig);
                                           
                                            template = _.template(parsedHtmlData.html);
                                            if (moduleData.js) {
                                                promiseInitModuleFromJson = fpUi.initModuleFromJson(moduleData, $element, moduleConfig, template, parent)
                                                    .then(function(data) {
                                                        moduleData = data;

                                                        if(_.size(childModules)) {
                                                            moduleData.modules = childModules;
                                                            _.each(childModules, function (item) {
                                                                item.parent = moduleData;
                                                            });
                                                        }
                                                    });
                                            }
                                            else $element.html(template());
                                        }
                                    }
                                    catch (exc) {
                                        fp.notifier.notify(exc, {
                                            severity: 'error',
                                            metaData: {
                                                'meta data': {
                                                    'Module Name': moduleConfig.name,
                                                    'Module Selector': S.getString(moduleConfig.elementSelector).substr(0, 500),
                                                    'Module Layout': moduleConfig.layout
                                                }
                                            }
                                        });
                                    }

                                    if(!fp.loaded) fpUtil.showProgress();

                                    return promiseInitModuleFromJson;
                                };

                                $.when.apply($, promiseChildModules)
                                    .then(onLoadChildModules, onLoadChildModules)
                                    .always(function() {
                                        deferred.resolve(moduleData, $element, moduleConfig, template, parent);
                                    });
                            }
                            else deferred.resolve(moduleData, $element, moduleConfig, template, parent);

                            return deferred
                                .promise()
                                .always(function(data) {
                                    if(!fp.loaded) fpUtil.showProgress();

                                    return data;
                                });
                        });
                });

            //if there is more than one element we need to
            //iterate and call fpUi.loadModule for each element
            if($elements.length > 1) {
                promise = promise
                    .then(function(data) {
                        //if((data instanceof fp.Module.View)) return;

                        var deferredSiblingModules = $.Deferred(),
                            siblingPromises = [];

                        $elements.each(function(index) {
                            if(!index) return;

                            var siblingConfig = $.extend(true, {}, baseModuleConfig);
                            siblingConfig.elementSelector = this;
                            promiseModule = fpUi.loadModule(siblingConfig);
                            siblingPromises.push(promiseModule);
                        });

                        var always = function() {
                            deferredSiblingModules.resolve(data);
                        };
                        $.when.apply($, siblingPromises).then(always, always);

                        return deferredSiblingModules.promise();
                    });
            }

            return promise;
        }
        ,initRequest: function(toParams) {
            var deferred = $.Deferred();
            if(fpConfig.disableInitializeShopping) return deferred.resolve();

            var stateParams = toParams;
            if(!_.isObject(stateParams)) stateParams = $.extend({}, fpUi.router.stateManager.stateParams);

            var searchParams = fpUtil.urlParams({
                    includeSearch: true,
                    includeRouteSearch: false
                }),
                routeParams = fpUtil.urlParams({
                    includeSearch: false,
                    includeRouteSearch: true
                }),
                storeId = S.getString(stateParams.store || stateParams.store_id || $('[data-requiredStoreId]').attr('data-requiredStoreId')),
                storeNumber = storeId.length ? '' : S.getString(stateParams.store_number),
                kioskStoreId = stateParams.kiosk_store_id;
                removeParamNames = fp.isBot ? [] : [
                    'store',
                    'store_id',
                    'store_number',
                    'fulfillment_identifier',
                    'fulfillment_type_id',
                    'promo_code',
                    'promotion_code',
                    'ref_code',
                    'referral_code',
                    'token',
                    'kiosk_store_id'
                ];

            //if(fp.isLocal()) removeParamNames = [];

            var promotionCode = stateParams.promo_code || stateParams.promotion_code,
                referralCode = stateParams.ref_code || stateParams.referral_code,
                fulfillmentIdentifier = stateParams.fulfillment_identifier || stateParams.fulfillment_type_id,
                promisePromotion;

            if (promotionCode || referralCode) {
                promisePromotion = fpService.userMeService
                    .post({
                        promotion_code: fpUtil.getUndefinedIfEmpty(promotionCode),
                        by_referral_code: fpUtil.getUndefinedIfEmpty(referralCode)
                    }, {
                        childServiceCall: 'promotions',
                        handleErrors: false
                    });

                if(referralCode) fp.setPrefCookie({referral_code: referralCode});
            }

            var uiRouter = fpUi.router,
                isUnloading = !uiRouter.routeManager.hasXhrPageLoad && _.hasAny(searchParams, removeParamNames),
                hasParams;

            //removeIf(!debug)

            //don't remove  remove store_id from url if in debug mode
            //delete removeParamNames.store;
            //delete removeParamNames.store_id;
            //delete removeParamNames.store_number;

            //endRemoveIf(!debug)

            _.each(removeParamNames, function(key) {
                if(_.has(stateParams, key)) stateParams[key] = null;
                if(_.has(searchParams, key)) searchParams[key] = null;
                if(_.has(routeParams, key)) {
                    routeParams[key] = null;
                    hasParams = true;
                }

                delete uiRouter.routeManager.searchParams[key];
                delete uiRouter.routeManager.urlParams[key];
                delete uiRouter.stateManager.stateParams[key];
            });

            if(isUnloading && window.history && window.history.replaceState) {
                isUnloading = false;

                var href = uiRouter.routeManager.buildUrl(null, {searchParams: searchParams, routeSearchParams: routeParams}),
                    origin = uiRouter.location.origin();
                if(fpConfig.enableRouteDomain && uiRouter.routeManager.origin && uiRouter.routeManager.origin != origin && S(href).contains(uiRouter.routeManager.origin)) {
                    href = href.replace(uiRouter.routeManager.origin, origin);
                }

                window.history.replaceState({}, null, href);
            }
            else if(!isUnloading && hasParams) {
                _.each(searchParams, function(key) {
                    if(!_.has(routeParams, key)) delete stateParams[key];
                });

                var stateManager = uiRouter.stateManager;
                stateManager.go(stateManager.current, stateParams, {preventDefault: true, searchParams: searchParams, enableReplaceState: true});
            }

            $.when(promisePromotion)
                .always(function () {
                    fp.isUnloading = freshop.unloading = isUnloading;

                    //if freshop has not been loaded at
                    if(
                        fp.loaded && !isUnloading && (
                            (storeId.length && storeId != fp.store.id)
                            || (storeNumber.length && storeNumber != fp.store.number)
                        )
                    ) {
                        fp.ensureActiveStore(false, {
                            storeId: storeId,
                            storeNumber: storeNumber,
                            kioskStoreId: kioskStoreId
                        })
                        .always(function () {
                            if (isUnloading) {
                                deferred.resolve();
                                return;
                            }

                            $.when(
                                fp.listManager.getSelectedList(true, null, {handleErrors: false}),
                                fpUi.loadStoreDependencies()
                            ).always(deferred.resolve);
                        });
                    }
                    else deferred.resolve();
                });

            return deferred
                .then(function() {
                    if(fulfillmentIdentifier) return fpUi.setFulfillmentType(fulfillmentIdentifier);
                })
                .then(function() {
                    if(isUnloading) {
                        var url = uiRouter.routeManager.buildUrl(null, {searchParams: searchParams, routeSearchParams: routeParams});

                        window.location.replace(url);

                        return $.Deferred().promise(); //page is unloading. we don't need to resolve deferred
                    }

                    if(!fp.loaded) return; //freshop hasn't loaded yet; no need to set department

                    fpUtil.hideError();
                    fpUtil.initDepartment();
                });
        }
        ,getModule: function(name, modules) {
            if (!name) return;

            modules = modules || fpConfig.modules;
            //fp.log('modules', modules);
            var module = _.find(modules, function (item) {
                return item.name == name || item.path == name;
            });

            if (!module) {
                _.find(modules, function(item) {
                    if(_.size(item.modules)) {
                        module = fpUi.getModule(name, item.modules);
                        return module != null;
                    }
                });
            }

            return module;
        }
        ,loadModules: function(modules, $parent, enableInitRequest) {
            if(!modules) modules = fpConfig.modules;
            delete fp.modulesLoaded;

            var stateManager = fpUi.router.stateManager,
                routeStates = fpConfig.routeStates,
                loadModulePromises = [],
                viewModuleConfig,
                $module;

            _.each(modules, function(items, key) {
                items = _.isArray(items) ? items : [items];

                _.each(items, function(moduleConfig) {
                    //if(
                    //    fpConfig.enableMobile &&
                    //    (fp.bowser.mobile || fp.bowser.tablet) &&
                    //    !(moduleConfig.enableMobile || fpUtil.getFloat(moduleConfig.version, 1) >= 2) //version 2 is automatically mobile
                    //) {
                    //    return;
                    //}

                    if(moduleConfig.disableAutoLoad) return;

                    //when passing in $parent we only want to load modules inside
                    if(fpUtil.isJQuery($parent)) {
                        $module = $parent.find(moduleConfig.elementSelector);
                        if(!$module.length) $module = $parent.filter(moduleConfig.elementSelector);
                    }
                    else $module = $(moduleConfig.elementSelector);
                    
                    if(!moduleConfig.isView) {
                        $module = $module.filter(':not([data-module-loaded="true"])');
                    }

                    if($module.length) {
                        $module.attr('data-module-loaded', true);

                        if(!fp.moduleDepartmentId) fp.moduleDepartmentId = $module.attr('data-freshop-department_id') || $module.attr('data-department-id');
                        if(!fp.moduleCategoryId) fp.moduleCategoryId = $module.attr('data-freshop-category_id');

                        //temporary fix for current configuration of parent/child modules in checkout
                        //check if we should be loading child module
                        _.find(moduleConfig.modules, function(item) {
                            if(!item.elementSelector && item.inherit) {
                                var routeState = routeStates[S(item.name).replace('/', '-').camelize().s];
                                if(routeState && stateManager.is(routeState)) {
                                    item.elementSelector = moduleConfig.elementSelector;
                                    item.isView = moduleConfig.isView;
                                    if(!_.has(item, 'version')) item.version = moduleConfig.version;
                                    moduleConfig = item;
                                    return true;
                                }
                            }
                        });

                        if(!viewModuleConfig && moduleConfig.isView) viewModuleConfig = moduleConfig;

                        loadModulePromises.push(fpUi.loadModule(moduleConfig, null, $parent));
                    }
                });
            });

            if(modules === fpConfig.modules) fp.trigger(fp.events.VIEW_MODULE_LOADED, viewModuleConfig);

            var promiseLoadModules = $.when.apply($, loadModulePromises);
            if(enableInitRequest) {
                promiseLoadModules = promiseLoadModules
                    .then(function () {
                        if (fp.isUnloading) return;

                        stateManager.init();

                        return fpUi.initRequest();
                    });
            }

            return promiseLoadModules
                .then(function () {
                    if (fp.isUnloading) return;

                    if (enableInitRequest && !fp.loaded) {
                        fp
                            .on(fp.events.ROUTE_BEFORE_CHANGE, function (event, payload) {
                                fpUi.initRequest(payload.toParams);
                            });
                    }

                    fp.modulesLoaded = true;
                    if(fp.Module.items.length) {
                        return fpUi.initModules(fp.Module.items);
                    }
                });
        }
        ,initModuleFromJson: function(moduleData, $element, moduleConfig, template, parent) {
            if(!_.isObject(moduleData)) return moduleData;
            if(!moduleData.js) return moduleData;

            //if(moduleConfig.inherit) {
            //    var inheritConstructor = fp.Module.getConstructor(moduleConfig.inherit);
            //    fp.log('inheritConstructor', template, _.keys(inheritConstructor));
            //
            //    if(inheritConstructor && inheritConstructor.template) {
            //        template = inheritConstructor.template;
            //    }
            //}

            let jsString = moduleData.js;
            const matchWrapperFunction = fpUtil.regExp.matchWrapperFunction;
            matchWrapperFunction.lastIndex = 0;
            if(matchWrapperFunction.test(jsString)) jsString = 'return ' + jsString;

            const stateManager = this.router.stateManager,
                initMethod = new Function(
                    'fp',
                    'util',
                    'constants',
                    'service',
                    'jQuery',
                    '$',
                    '_',
                    'moment',
                    'dateFns',
                    'jss',
                    'showdown',
                    'S',
                    'Lockr',
                    'stateManager',
                    'stateParams',
                    'element',
                    'config',
                    'template',
                    'parent',
                    jsString
                ),
                deferred = $.Deferred();

            let moduleConstructor = initMethod(
                    fp,
                    fpUtil,
                    fpConstants,
                    fpService,
                    jQuery,
                    $,
                    _,
                    fp.moment,
                    dateFns,
                    jss,
                    showdown,
                    S,
                    Lockr,
                    stateManager,
                    stateManager.stateParams,
                    $element,
                    moduleConfig,
                    template,
                    parent
                ),
                promiseInherit,
                promiseDependencies;

            //if(fp.loaded) {
            //    fp.log('moduleData', moduleData);
            //    fp.log('moduleConfig', moduleConfig);
            //    fp.log('moduleConstructor', moduleConstructor);
            //    fp.log('$element', $element);
            //}

            if(_.isObject(moduleConstructor) && moduleConstructor.moduleConstructor) {
                const moduleWrapper = moduleConstructor;
                _.defaults(moduleConfig, moduleWrapper.config);

                if(moduleConfig.dependencies?.load?.file) {
                    promiseDependencies = this.loadFileDependencies(moduleConfig.dependencies.load.file);
                }

                if(moduleConfig.inherit && !moduleConfig.inheritConstructor) {
                    var inheritConfig = {};
                    if(!moduleConfig.superInheritContructor) {
                        inheritConfig = _.getObject(this.getModule(moduleConfig.inherit), inheritConfig);
                    }
                    else {
                        delete inheritConfig.inherit;
                    }

                    promiseInherit = $.when(promiseDependencies)
                        .then(function() {
                            return fp.ui.loadModule({
                                    name: inheritConfig.name || moduleConfig.inherit,
                                    elementSelector: moduleConfig.elementSelector,
                                    layout: inheritConfig.layout || moduleConfig.layout,
                                    version: inheritConfig.version || moduleConfig.version,
                                    inherit: inheritConfig.inherit,
                                    inheritConstructor: _.result(moduleConfig, 'superInheritContructor'),
                                    disableInstantiate: true
                                },
                                parent
                            );
                        });
                }
            }

            $.when(promiseDependencies, promiseInherit)
                .always(function() {
                    if(_.isObject(moduleConstructor) && _.isFunction(moduleConstructor.moduleConstructor)) {
                        var inheritConstructor = moduleConfig.inheritConstructor;
                        if(!inheritConstructor && moduleConfig.inherit) {
                            inheritConstructor = fp.Module.getConstructor(moduleConfig.inherit);
                        }
                        //fp.log(moduleConfig.name, $.extend(true, {}, moduleConstructor));
                        moduleConstructor = moduleConstructor.moduleConstructor(inheritConstructor);
                    }

                    if (_.isFunction(moduleConstructor)) {
                        //fp.log(moduleConfig.name, $.extend(true, {}, moduleConfig));
                        moduleConstructor.template = template;
                        fp.Module.addConstructor(moduleConfig.name, moduleConstructor);

                        if(!moduleConfig.disableInstantiate) {
                            //fp.log('initModuleFromJson: moduleConfig', $.extend(true, {}, moduleConfig));
                            moduleData = new moduleConstructor($element, moduleConfig, template, parent);
                        }
                    }

                    //fp.log('resolve', moduleData)
                    //fp.log('resolve', moduleData)
                    deferred.resolve(moduleData);
                });

            return deferred.promise();
        }
        ,loadFileDependencies: function(dependencies, options) {
            if (!_.size(dependencies)) return $.when();

            if(!_.isArray(dependencies)) dependencies = [dependencies];
            options = _.getObject(options);

            var promiseDependencies = [],
                minify = !fp.isDev() && fpUi.router.routeManager.urlParams.minify !== 'false',
                $freshop;

            _.each(dependencies, function(item) {
                let src,
                    promise,
                    type,
                    external;

                if(fpUtil.isPromise(item)) {
                    promiseDependencies.push(item);
                    return;
                }
                else if(_.isObject(item)) {
                    src = item.src;
                    type = item.type;
                    external = item.external;
                }
                else {
                    src = item;
                }

                src = S(src);

                if(!type) {
                    if(src.endsWith('.js')) {
                        type = 'js';
                    }
                    else if(src.endsWith('.css')) {
                        type = 'css';
                    }
                    else if(src.endsWith('.html')) {
                        type = 'html';
                    }
                }

                const fileName = src.split('/').pop().split('.')[0];
                const cacheKey = fpUtil.cache.key(src.s);

                if (type === 'css') {
                    if (!src.contains('//')) {
                        src = src.prepend(fp.clientAssetBaseUrl + 'css/');
                        if (minify && !src.endsWith('min.css')) src = src.replace('.css', '.min.css');
                    }
                    if(!$freshop) $freshop = $('head').find('> link[data-group="freshop"]');

                    if(!$freshop.filter(fpUtil.formatString('[data-name="{0}"]', fileName)).length) {
                        promise = fpUi.loadScript(src.s, {
                            crossorigin: true,
                            "data-group": 'freshop',
                            "data-name": fileName
                        }, null, {
                            type: 'css',
                            insertBefore: item.prepend && $freshop.first(),
                            insertAfter: !item.prepend && $freshop.last(),
                            apiOptions: options.apiOptions
                        });
                    }
                }
                else if (type === 'js') {
                    if(external) {
                        promise = fpUi.loadScript(src.s);
                    }
                    else {
                        if (!src.contains('//')) {
                            src = src.prepend(fp.assetCdnUrl + 'js/');
                            if (minify && !src.endsWith('.min.js')) src = src.replace('.js', '.min.js');
                        }

                        if(!fp.cache.file[cacheKey]) {
                            fp.cache.file[cacheKey] = true;
                            promise = fp.api(
                                    src.s,
                                    null,
                                    $.extend({
                                        dataType: 'text',
                                        apiKey: null,
                                        // cache: true
                                    }, options.apiOptions)
                                )
                                .then(function (data) {
                                    //as this js was loading via XHR the sourceMappingURL is not correct. Fix this.
                                    if(src.contains(fp.assetCdnUrl)) {
                                        var path = src.split('/');
                                        if (path) {
                                            path.pop();
                                            data = data.replace('sourceMappingURL=', fpUtil.formatString('sourceMappingURL={0}/', path.join('/')));
                                        }
                                    }

                                    var isJsonEditor = src.match(/jsoneditor(\.min)?\.js/g)/*,
                                        isJsCharting = !isJsonEditor && src.match(/jscharting(-(\.?\d+)+)?(\.min)?\.js/g),
                                        oldJsCharting = isJsCharting && window.JSC*/;

                                    if (src.contains('/admin/')) {
                                        new Function('jQuery', '$', '_', 'moment', 'dateFns', 'jss', 'showdown', data)
                                            .call(window, jQuery, $, _, fp.moment, dateFns, jss, showdown);
                                    }
                                    // else if(fp.isLocal() && data.indexOf('/*! admin/enclose-header.js */') === 0) {
                                    //     //using eval allows debugger to work properly
                                    //     eval(data);
                                    // }
                                    else {
                                        new Function('jQuery', '$', '_', 'dateFns', 'jss', 'showdown', 'S', 'fp', 'fpConfig', 'util', 'service', 'fpUtil', 'fpConstants', 'fpService', data)
                                            .call(window, jQuery, $, _, dateFns, jss, showdown, S, fp, fpConfig, fpUtil, fpService, fpUtil, fpConstants, fpService);
                                    }

                                    if(isJsonEditor) fp.__initJSONEditor();
                                    //else if(isJsCharting) fp.__initJsCharting(oldJsCharting);
                                });
                        }
                    }
                }
                else if (type === 'html') {
                    if(!fp.cache.file[cacheKey]) {
                        fp.cache.file[cacheKey] = true;
                        promise = fp.api(src, null, {apiKey: 'sdk', dataType: 'text'});
                        if(src.endsWith('component.html')) {
                            promise = promise
                                .then(function(data) {
                                    fp.Component.parseHtml(data);
                                    return data;
                                });
                        }
                    }
                }

                if(promise) promiseDependencies.push(promise);
            });

            return $.when.apply($, promiseDependencies);
        }
        ,initModules: function(modules, autoRender) {
            fp.Module.sort();

            var promises = [],
                disableProgressPromises = [],
                hashedPromises = {},
                hashedModules = {};

            function initModule(module, lineage, isDependency) {
                var promiseKey = _.isString(module.config.elementSelector) ? module.config.elementSelector : module.config.name,
                    promise;

                lineage = _.getObject(lineage);
                lineage[promiseKey] = true;

                if(isDependency && _.has(hashedPromises, promiseKey)) {
                    promise = hashedPromises[promiseKey];
                    return promise;
                }

                //if(!module.dependencies.init) fp.log('module', module);
                if(_.size(module.dependencies.init.module)) {
                    var promiseDependencies = [],
                        dependencyModule;

                    //fp.log('module.dependencies.init.module', module.dependencies.init.module);
                    _.each(module.dependencies.init.module, function(moduleName) {
                        dependencyModule = hashedModules[moduleName];
                        if(!(dependencyModule && dependencyModule.enabled)) return;

                        if(lineage[moduleName]) {
                            fp.warn(fpUtil.formatString(
                                'Circular dependency detected for initializing module "{0}" and dependency module "{1}"',
                                promiseKey,
                                _.isString(dependencyModule.config.elementSelector) ? dependencyModule.config.elementSelector : dependencyModule.config.name
                            ));
                            return;
                        }

                        promiseDependencies.push(initModule(dependencyModule, lineage, true));
                    });

                    if(_.size(promiseDependencies)) {
                        promise = $.when.apply($, promiseDependencies)
                            .then(function () {
                                var promiseInit = module.init(fpUtil.getStateValue(fp.loaded, true, autoRender))
                                    .catch(function(error) {
                                        if(error instanceof Error && !error.__metaData) {
                                            error.__metaData = {
                                                'Module Name': module.config.name,
                                                'Module Selector': S.getString(module.config.elementSelector).substr(0, 500),
                                                'Module Layout': module.config.layout
                                            }
                                        }
                                    });

                                return promiseInit;
                            });

                        hashedPromises[promiseKey] = promise;
                        return promise;
                    }
                }

                promise = module.init(fpUtil.getStateValue(fp.loaded, true, autoRender))
                    .catch(function(error) {
                        if(error instanceof Error && !error.__metaData) {
                            error.__metaData = {
                                'Module Name': module.config.name,
                                'Module Selector': S.getString(module.config.elementSelector).substr(0, 500),
                                'Module Layout': module.config.layout
                            }
                        }
                    });

                hashedPromises[promiseKey] = promise;

                return promise;
            }

            // if(fpUtil.getBoolean($module.attr('data-freshop-processed'))) return;
            // $module.attr('data-freshop-processed', true);

            var nonMajorModules = [],
                hasViewModule = false,
                // hashedModule,
                // moduleKey,
                promise,
                module;

            //use for loop as initModule may sort
            for(var n=0;n<modules.length;n++) {
                module = modules[n];
                if (!module.enabled || module.processed) continue;
                // if(!fp.loaded && module.initialized) continue;
                // if($parent && !$parent.closest(module.config.elementSelector)) {
                //     continue;
                // }
                //if(module.$element) {
                //    fp.log('module', module.$element[0]);
                //}

                module.processed = true;
                
                if(module.config.priority <= fpConstants.priority.MAJOR) {
                    promise = initModule(module);
                    if(!fpConfig.disableMajorModuleDelay && module.config.disableShowProgress) {
                        disableProgressPromises.push(promise);
                    }
                    else {
                        if(!hasViewModule) hasViewModule = module.config.isView || (module instanceof fp.Module.View);
                        promises.push(promise);
                    }
                }
                else nonMajorModules.push(module);
            }

            var promiseInitModules = $.when.apply($, promises);

            if(nonMajorModules.length) {
                promiseInitModules = $.when(!fp.loaded && hasViewModule ? fpUtil.getPromiseFromEvent(fp.events.VIEW_MODULE_RENDERED) : undefined)
                    .then(function() {
                        _.each(nonMajorModules, function(module) {
                            promise = initModule(module);
                            disableProgressPromises.push(promise);
                        });

                        return {
                            disableProgressPromise: $.when.apply($, disableProgressPromises)
                        }
                    });
            }

            return promiseInitModules;
        }
        ,setModuleContent: function ($element, html) {
            var $loading = $element.filter('.fp-animated-loading-container').find('> .fp-loading');
            if(!$loading.length) $loading = $element.closest('.fp-animated-loading-container > .fp-loading');
            $element.html(html).append($loading);
        }
        ,getPageTitle: function(title) {
            if(title) title = S(title).stripTags().s;
            else {
                //only utilize child state titles
                var state = this.router.stateManager.current;
                if(state.parent && !state.parent.abstract) title = _.result(state.data, 'title', '');
            }
            return title;
        }
        ,setPageTitle: function(title) {
            if(!this.router.stateManager.current.enableSEO) {
                //fp.log('setPageTitle', title);

                if (!fp.__initialPageTitle) fp.__initialPageTitle = window.document.title;
                title = this.getPageTitle(title);

                //fp.log('setPageTitle 2', title);

                var titleFormat = fpConfig.siteTitleFormat,
                    category = S.getString(this.getActiveCategory().name);
                if (category) {
                    titleFormat = title ? titleFormat.replace('{siteTitle}', fpConfig.siteTitleCategoryFormat) : fpConfig.siteTitleCategoryFormat;
                }

                if (title) {
                    title = titleFormat
                        .replace('{title}', title)
                        .replace('{category}', category)
                        .replace('{siteTitle}', fpConfig.siteTitle);
                }

                window.document.title = fpUtil.decodeForHtml(title || fp.__initialPageTitle);
            }

            if(fpConfig.enableSearchResultsTitle) {
                var stateParams = this.router.stateManager.toParams,
                    searchTerm = '';
                
                if(stateParams) {
                    if(stateParams.q && this.router.stateManager.is(fpConfig.routeStates.product)) {
                        searchTerm = stateParams.q;
                    }

                    if(stateParams.recipe_q && this.router.stateManager.is(fpConfig.routeStates.recipe)) {
                        searchTerm = stateParams.recipe_q;
                    }

                    if(searchTerm.length > 0 && title) window.document.title = 'Search Results: ' + searchTerm + ' | ' + title;
                } 
            }
        }
        ,setMetaDescription: function(value) {
            if(!this.router.stateManager.current.enableSEO) {
                //fp.log('setMetaDescription', value);

                var $meta = $('head meta'),
                    $metaDescription = $meta.filter('[name="description"]').first(),
                    storedValue = S.getString($metaDescription.prop('content'));

                if (storedValue) {
                    if ($metaDescription.length && !fpUtil.isDefined($metaDescription.data('storedValue'))) {
                        $metaDescription.data('storedValue', storedValue);
                    }

                    //only allow child state meta description
                    var state = this.router.stateManager.current;
                    if (state.parent && state.parent.abstract) value = $metaDescription.data('storedValue');
                }

                if (!value) value = storedValue;
                if (value) {
                    if (!$metaDescription.length) {
                        $metaDescription = $('<meta name="description" />').insertAfter($meta.last());
                    }

                    $metaDescription.prop('content', value);
                }
            }
        }
        ,cacheTemplate: function(id, template, disableNotify) {
            if(!id || !template) return '';
            var key = id.replace(fpUtil.regExp.matchSlash, '-');

            //there is currently a valid reason for a template that already exists as templates
            //can be loaded from a module and a module can be loading more than once
            //if(!disableNotify && _.has(fp.cache.template, key)) {
            //    fp.notifier.notify({
            //        name: 'TemplateError',
            //        message: fpUtil.formatString('TemplateError: Template {0} already exists.', id)
            //    }, {
            //        severity: 'error'
            //    });
            //}
            fp.cache.template[key] = template;

            return key;
        }
        ,getTemplate: function(id, disableNotify) {
            if(!_.isString(id)) return id;

            var key = id.replace(fpUtil.regExp.matchSlash, '-');

            if(!disableNotify && !_.has(fp.cache.template, key)) {
                fp.notifier.notify({
                    name: 'TemplateError',
                    message: fpUtil.formatString('TemplateError: Template {0} not found.', id)
                }, {
                    severity: 'error'
                });
            }

            var template = fp.cache.template[key];
            if(_.isString(template)) {
                template = fp.cache.template[key] = _.template(template);
                template.__id = id;
                if(!fp.isProd()) template.__comment = this.getComment(id);
            }

            return template;
        }
        ,renderTemplate: function(id, scope, handleError, disableComment) {
            var matchHtml = fpUtil.regExp.matchHtml,
                template,
                comment;

            matchHtml.lastIndex = 0;

            if(_.isString(id) && matchHtml.test(id)) template = _.template;
            else {
                template = this.getTemplate(id);
                comment = !disableComment && template && template.__comment;
            }

            if (_.isFunction(template)) {
                scope = _.getObject(scope);
                if (scope.__type != 'fpScope') {
                    scope = $.extend(scope, fp.defaultScope);
                }
                
                try {
                    if (template == _.template) template = _.template(id);
                    template = template(scope);
                }
                catch (exc) {
                    if(fpUtil.getBoolean(handleError, true)) {
                        fp.notifier.notify(exc, {
                            severity: 'error',
                            metaData: {
                                'meta data': {
                                    Template: S.getString(template && template.__id || id).substr(0, 500)
                                }
                            }
                        });
                    }
                    else throw exc;
                }
            }

            if(comment) template = comment + template;

            return template;
        }
        ,renderAttrs: function(attrs, template, keys) {
            if(!template) template = ' {0}="{1}"';
            var returnValue = '';
            if(_.isArray(keys)) keys = _.indexBy(keys);
            _.each(_.isObject(attrs) && attrs, function(value, key) {
                if((!keys || _.has(keys, key)) && !_.isObject(value)) {
                    returnValue += fpUtil.formatString(template, S(key).dasherize('-').s, value);
                }
            });
            return S(returnValue).trim().s;
        }
        ,getComment: function(value) {
            if(fpUi.router.routeManager.urlParams.enable_comments != 'true') return '';
            return fpUtil.formatString('<!-- [{0}] -->\n', fpUtil.getAttrs(value));
        }
        ,getComponentCacheKey: function(componentKey, layout, type) {
            if(!componentKey) return '';

            var regExp = fpUtil.regExp.matchNonAlphanumeric;
            regExp.lastIndex = 0;

            var name = S(componentKey).replace(regExp, '-').dasherize('-').s;
            layout = (layout || 'layout-0').replace('layout-', '').replace('-', '/');
            type = type || 'component';

            return type + '/' + layout + '/' + name + '.html';
        }
        ,getComponentTemplate: function(layout, obj, options) {
            var cacheKey = layout || 'layout-0';

            if(S(cacheKey).startsWith('layout-')) {
                options = _.getObject(options);
                cacheKey = this.getComponentCacheKey(options.componentKey, layout, options.type);
            }

            return this.getTemplate(cacheKey, obj);
        }
        ,renderComponentTemplate: function(layout, obj, options) {
            var template = this.getComponentTemplate(layout, obj, options);

            if(_.isFunction(template)) {
                obj = $.extend(obj, fp.defaultScope);
                template = template(obj);
            }

            return S.getString(template);
        }
        //getTabIndex is deprecated and should not be used
        ,getTabIndex: function(startTabIndex) {
            var tabIndex = nextTabIndex;

            //if non-undefined value is passed, used passed in value to set tabIndex and nextTabIndex
            if(fpUtil.isDefined(startTabIndex)) tabIndex = fpUtil.getInteger(startTabIndex, 1);

            nextTabIndex += 1;

            return tabIndex;
        }
        ,getNavigation: function(storeId) {
            // fp.log('getNavigation', storeId);
            // if(fpUi.router.routeManager.urlParams.disable_nav === 'true') {
            //     return $.Deferred().resolve({shop: {children: []}, recipe: {children: []}}).promise();
            // }

            const routeManager = fpUi.router.routeManager;
            let shoppingUrlPath = fpUi.getSiteUrls().shopping_url_path,
                promiseDependencies,
                nav;

            if(storeId && fp.store.id != storeId) {
                let store;
                promiseDependencies = $.when(
                        fpService.storeService
                            .get({
                                id: storeId,
                                fields: 'name,lineage'
                            }, {formatForRestfulId: true})
                            .then(function(resp) {
                                store = resp;
                            }),
                        fpUi.initSiteUrls(storeId)
                    )
                    .then(function () {
                        if(store) shoppingUrlPath = fpUi.getSiteUrls(store).shopping_url_path;
                    });
            }
            else if(!fp.loaded) {
                if(!fp.__promiseStoreDependencies) fp.__promiseStoreDependencies = $.Deferred().promise();
            }

            return $.when(
                fp.__promiseLoadStoreDependencies,
                promiseDependencies
            )
            .then(function() {
                const stateManager = fpUi.router.stateManager,
                    stateParams = {},
                    generateMenu = function(items, options, stateParams) {
                        if(!_.size(items)) return;

                        const topItem = items[0],
                            menuHash = {},
                            isProd = fp.isProd(),
                            generateMenuItem = function(item) {
                                if(options.type === 'product' && item.id !== topItem.id && _.first(item.lineage) !== topItem.id) {
                                    // fp.log(topItem, item);
                                    return;
                                }

                                const menuItem = {
                                    id: item.id,
                                    sequence: fpUtil.getInteger(item.sequence),
                                    title: S.getString(item.name)
                                };

                                if (item.active) menuItem.active = true;

                                if (fpUtil.getInteger(item.parent_id) >= 0) {
                                    menuItem.parent_id = item.parent_id;
                                    if(isProd && item.canonical_url) {
                                        menuItem.url = routeManager.relativeUrl(item.canonical_url);
                                    }
                                    else {
                                        menuItem.url = stateManager.categoryHref(item, options, stateParams);
                                    }
                                }

                                menuHash[item.id] = menuItem;
                            },
                            generateMenuChildren = function(item) {
                                if (!_.size(item.items)) return;

                                const menuItem = menuHash[item.id];
                                if(menuItem) {
                                    const children = [];
                                    menuItem.children = children;
                                    _.each(item.items, function (child) {
                                        const menuChild = menuHash[child.id];
                                        if(menuChild) children.push(menuChild);
                                    });
                                }
                            };

                        //only generate one level of menu categories for mobile
                        if(fpConfig.enableMobile) {
                            generateMenuItem(topItem);
                            _.each(topItem.items, generateMenuItem);
                            generateMenuChildren(topItem);
                        }
                        else {
                            _.each(items, generateMenuItem);
                            _.each(items, generateMenuChildren);
                        }

                        return menuHash[topItem.id].children;
                    };

                    let promiseProductCategories,
                        promiseRecipeCategories;

                nav = _.getObject(getNavigation(stateManager.root).children);
                //fp.logStack('nav.shop');
                //fp.log( nav.shop);

                if(_.isObject(nav.shop)) {
                    //if(fp.isLocal() && window.testNavigation) {
                    //    debugger;
                    //}

                    const options = {
                        type: 'product',
                        relative: false,
                        js_navigation_path: S(shoppingUrlPath || nav.shop.url).trimRight(fp.routeDelimiter + '/').s,
                        enableTemplate: true
                    };

                    if(shoppingUrlPath) nav.shop.url = stateManager.categoryHref(null, options, stateParams);

                    if((!storeId || fp.store.id == storeId) && _.size(fp.departments)) {
                        promiseProductCategories = $.Deferred()
                            .resolve({
                                categories: fp.departments
                            })
                            .promise();
                    }
                    else {
                        promiseProductCategories = fpUi.getCategories(storeId);
                    }

                    promiseProductCategories
                        .done(function(data) {
                            // var startDate = new Date();

                            var children = generateMenu(data.categories, options, stateParams);
                            if(_.size(children)) nav.shop.children = children;

                            // var duration = (new Date()).getTime() - startDate.getTime();
                            // fp.warn('generateMenu product categories duration (ms)', duration);
                        });
                }

                if(!fpConfig.enableMobile && _.isObject(nav.recipe)) {
                    promiseRecipeCategories = fpUi.getCategories(storeId, 'recipe')
                        .done(function(data) {
                            // var startDate = new Date();

                            var children = generateMenu(data.categories, {
                                type: 'recipe',
                                relative: false,
                                enableTemplate: true
                            }, stateParams);
                            if(_.size(children)) nav.recipe.children = children;

                            // var duration = (new Date()).getTime() - startDate.getTime();
                            // fp.warn('generateMenu recipe categories duration (ms)', duration);
                        });
                }

                return $.when(
                    promiseProductCategories,
                    promiseRecipeCategories
                );
            })
            .then(function() {
                return nav;
            });
        }
        ,getFulfillmentSlotDateTimeLabel: function(slot, options) {
            var value = {
                date: null,
                label: '',
                dateLabel: '',
                timeLabel: '',
                hasEndTime: false
            };

            options = _.defaults(options, {
                dateFormat: fpConfig.fulfillmentDateFormat,
                timeFormat: fpConfig.fulfillmentTimeFormat,
                dateTimeDelimiter: fpConfig.fulfillmentDateTimeDelimiter,
                dateTimeHasEndTimeDelimiter: fpConfig.fulfillmentDateTimeHasEndTimeDelimiter
            });

            if(_.isObject(slot)) {
                var slotTimeArray = S.getString(slot.slot_start).split(' '),
                    slotStart = slotTimeArray.length > 1 ? slotTimeArray[1] : S.getString(slotTimeArray[0]),
                    isShortTime = false,
                    fulfillmentType = _.getObject(slot.fulfillmentType),
                    timeZone = (options.store || fp.store).timezone;

                if(S(options.timeFormat).endsWith('a-')) {
                    isShortTime = true;
                    options.timeFormat = options.timeFormat.substr(0, options.timeFormat.length-1);
                }

                value.date = dateFns.parse(slot.date + ' ' + slotStart);
                // value.localDate = timeZone ? dateFns.toDate(slot.date + 'T' + slotStart, {timeZone: timeZone}) : value.date;
                try {
                    value.localDate = (timeZone && dateFns.tz) ? dateFns.tz.toDate(slot.date + 'T' + slotStart, {timeZone: timeZone}) : value.date;
                }
                catch(exc){
                    // fp.notifier.notify(exc, {disableThrowError: fp.isLocal()});
                    fp.logError(exc.message);
                    value.localDate = value.date;
                }

                if(dateFns.isValid(value.date)) {
                    value.timeLabel = dateFns.format2(value.date, options.timeFormat);
                    if (isShortTime) value.timeLabel = S(value.timeLabel).trimRight('m').s;

                    value.dateLabel = dateFns.format2(value.date, options.dateFormat);
                }

                var dateTimeDelimiter = options.dateTimeDelimiter,
                    fulfillmentTypeMap = fpUtil.map.get('fulfillmentType'),
                    hasEndTime = (
                        slot.fulfillment_type_id == fulfillmentTypeMap.get('delivery').id
                        || fulfillmentType.identifier == 'delivery'
                        || slot.fulfillment_type_id == fulfillmentTypeMap.get('drop_off').id
                        || fulfillmentType.identifier == 'drop_off'
                        || (fpConfig.pickUpHasEndTime && (fulfillmentType.identifier == 'pickup' || slot.fulfillment_type_id == fulfillmentTypeMap.get('pickup').id))
                    );

                if (hasEndTime && !options.enableStartTimeOnly) {
                    value.hasEndTime = hasEndTime;
                    dateTimeDelimiter = options.dateTimeHasEndTimeDelimiter;
                    slotTimeArray = S.getString(slot.slot_end).split(' ');

                    var slotEnd = slotTimeArray.length > 1 ? slotTimeArray[1] : S.getString(slotTimeArray[0]),
                        time = dateFns.parse(slot.date + ' ' + slotEnd);

                    if(dateFns.isValid(time)) {
                        time = dateFns.format2(time, options.timeFormat);

                        if (isShortTime) time = S(time).trimRight('m').s;
                        value.timeLabel += '-' + time;
                    }
                }

                if(dateFns.isValid(value.date)) {
                    value.label = value.dateLabel + dateTimeDelimiter + value.timeLabel;
                }

                if(slot.fulfillment_type_id == fulfillmentTypeMap.get('drop_ship').id || fulfillmentType.identifier == 'drop_ship') value.label = value.dateLabel;
            }

            return value;
        }
        ,getSlotOrderByHtml: function(slot, enableBeyondToday) {
            var orderByHtml = '';
            if(slot && slot.booking_close_minutes_prior && slot.dateTimeLabel) {
                var slotCloseDate = dateFns.subMinutes(slot.dateTimeLabel.localDate, slot.booking_close_minutes_prior),
                    now = new Date();

                // fp.log('date', slot.dateTimeLabel.date, 'booking_close_minutes_prior', slot.booking_close_minutes_prior, 'slotCloseDate', slotCloseDate);
                if(slotCloseDate >= now) {
                    if(dateFns.isToday(slotCloseDate)) {
                        if(dateFns.differenceInHours(slotCloseDate, now)) {
                            orderByHtml = fpUi.localef('shared-order-by', '<span class="font-italic">Order by</span> {0}', dateFns.format2(slotCloseDate, fpConfig.fulfillmentTimeFormat));
                        }
                        else {
                            var seconds = dateFns.differenceInSeconds(slotCloseDate, now);
                            orderByHtml = fpUi.localef('shared-order-within', '<span class="font-italic">Order within</span> {0} min {1} sec', Math.floor(seconds / 60), seconds % 60);
                        }
                    }
                    else if(enableBeyondToday) {
                        orderByHtml = fpUi.localef('shared-order-by', '<span class="font-italic">Order by</span> {0}', dateFns.format2(slotCloseDate, fpConfig.fulfillmentShortDateFormat));
                    }
                }
            }
            return orderByHtml;
        }
        ,showModal: function(options) {
            options = $.extend({
                template: 'component/0/modal.html',
                animatedLoadingContainerClass: 'fp-animated-loading-container'
            }, options);

            options.name = fpUtil.formatString('fp-modal-{0}', options.name || _.uniqueId());

            var $modal = fp.__$freshop.find(fpUtil.formatString('[data-role="modal-container"] [data-role="{0}"]', options.name)),
                content = _.result(options, 'content'),
                isPromise = fpUtil.isPromise(content),
                disableFade = options.disableFade,
                bsModal;

            if(isPromise) {
                options.content = fpUi.renderTemplate('component/0/animated-loading.html', null, null, true);
            }

            options.modal = _.defaults(options.modal, {
                persist: false,
                backdrop: fpUtil.getStateValue(options.disableClose, 'static'),
                keyboard: !options.disableClose
            });

            if($modal.length) {
                if(fpUtil.isNull(disableFade)) {
                    disableFade = !$modal.hasClass('fade');
                }

                bsModal = $modal.data('bs.modal');

                if(options.content) {
                    $modal.find('[data-role="title"]')
                        .html(options.title);

                    $modal.find('[data-role="modal-content"]')
                        .empty()
                        .append(options.content)
                        .toggleClass(options.animatedLoadingContainerClass, isPromise);
                }
                else if(options.template) {
                    let template = options.template;
                    if (_.isString(template)) {
                        fpUtil.regExp.matchHtml.lastIndex = 0;
                        if(!fpUtil.regExp.matchHtml.test(template)) {
                            template = this.renderTemplate(template, options, null, true);
                        }
                    }

                    $modal
                        .empty()
                        .append($(template).find('.modal-dialog'));
                }
            }
            else {
                if(!options.disableToggleActiveModal) {
                    $activeModal = fp.__$freshop.find(
                        fpUtil.formatString('[data-role="modal-container"] .modal[data-aria-hidden="false"]:not([data-role="{0}"])', options.name)
                    );

                    if ($activeModal.length) {
                        $activeModal.hide().prev('.modal-backdrop').hide();
                        disableFade = true;

                        fpUi.__activeModals = _.getArray(fpUi.__activeModals);
                        fpUi.__activeModals.push($activeModal);
                    }
                }

                var template = options.template;
                if (_.isString(template)) {
                    fpUtil.regExp.matchHtml.lastIndex = 0;
                    if(!fpUtil.regExp.matchHtml.test(template)) {
                        template = this.renderTemplate(template, options, null, true);
                    }
                }

                $modal = $(template);

                if(fpUtil.isNull(disableFade)) {
                    disableFade = !$modal.hasClass('fade');
                }

                if (isPromise) {
                    $modal
                        .one('show.bs.modal', function () {
                            if(content.state() != 'pending') return;

                            $modal.find('[data-role="modal-content"]')
                                .addClass(options.animatedLoadingContainerClass);
                        });
                }

                const hasActiveModals = _.size(fpUi.__activeModals) > 0;
                $modal
                    .one('hide.bs.modal.activeModal', function () {
                        if(hasActiveModals) {
                            fpUi.__activeModals.pop().show().prev('.modal-backdrop').show();
                        }
                        if($modal.has(document.activeElement).length) {
                            $(document.activeElement).trigger('blur');
                        }
                    })
                    .one('hidden.bs.modal.activeModal', function () {
                        fp.trigger(fp.events.MODAL_HIDDEN, $modal[0]);
                    });
            }

            if(options.disableClose) $modal.find('.modal-header [data-dismiss="modal"]').addClass('invisible');

            if (isPromise) {
                options.content = content
                    .done(function (data) {
                        var module;
                        if(data instanceof fp.Module) {
                            module = data;
                            data = data.$element;
                        }

                        var $modalContent = $modal.find('[data-role="modal-content"]').removeClass(options.animatedLoadingContainerClass),
                            $bodyContent = $modalContent.find('[data-role="body-content"]');
                        if(!$bodyContent.length) $bodyContent = $modalContent;

                        $modalContent.find('[data-role="animated-loading"]').remove();
                        $modalContent.find('.fp-form-shop-intent').removeClass('hidden');

                        $bodyContent
                            .empty()
                            .append(data);

                        if(module && !module.rendered) module.render();

                        var bsModal = $modal.data('bs.modal');
                        if(bsModal && bsModal.isShown) bsModal.focus();
                    });
            }

            $modal.toggleClass('fade', !disableFade);

            //use defer to allow caller to bind show event
            $modal.appendTo(options.modal?.container || fp.__$freshop.find('[data-role="modal-container"]'));
            _.defer(function() {
                if(!bsModal) $modal.modal(options.modal);
                else if(!bsModal.isShown) $modal.modal('show');
            });

            $modal.data('modalOptions', options);

            if(fpConfig.enableMobile) {
                var $modalDialog = $modal.find('> .modal-dialog').removeClass('modal-sm modal-md modal-lg modal-xl');
                if(options.size) $modalDialog.replaceClass('modal-dialog', 'modal-dialog modal-' + options.size);
                if(options.center) $modalDialog.addClass('modal-dialog-centered');
            }
            else {
                $modal.removeClass('modal-sm modal-md modal-lg');
                if(options.size) $modal.replaceClass('modal', 'modal modal-' + options.size);
            }


            return $modal;
        }
        ,hideModal: function(selector, disableFade) {
            var $modal = $(selector);
            if(!$modal.length) return $modal;

            var modal = _.getObject($modal.data('bs.modal'));
            if(!modal.isShown) return $modal;

            disableFade = _.isUndefined(disableFade) ? _.getObject($modal.data('modalOptions')).disableFade : disableFade;
            if(disableFade) $modal.removeClass('fade');

            $modal.modal('hide');
            $modal.addClass('fade');

            return $modal;
        }
        ,getActiveModal: function() {
            return fp.__$freshop.find('[data-role="modal-container"] .modal[data-aria-hidden="false"]');
        }
        ,closeActiveModal: function(disableFade) {
            return this.hideModal(this.getActiveModal(), disableFade);
        }
        ,updateModalSize: function($modal, oldSize, newSize) {
            $modal = $($modal);

            if(fpConfig.enableMobile) $modal = $modal.find('> .modal-dialog');
            $modal.replaceClass('modal-' + oldSize, 'modal-' + newSize);
        }
        ,showShopIntentModal: function(options) {
            if(!_.isObject(options)) {
                options = {
                    force: arguments[0],
                    fulfillmentIdentifier: arguments[1],
                    next: arguments[2]
                };
            }

            var force = options.force,
                fulfillmentIdentifier = options.fulfillmentIdentifier,
                next = options.next,
                stateManager = this.router.stateManager,
                shopIntentConfig = fpConfig.shopIntent,
                fulfillmentTypes = fpUtil.map.get('fulfillmentType').items(),
                enabled = shopIntentConfig.enabled;

            if(fpUtil.isNull(fulfillmentIdentifier) && shopIntentConfig.action) {
                fulfillmentIdentifier = shopIntentConfig.action;
            }
            if(stateManager.stateParams.modal == 'shop_intent') {
                if(fpUtil.isNull(force)) force = true;
                if(fpUtil.isNull(fulfillmentIdentifier)) {
                    fulfillmentIdentifier = stateManager.stateParams.modal_action;
                }
            }

            if(!force && enabled && shopIntentConfig.enableTestersOnly) {
                enabled = fpUtil.hasRole(fp.constants.adminRole.TESTER);
            }

            if(
                !force && (
                    !enabled ||
                    fp.store.id ||
                    !fulfillmentTypes.length
                )
            ) {
                return $.when();
            }

            if(fp.__shopIntentPromise) return fp.__shopIntentPromise;
            if(fp.__$shopIntentModal) return $.when();

            var ageGateFulfillmentIdentifier = fulfillmentIdentifier,
                enableAgeGate = shopIntentConfig.enableAgeGate ? !fpUtil.getBoolean(fp.getSessionCookie().ageGate) : false;
            if(enableAgeGate) fulfillmentIdentifier = null;

            var items = [],
                filteredFulfillmentTypes = [],
                enabledFulfillmentTypes = _.size(shopIntentConfig.fulfillmentTypes) && _.indexBy(shopIntentConfig.fulfillmentTypes),
                fulfillmentType;

            fp.__shopIntentPromise = $.Deferred().promise();

            //don't show fulfillment types if age gate is enabled/displayed and store is selected
            if(!options.disableFulfillment) {
                if (/*!force && */!shopIntentConfig.disablePlanShopping) {
                    items.push({
                        identifier: 'plan',
                        name: fpUi.locale('shopper-intent-plan-shopping-name', 'Plan'),
                        title: fpUi.locale('shopper-intent-plan-shopping-title', 'Plan your shopping')
                    });
                }

                _.each(fulfillmentTypes, function (item) {
                    if (!enabledFulfillmentTypes || _.has(enabledFulfillmentTypes, item.identifier)) {
                        items.push($.extend(_.pick(item, 'id', 'identifier', 'name'), {
                            title: _.getObject(shopIntentConfig[item.identifier]).fulfillmentLabel || fpUi.localef('shopper-intent-fulfillment-action-label', 'Place a {0} order', S(item.name).toLowerCase())
                        }));

                        filteredFulfillmentTypes.push(item);
                    }
                });
            }

            function loadStoreLocator(fulfillmentIdentifier) {
                var fulfillmentConfig = _.getObject(shopIntentConfig[fulfillmentIdentifier]),
                    enableApiAddressSearch = _.contains(['delivery', 'drop_ship'], fulfillmentIdentifier),
                    searchInstructions,
                    searchType;

                if(enableApiAddressSearch) {
                    searchInstructions = fpUi.locale('shopper-intent-full-address-search-instructions', 'Please enter your full address with zip code.');
                    searchType = fulfillmentConfig.searchType;
                }

                var moduleConfig = $.extend(true, {
                        name: 'store-locator',
                        intent: 'modal',
                        enableApiAddressSearch: enableApiAddressSearch,
                        addressSearchKey: fulfillmentConfig.addressSearchKey,
                        disableHasAddress: fulfillmentConfig.disableHasAddress,
                        disableLocationServices: enableApiAddressSearch,
                        enableSearchAllFulfillmentTypes: shopIntentConfig.enableSearchAllFulfillmentTypes,
                        searchPlaceHolder: searchInstructions,
                        searchInstructions:  fulfillmentConfig.storeLocatorSearchInstructions,
                        searchType: searchType,
                        onSearch: function(items) {
                            if(fulfillmentIdentifier != 'delivery') return;
                            if(!_.size(items)) return;

                            if(_.size(items) == 1) {
                                title = fpUi.localef('shopper-intent-delivery-search-success-single', 'Great news! We deliver to your address from our {0} store.', items[0].name);
                            }
                            else {
                                title = fpUi.locale('shopper-intent-delivery-search-success-multiple', 'Great news! We deliver to your address. Click "Continue" to start shopping.');
                            }

                            $modal.find('[data-role="title"]')
                                .text(title);

                            //var $fulfillment = $modalContent.find('[data-role="fulfillment"]').empty();
                            //if(!$fulfillment.length) {
                            //    $fulfillment = $('<div data-role="fulfillment"></div>')
                            //        .prependTo($modalContent);
                            //}
                            //
                            //$fulfillment
                            //    .toggleClass('hidden', !_.size(items))
                            //    .toggleClass('hidden', !_.size(items))
                            //    .html(fpUi.renderTemplate('component/0/shop-intent-modal-fulfillment.html', {items: items}));
                        }
                    }, fpConfig.modules.storeLocator);

                if(next) {
                    moduleConfig.next = next;
                    moduleConfig.searchAgain = 'Please try a different search.';
                    moduleConfig.disableLocationServices = true;
                }

                if(fulfillmentConfig.disallowedRedirect && _.size(fulfillmentConfig.disallowedPostalCodes)) {
                    moduleConfig.onBeforeSearch = function (params) {
                        var postalCode = S(params.q).trim();
                        if(_.find(fulfillmentConfig.disallowedPostalCodes, function(value) {
                            return postalCode.startsWith(value);
                        })) {
                            window.location.href = fulfillmentConfig.disallowedRedirect;
                            return $.Deferred().promise();
                        }
                    };
                }

                moduleConfig.elementSelector = $('<div data-role="store-locator"></div>').appendTo(fp.__$freshop);
                moduleConfig.enableResponsiveContainer = true;

                return fpUi.loadModule(moduleConfig)
                    .then(function (module) {
                        module.scope.hashedSelectedServices[fpUtil.formatString('has_{0}', fulfillmentIdentifier)] = true;
                        module.scope.fulfillmentTypes = filteredFulfillmentTypes;
                        module.scope.fulfillmentType = fulfillmentType;

                        return module.init(false)
                            .then(function() {
                                return module;
                            });
                    });
            }

            var attrs = {};
            if(fp.loaded) attrs.rendered = true;
            else attrs.initialized = true;

            var modalOptions = {
                name: 'shop-intent-modal',
                template: shopIntentConfig.template || 'component/0/shop-intent-modal.html',
                title: fpUi.localef('shopper-intent-title', 'Welcome to {0}', fpConfig.siteTitle),
                subTitle: enableAgeGate && !_.size(items) ? shopIntentConfig.ageGateModalSubTitle : shopIntentConfig.modalSubTitle || fpUi.locale('shopper-intent-sub-title', 'What would you like to do?'),
                actionTitle: shopIntentConfig.modalActionTitle,
                className: 'fp-shop-intent-modal' + (next ? ' fp-shop-intent-see-price' : ''),
                size: 'md',
                contentImg: shopIntentConfig.contentImg,
                contentImgTest: shopIntentConfig.contentImgTest,
                enableAgeGate: enableAgeGate,
                ageGateSubtitle: shopIntentConfig.ageGateSubtitle,
                disableClose: shopIntentConfig.disableClose || enableAgeGate,
                disableFulfillment: shopIntentConfig.disableFulfillment,
                buttonBorderRadius: shopIntentConfig.buttonBorderRadius || 4,
                items: items
            };

            if(fulfillmentIdentifier) {
                fulfillmentType = _.getObject(_.findWhere(items, {identifier: fulfillmentIdentifier}));
                fpUi.setFulfillmentType(fulfillmentType.identifier, true);

                var fulfillmentConfig = _.getObject(shopIntentConfig[fulfillmentIdentifier]);

                if(_.contains(['delivery', 'drop_ship'], fulfillmentIdentifier)) {
                    modalOptions.title = S.getString(fulfillmentConfig.searchInstructions, fpUi.locale('shopper-intent-search-instructions', 'Enter Your Address'));
                }
                else modalOptions.title = fulfillmentConfig.title || fpUi.localef('shopper-intent-select-store-title', 'Select your {0} store', fulfillmentType.name);

                // modalOptions.className = 'modal-fullwidth-md-down ' + modalOptions.className;
                modalOptions.size = fpConfig.enableMobile ? 'vw' : 'lg';
                modalOptions.content = loadStoreLocator(fulfillmentIdentifier);
            }

            var $modal = fp.__$shopIntentModal = fpUi.showModal(modalOptions),
                proxyStoreAfterChange = function() {
                    if(!fp.store.id) return;

                    var promise;
                    if(!fp.loaded) promise = fpUi.loadStoreDependencies(true);
                    $.when(promise)
                        .done(function() {
                            fpUi.hideModal($modal);
                        })
                },
                defaultModalContent;

            $modal
                .on('show.bs.modal.shopIntent', function() {
                    fp.on(fp.events.STORE_AFTER_CHANGE, proxyStoreAfterChange);

                    var $modalContent = $modal.find('[data-role="modal-content"]');
                    defaultModalContent = $modalContent.html();

                    if(!fulfillmentIdentifier) {
                        $modalContent.children().removeClass('hidden');
                    }

                    if(fpConfig.enableMobile) $modal.find('> .modal-dialog').addClass('modal-vw-sm-down');

                    //if(fp.isLocal()) {
                    //    $modal.find('[data-role="modal-content"] a[data-action="delivery"]').trigger('click');
                    //}
                })
                .on('shown.bs.modal.shopIntent', function() {
                    if(fulfillmentIdentifier) {
                        var promise = fpUtil.isPromise(modalOptions.content) ? modalOptions.content : undefined;
                        $.when(promise)
                            .done(function () {
                                $modal.find('[data-role="prev"]').removeClass('invisible');
                            });
                    }

                    fp.setSessionCookie({shopIntentModalLastViewedAt: (new Date()).getTime()});
                })
                .on('hidden.bs.modal.shopIntent', function() {
                    if(stateManager.stateParams.modal == 'shop_intent') {
                        stateManager.go(stateManager.current, {modal: null, modal_action: null}, {preventDefault: true, inherit: true});
                    }

                    if(next) {
                        if(fulfillmentIdentifier == 'store-locator') fpUi.closeActiveModal();
                        else if (fp.store && fp.store.id) fp.ui.router.stateManager.go(next, null, {absolute: true, reload: true});
                    }

                    fp.off(fp.events.STORE_AFTER_CHANGE, proxyStoreAfterChange);

                    delete fp.__$shopIntentModal;

                    fp.__shopIntentPromise.deferred().resolve();
                    delete fp.__shopIntentPromise;

                    var attrs = {};
                    if(fp.loaded) attrs.rendered = true;
                    else attrs.initialized = true;

                    var viewModule = fp.Module.getViewModule({attrs: attrs}),
                        requireStore = viewModule && viewModule.config.requireStore;

                    if(_.isObject(requireStore) && !requireStore.disabled && requireStore.enableRedirect) {
                        fpUtil.ensureStore(requireStore);
                    }

                    if(fulfillmentIdentifier == 'store-locator') return;

                    var storeFulfillmentTypes = fpUtil.map.get('storeFulfillmentType'),
                        fulfillmentTypeId = fpUi.getPreference('fulfillmentTypeId');
                    fulfillmentType = storeFulfillmentTypes.get(fulfillmentType && fulfillmentType.identifier);

                    if(!fulfillmentType.id) fulfillmentType = storeFulfillmentTypes.get(fulfillmentTypeId);
                    if(S(fulfillmentType.id).ne(fulfillmentTypeId)) {
                        fpUi.setFulfillmentType(fulfillmentType.identifier, true);
                    }
                })
                .on('click.modal.prev', '[data-role="prev"]', function(event) {
                    event.preventDefault();

                    $(this).addClass('invisible');
                    // $modal.replaceClass('modal-fullwidth-md-down', 'modal-fullwidth-sm-down');
                    fpUi.updateModalSize($modal, fpConfig.enableMobile ? 'vw' : 'lg', 'md');

                    const module = $modal.find('.fp-modal-content .fp-module:first').data('fp.ui.Component');
                    if(module instanceof fp.Module) module.destroy();

                    $modal.find('[data-role="title"]').text(fpUtil.formatString('Welcome to {0}', fpConfig.siteTitle));
                    const $modalContent = $modal.find('[data-role="modal-content"]')
                        .html(defaultModalContent)
                        .removeClass(modalOptions.animatedLoadingContainerClass);

                    $modalContent.find('[data-role="animated-loading"]').remove();
                    $modalContent.children().removeClass('hidden');
                    if(shopIntentConfig.enableAgeGate) {
                        $modalContent.find('[data-role="age-gate"]').toggleClass('hidden', fpUtil.getBoolean(fp.getSessionCookie().ageGate));
                        $modalContent.find('[data-action^="change-"]').prop('disabled', false);
                    }
                })
                .on('click.modal.shopIntent', '[data-role="modal-content"] [data-action^="change-"]', function(event) {
                    event.preventDefault();

                    var fulfillmentIdentifier = $(this).attr('data-action').split('change-')[1];
                    fulfillmentType = _.getObject(_.findWhere(items, {identifier: fulfillmentIdentifier}));

                    if (fulfillmentIdentifier == 'plan') {
                        fpUi.hideModal($modal);
                    }
                    else {
                        $modal.find('[data-role="modal-content"]')
                            .html(fpUi.renderTemplate('component/0/animated-loading.html'))
                            .addClass(modalOptions.animatedLoadingContainerClass);

                        var modalTitle,
                            fulfillmentConfig = _.getObject(shopIntentConfig[fulfillmentIdentifier]);

                        if(_.contains(['delivery', 'drop_ship'], fulfillmentIdentifier)) {
                            modalTitle = S.getString(fulfillmentConfig.searchInstructions, fpUi.locale('shopper-intent-search-instructions', 'Enter Your Address'));
                        }
                        else modalTitle = fulfillmentConfig.title || fpUtil.formatString('Select your {0} store', fulfillmentType.name);

                        $modal.find('[data-role="title"]').text(modalTitle);

                        loadStoreLocator(fulfillmentIdentifier)
                            .done(function(module) {
                                var $modalContent = $modal.find('[data-role="modal-content"]').removeClass(modalOptions.animatedLoadingContainerClass),
                                    $bodyContent = $modalContent.find('[data-role="body-content"]');
                                if(!$bodyContent.length) $bodyContent = $modalContent;

                                $bodyContent
                                    .empty()
                                    .append(module.$element);

                                $modal.find('[data-role="prev"]').removeClass('invisible');
                                // $modal.replaceClass('modal-fullwidth-sm-down', 'modal-fullwidth-md-down');
                                fpUi.updateModalSize($modal, 'md', fpConfig.enableMobile ? 'vw' : 'lg');

                                module.render();

                                var bsModal = $modal.data('bs.modal');
                                if(bsModal && bsModal.isShown) bsModal.focus();
                            });
                    }
                })
                .on('click.modal.shopIntent', '[data-action="start-shopping"]', function (event) {
                    event.preventDefault();

                    var $this = $(this),
                        storeId = $this.attr('data-store-id');
                    if(!storeId) return;

                    fp.formLoader.show($this);

                    fp.storeChange({
                        storeId: storeId,
                        callback: function() {
                            fp.formLoader.hide();
                        }
                    });
                })
                .on('change.modal.shopIntent', 'input[name="input-age_gate"]', function (event) {
                    var checked = this.checked,
                        $buttons = $modal.find('[data-role="modal-content"] [data-action^="change-"]')
                            .each(function() {
                                var $this = $(this).prop('disabled', !checked);

                                if(checked && ageGateFulfillmentIdentifier && S($this.attr('data-action')).endsWith(ageGateFulfillmentIdentifier)) {
                                    $this.trigger('click');
                                }
                            });
                    fp.setSessionCookie({ageGate: fpUtil.getBoolean(checked)});

                    if(checked && !$buttons.length) fpUi.hideModal($modal);
                });

            return fp.__shopIntentPromise;
        }
        ,showAlertMeModal: function(event, product) {
            if(!(fpConfig.enableBreinify && product)) return;

            var promiseStore,
                dropShipStore;
            if(!fpUtil.map.get('storeFulfillmentType').get('drop_ship').id) {
                promiseStore = fpService.storeService
                    .get({
                        for_fulfillment_state: fp.store.state,
                        for_fulfillment_type_id: fpUtil.map.get('fulfillmentType').get('drop_ship').id
                    })
                    .done(function (resp) {
                        dropShipStore = _.first(resp.items);
                    });

                if(event && event.target) {
                    new fpUi.Loading({
                        appendTo: event.target,
                        promiseHide: promiseStore,
                        showOnInstantiate: true,
                        destroyOnHide: true
                    });
                }
            }

            $.when(promiseStore)
                .done(function() {
                    var $modal = fpUi.showModal({
                            name: 'alert-me',
                            size: 'lg',
                            template: 'component/0/modal-alert-me.html',
                            className: 'fp-modal-alert-me',
                            title: fpUtil.formatString('{0} Alert Me', fpConfig.siteTitle),
                            item: product,
                            dropShipStore: dropShipStore
                        })
                        .on('click', '[data-action="confirm"]', function (event) {
                            event.preventDefault();
                            var $content = $modal.find('[data-role="modal-content"]'),
                                alertMe = fpUtil.getValueFromNamespace('Breinify.plugins.alertMe', window),
                                $alert = $content.find('[data-role="alert"]');

                            if(!alertMe) {
                                fpUtil.showError('Alert Me module was not found', $alert);
                                throw new Error('Breinify.plugins.alertMe is undefined');
                            }

                            var $form = $content.closest('form[name="fp-form-alert-me"]'),
                                $phone = $content.find('input[name="input-mobile-phone"]'),
                                phone = $phone.cleanVal(),
                                dropdown = $content.find('.fp-dropdown-alert-time').data('fp.ui.Component'),
                                time = dropdown && fp.S(dropdown.getValue()).split('|');

                            if(phone && time) {
                                var loading = new fpUi.Loading({
                                    appendTo: this,
                                    showOnInstantiate: true,
                                    destroyOnHide: true
                                });
                                fpUi.disableForm($form);

                                var $fulfillmentInform = $content.find('input[name="input-fulfillment-inform"]'),
                                    weekends = time[2],
                                    locationType = fpUtil.map.get('storeFulfillmentType').get('drop_ship').id ? 'delivery' : 'store',
                                    locations = {
                                        id: fp.store.store_number,
                                        type: locationType
                                    },
                                    alertTime = {
                                        start: fpUtil.getInteger(time[0]) * 60 * 60,
                                        end: fpUtil.getInteger(time[1]) * 60 * 60,
                                        weekdays: weekends == '0' || weekends == '-1',
                                        weekends: weekends == '1' || weekends == '-1'
                                    };

                                if(locationType != 'delivery') {
                                    locations.name = fp.store.name;

                                    if(dropShipStore && $fulfillmentInform.prop('checked')) {
                                        locations = [locations];
                                        locations.push({
                                            id: dropShipStore.store_number,
                                            type: 'delivery'
                                        });
                                    }
                                }

                                //if(fp.isLocal()) {
                                //    loading.hide();
                                //    fpUi.enableForm($form);
                                //    $phone.val('');
                                //    if(dropdown) dropdown.setValue(dropdown.$list.first().attr('data-value'));
                                //    $fulfillmentInform.prop('checked', false);
                                //    $modal.find('[data-action="confirm"]').prop('disabled', true);
                                //    fpUtil.showSuccess('We sent you a message! Please check your phone and confirm the alert.', $alert, {fadeOutMs: null});
                                //    fp.log(fpUtil.formatString('+1{0}', phone), {
                                //            email: fp.user.email,
                                //            userId: fp.user.store_card_number
                                //        }, {
                                //            sku: product.like_code,
                                //            name: product.name
                                //        }, locations,
                                //        alertTime);
                                //    return;
                                //}

                                alertMe.set(fpUtil.formatString('+1{0}', phone), {
                                        email: fp.user.email,
                                        userId: fp.user.store_card_number
                                    }, {
                                        sku: product.like_code,
                                        name: product.name
                                    }, locations,
                                    alertTime, function(error, data) {
                                        loading.hide();
                                        fpUi.enableForm($form);
                                        if(error && error.message) {
                                            fpUtil.showError(error.message.replace(/\[.*?\] /, ''), $alert);
                                            fp.notifier.notify({
                                                name: 'BreinifyWarning',
                                                message: error.message
                                            }, {
                                                severity: 'warning'
                                            });
                                        }
                                        else {
                                            $phone.val('');
                                            if(dropdown) dropdown.setValue(dropdown.$list.first().attr('data-value'));
                                            $fulfillmentInform.prop('checked', false);
                                            $modal.find('[data-action="confirm"]').prop('disabled', true);
                                            fpUtil.showSuccess('We sent you a message! Please check your phone and confirm the alert.', $alert, {fadeOutMs: null});
                                        }
                                    }
                                );
                            }
                        })
                        .one('show.bs.modal', function () {
                            var $content = $modal.find('[data-role="modal-content"]'),
                                $button = $modal.find('[data-action="confirm"]')
                                phoneConfig = fp.config.localePhone;

                            if(phoneConfig.format_input) {
                                $content.find('input[name="input-mobile-phone"]')
                                    .attr('placeholder', phoneConfig.default_format.replace('0', 'x'))
                                    .mask(phoneConfig.default_format, {
                                        onKeyPress: function() {
                                            $button.prop('disabled', true);
                                        },
                                        onComplete: function() {
                                            $button.prop('disabled', false);
                                        }
                                    });
                            }

                            $content.find('.fp-dropdown-alert-time').dropdown({
                                ariaLabel: fp.ui.locale('aria-label-dropdown-alert-time', 'Select time range')
                            });
                        })
                        .one('hidden.bs.modal', function () {
                            if(fp.config.localePhone.format_input) {
                                $modal.find('[data-role="content"] input[name="input-mobile-phone"]').unmask();
                            }
                        });
                });
        }
        ,showAddressModal: function() {
            var deferred = $.Deferred(),
                userAddressConfig,
                regions,
                modalConfig = {
                    name: 'address',
                    //template: 'component/0/address-fields.html',
                    content: deferred.promise(),
                    className: 'fp-address-modal',
                    //title: fpUi.locale('shared-edit-address', 'Edit Address'),
                    title: 'Please enter a valid CA Shipping address below to enter the Cyber Monday Event.',
                    buttons: [{
                        title: fpUi.locale('shared-submit', 'Submit'),
                        className: 'fp-btn-submit',
                        action: 'submit-address'
                    },
                    {
                        title: fpUi.locale('shared-cancel', 'Cancel'),
                        action: 'cancel',
                        className: 'fp-btn-cancel'
                    }]
                },
                $modal = fpUi.showModal(modalConfig)
                    .on('click', '[data-action="submit-address"]', function (event){
                        $modal.find('form[name="fp-form-address"]').trigger('submit');
                    })
                    .on('submit', 'form[name="fp-form-address"]', function (event){
                        event.preventDefault();

                        var $form = $(this);

                        if(fpUtil.validateForm($form)) {
                            var address = fp.user.address,
                                deliveryAddress = fpUi.getFormValues($form),
                                $error = $form.find('.fp-error'),
                                store,
                                promise;

                            Lockr.set('deliveryAddress', deliveryAddress);

                            if (address?.id) {
                                deliveryAddress.id = address.id;
                                promise = fpService.userAddressService
                                    .update(deliveryAddress, {
                                        errorSelector: $error
                                    });
                            }

                            promise = $.when(promise)
                                .then(function() {
                                    return fpService.storeService
                                        .get({
                                            for_address: fpUtil.getFormattedAddress(deliveryAddress, null, ',', null),
                                            for_fulfillment_type_id: fpUtil.map.get('fulfillmentType').get('drop_ship').id
                                        });
                                })
                                .then(function(resp) {
                                    store = _.first(resp.items);
                                    if(store && store.id == '3003') return fp.setStore(store, true);
                                    else store = null;
                                })
                                .done(function () {
                                    if(store) {
                                        fpUi.closeActiveModal();
                                        window.location.href = '/cyber-monday';
                                        return;
                                    }

                                    fpUtil.showError('Must enter a valid CA Shipping address to enter the Cyber Monday Event.', $error);
                                });

                            new fpUi.Loading({
                                appendTo: $modal.find('[data-action="submit-address"]'),
                                showOnInstantiate: true,
                                destroyOnHide: true,
                                promiseHide: promise
                            });
                        }
                    });

            fpUtil.map.load({
                service: fpService.serviceProviderConfigurationService,
                payload: {
                    service_provider_type: 'user_configuration',
                    service_provider: 'user_address'
                }
            })
            .then(function() {
                userAddressConfig = _.getObject(fpUtil.map.get('spcUserConfiguration').get('user_address').config);
                if(userAddressConfig.default_country_code) {
                    return fpService.regionService
                        .get({
                            parent: userAddressConfig.default_country_code,
                            is_selectable: fpConfig.enableAddressIsSelectable || undefined,
                            sort: 'name'
                        })
                        .done(function(resp) {
                            regions = resp.items;
                        });
                }
            })
            .then(fpService.userMeService.applyAddress)
            .then(function() {
                if(!fpUtil.isAuthenticated()) {
                    _.removeWhere(userAddressConfig.address_fields, {identifier: 'phone'});
                }

                const address = _.getObject(Lockr.get('deliveryAddress'));
                $.extend(address, fp.user.address);

                deferred
                    .resolve($(fpUi.renderTemplate('component/0/modal-address.html', $.extend(modalConfig, {
                        address: address,
                        userAddressConfig: userAddressConfig
                    }))).find('form[name="fp-form-address"]').append('<input type="submit" class="hidden" />'));

                //var $this = $(this);
                //
                //var self = this,
                //    scope = this.scope,
                //    address = {},
                //    cities;

                //if(address.city) address.city = address.city;
                //

                var $form = $modal.find('form[name="fp-form-address"]')
                    addressFieldHash = _.indexBy(userAddressConfig.address_fields, 'identifier');
                if(!userAddressConfig.user_state) {
                    $form.find('[data-role="region"]')
                        .html(fpUi.renderTemplate('component/0/address-region.html', {
                            regions: regions,
                            renderStoreCardSettings: {addressRequired: true},
                            state: address.state,
                            profile: false,
                            userAddressConfig: userAddressConfig,
                            addressFieldHash: addressFieldHash
                        }))
                        .find('.fp-dropdown-region').dropdown({
                            ariaLabel: fp.ui.locale('aria-label-dropdown-region', 'Select region')
                        });
                }

                $form.find('[data-role="city"]')
                    .html(fpUi.renderTemplate('component/0/address-city.html', {
                        cities: null,
                        renderStoreCardSettings: {addressRequired: true},
                        profile: false,
                        address: address,
                        addressFieldHash: addressFieldHash
                    }));

                fpUi.bindAddressAutoComplete($form);
            });
        }
        ,getLoginRedirectUrl: function(options) {
            options = _.getObject(options);

            var redirectUrl = options.next,
                autoRedirect = fpUtil.getBoolean(options.autoRedirect, true),
                routeOptions;

            if(_.isFunction(redirectUrl)) redirectUrl = redirectUrl();

            //old code specific to medactive
            // if(
            //     fpConfig.pageInterceptUrl &&
            //     autoRedirect &&
            //     (!redirectUrl || redirectUrl && redirectUrl.indexOf(fpConfig.pageInterceptUrl) >= 0)
            // ) {
            //     redirectUrl = '/';
            // }

            if(redirectUrl) {
                try {
                    redirectUrl = decodeURIComponent(redirectUrl);
                }
                catch(exc) {
                    fp.notifier.notify(exc);
                    redirectUrl = null;
                }
            }

            //only allow relative redirect URLs
            if(!options.allowAllUrls && redirectUrl) {
                redirectUrl = fpUi.router.routeManager.relativeUrl(redirectUrl);

                //usage of [token] indicates a redirect that will eventually go out to external URL
                //disableRouteParams to ensure that only search params are added to URL
                if(redirectUrl.indexOf('shopper_identifier=[token]') >= 0) {
                    redirectUrl = redirectUrl.replace('shopper_identifier=[token]', fpUtil.formatString('shopper_identifier={0}', fp.session.token));
                    options.disableRouteParams = true;
                    routeOptions = {
                        searchParams: fpUtil.urlParams({url: redirectUrl, includeSearch: true, includeRouteSearch: false})
                    };
                    redirectUrl = redirectUrl.split('?')[0];
                }
            }
            
            if(!redirectUrl && autoRedirect) redirectUrl = S.getString(window.document.referrer, '/');

            //ensure token is not in redirect url
            if(redirectUrl) {
                var params = {token: null};
                if(!routeOptions) {
                    routeOptions = {
                        searchParams: params,
                        routeSearchParams: params,
                        inherit: true
                    };
                }

                redirectUrl = this.router.routeManager.buildUrl(redirectUrl, routeOptions);
            }

            return redirectUrl;
        },
        applyUserLocaleToUrl: function(fromUrl, excludeParams) {
            var toUrl = fromUrl;

            if(fpConfig.enableLocaleRoute && fpUtil.isAuthenticated() && !fp.getSessionCookie().impersonate) {
                var locale = fpConfig.enableLocale && fp.locale,
                    userLocale = fp.user.locale;

                if(locale && userLocale && userLocale != locale) {
                    var stateManager = fpUi.router.stateManager,
                        toState,
                        toParams;

                    if (toUrl) {
                        var parsedUrl = stateManager.getStateFromUrl(toUrl, null, true);
                        toState = parsedUrl.state;
                        toParams = _.omit(parsedUrl.params, excludeParams);
                    }
                    else {
                        toState = stateManager.current;
                        toParams = _.omit(stateManager.stateParams, excludeParams);
                    }

                    toParams.lang = userLocale || null;
                    toUrl = stateManager.href(toState, toParams);
                }
            }

            return toUrl;
        },
        getAdminUrl: function() {
            //temporarily assign apiBaseUrl #FO-1091
            let adminUrl = fpConfig.adminUrl;
            if(S(fp.apiBaseUrl).trimRight('/').endsWith('ncrcloud.com')) {
                if(!fpUtil.isSuperUser()) {
                    adminUrl = fpConfig.gcpAdminUrl;
                }
                else if(fpConfig.intent === 'admin') {
                    adminUrl = fpUi.router.location.origin();
                }
            }
            return S(adminUrl).trimRight('/').s;
        }
        ,getCheckoutUrl: function() {
            var stateManager = fpUi.router.stateManager,
                fulfillmentTypes = fp.getStoreFulfillmentTypes(),
                checkoutState;

            if(fulfillmentTypes.length == 1) {
                checkoutState = stateManager.get(fpUtil.formatString('{0}-{1}', fpConfig.routeStates.checkout.name, fulfillmentTypes[0].identifier));
            }
            if(!checkoutState) checkoutState = fpConfig.routeStates.checkout;

            return stateManager.href(checkoutState);
        }
        ,getStoreUrl: function(store, defaultUrl) {
            var uiRouter = fpUi.router,
                url = S(_.getObject(store, fp.store).url || defaultUrl).trim().s;
            if(!url) {
                url = uiRouter.stateManager.href(fpConfig.routeStates.storeLocator);
            }

            return fp.isProd() ? url : uiRouter.routeManager.relativeUrl(url);
        }
        ,getOauthLoginUrl: function() {
            //return first oauth URL if no username/password configuration exists
            var authenticationTypes = fpUtil.map.get('spcUserAuthenticationType', null, true),
                oauthTypes = fpUi.getOauthTypes();

            if(oauthTypes.length === 1 && !authenticationTypes.get('username_password').id) {
                return oauthTypes[0].url;
            }
        }
        ,getOauthLogoutUrl: function(returnUrl) {
            //return first oauth logout URL if no username/password configuration exists
            var authenticationTypes = fpUtil.map.get('spcUserAuthenticationType', null, true),
                oauthTypes = fpUi.getOauthTypes();

            if(oauthTypes.length === 1 && !authenticationTypes.get('username_password').id) {
                return oauthTypes[0].logout_url;
            }
        }
        ,getMediaSize: function(width) {
            if(S(fp.device.screen).eq('XS', true)) return 'XS';
            if(!fpUtil.isInteger(width)) return '';

            //var matchMediaMin = fpConstants.matchMediaMin,
            var matchMediaMin = fpConstants.matchContainerMin,
                size = 'LG';

            if(width < matchMediaMin.SM) size = 'XS';
            else if(width < matchMediaMin.MD) size = 'SM';
            else if(width < matchMediaMin.LG) size = 'MD';

            return size;
        }
        ,getContainerPadding: function($element) {
            var paddingLeft = 0;
            if(fpUtil.isJQuery($element) && $element.length) {
                $element
                    .parents('.container, .container-fluid')
                    .add($element.filter('.container, .container-fluid'))
                    .each(function() {
                        paddingLeft = fpUtil.getInteger($(this).css('paddingLeft'));
                        return paddingLeft > 0;
                    });
            }

            return paddingLeft;
        }
        ,getClassName: function(state, className, altClassName) {
            return S.getString(fpUtil.getStateValue(state, className, altClassName));
        }
        ,getItemClassName: function(item) {
            var className = [];
            if(item && item.id) {
                var typeId = item.sale_configuration_type_id &&
                    fpUtil.map.get('saleConfigurationType').get(item.sale_configuration_type_id, null, true).identifier;
                if(typeId) className.push('fp-item-' + typeId);
                _.each(item.offers, function(item) {
                    _.each(item.tags, function(key) {
                        className.push('fp-item-offer-' + key);
                    });
                });
                if(item.store_card_required) className.push('fp-item-store_card_required');
            }
            return className.join(' ');
        }
        ,onProductAdClick: function(event, item, options) {
            if (!fpUtil.isEvent(event) || !fpUtil.isProductAd(item)) {
                return $.when();
            }

            options = _.defaults(options, {showProductModal: false});

            var $target = $(event.target),
                isClick = event.type == 'click',
                $item = $target.closest('.fp-item'),
                $anchor = $target.closest('a'),
                $itemImage = $target.closest('.fp-item-image'),
                triggerTrackUrl = options.triggerTrackUrl,
                href,
                promise;

            //set triggerTrackUrl to null to let logic decide
            if (fpUtil.isNull(triggerTrackUrl) && !item.__hasTrackedInteraction) {
                triggerTrackUrl = false;

                if ($anchor.length) {
                    triggerTrackUrl = true;
                }
                else if ($itemImage.length) {
                    triggerTrackUrl = true;
                    $anchor = $item.find('.fp-item-image a');
                }
                else if (!$item.find('.fp-item-action:visible, .fp-item-favorite:visible').length) {
                    triggerTrackUrl = true;
                    $anchor = $item.find('.fp-item-image a');
                }
                else if ($target.hasClass('fp-item-favorite') || $target.closest('.fp-item-action').length) {
                    triggerTrackUrl = true;
                }
            }

            if(triggerTrackUrl && !item.__hasTrackedInteraction) {
                var stateManager = fpUi.router.stateManager;
                if(fp.isDev() && !fpUtil.getBoolean(stateManager.stateParams.enable_track_url)) {
                    fp.log('Product Ad Interaction Track Url:', item.interaction_track_url);
                }
                else {
                    if(S(item.interaction_track_url).startsWith(fp.apiBaseUrl)) {
                        promise = fp.api(item.interaction_track_url, {token: null}, {apiKey: null, ignoreErrors: true});
                    }
                    else promise = fpUi.preloadImage(item.interaction_track_url);
                }

                if (isClick && !options.disableRedirectToDetail && !options.showProductModal) {
                    if ($anchor.length) href = $anchor.attr('href');

                    //if we are transitioning to a new page, wait until tracking has completed
                    if (!fp.ui.router.location.isCurrentPage(href)) {
                        event.preventDefault();
                        fp.formLoader.show($item.find('.fp-item-image a'));

                        $.when(promise)
                            .always(function () {
                                fp.formLoader.hide();
                                stateManager.go(href, null, {absolute: true});
                            });
                    }
                }

                if(!fp.disableHasTracked) item.__hasTrackedInteraction = true;
            }

            if(isClick && options.showProductModal) {
                event.preventDefault();

                if(options.displayType == 'coupon') {
                    fp.ui.showOfferModal(item.product && item.product.clippable_offer);
                }
                else {
                    var productAds = _.size(item.products) ? item.products : [item],
                        hashedProductAds = {},
                        productIds = [];

                    _.each(productAds, function (productAd) {
                        productIds.push(productAd.product_id);
                        if(productAd.product_id == item.product_id && productAd.interaction_track_url && !fp.disableHasTracked) {
                            productAd.__hasTrackedInteraction = true;
                        }
                        hashedProductAds[productAd.product_id] = productAd;
                    });

                    options.productAdsData.items = productAds;

                    fp.trigger(fp.events.PRODUCTS_MODAL_SHOW, {
                        title: options.title || fp.ui.locale('shared-add-products-list', 'Add Product to List'),
                        productIds: productIds,
                        productAds: productAds,
                        hashedProductAds: hashedProductAds,
                        productAdsData: options.productAdsData
                    });
                }
            }

            return $.when(promise);
        }
        ,onBannerAdClick: function(event, item, options) {
            if (!fpUtil.isEvent(event) || !fpUtil.isBannerAd(item)) {
                return $.when();
            }

            options = _.getObject(options);

            var $target = $(event.target),
                $anchor = $target.closest('a'),
                triggerTrackUrl = options.triggerTrackUrl,
                href,
                promise;

            //set triggerTrackUrl to null to let logic decide
            if (fpUtil.isNull(triggerTrackUrl)) {
                triggerTrackUrl = $anchor.length > 0;
            }

            if(triggerTrackUrl && !item.__hasTrackedInteraction) {
                if(fp.isDev()) {
                    fp.log('Banner Ad Interaction Track Url:', item.interaction_track_url);
                }
                else {
                    if(S(item.interaction_track_url).startsWith(fp.apiBaseUrl)) {
                        promise = fp.api(item.interaction_track_url, {token: null}, {apiKey: null, ignoreErrors: true});
                    }
                    else promise = fpUi.preloadImage(item.interaction_track_url);
                }

                if (!options.disableRedirect) {
                    if ($anchor.length) href = $anchor.attr('href');

                    //if we are transitioning to a new page, wait until tracking has completed
                    if (!fp.ui.router.location.isCurrentPage(href)) {
                        event.preventDefault();
                        fp.formLoader.show($anchor);

                        $.when(promise)
                            .always(function () {
                                fp.formLoader.hide();
                                fp.ui.router.stateManager.go(href, null, {absolute: true});
                            });
                    }
                }

                if(!fp.disableHasTracked) item.__hasTrackedInteraction = true;
                
                if(options.showProductModal) {
                    fp.trigger(fp.events.PRODUCTS_MODAL_SHOW, {
                        title: fpUi.locale('shared-add-products-list', 'Add Product to List'),
                        productIds: productIds,
                        hashedProductAds: hashedProductAds,
                        mode:'search'
                    });
                }
            }

            return $.when(promise);
        }
        ,triggerTrackUrls: function(obj, hash) {
            
            if(_.isObject(obj)) {
                var urlParams = fpUi.router.routeManager.urlParams,
                    enableMultiplex = fpConfig.enableMultiplex && urlParams.enable_multiplex != 'false',
                    enableTrackUrl = !fp.isDev() || fpUtil.getBoolean(urlParams.enable_track_url),
                    multiplexTrackUrls = [],
                    trackUrls = [],
                    itemTrackUrls,
                    hasBaseUrl;

                // trigger beacon on load
                if(!obj.isBecaonLoaded && obj.page_load_beacons && obj.page_load_beacons.on_load_beacons){
                    obj.isBecaonLoaded = true;
                    if (!enableTrackUrl) {
                        fp.log('Page Ad Beacons On Load Urls:', obj.page_load_beacons.on_load_beacons);
                    }else{
                        _.each(obj.page_load_beacons.on_load_beacons, function(on_load_beacon){
                            fp.api(on_load_beacon, {token: null}, {apiKey: null, ignoreErrors: true});
                        });
                    }
                }else{                
                    _.each(_.isArray(obj) ? obj : [obj], function (data) {
                        itemTrackUrls = data.track_urls ? data.track_urls : data.track_url && [data.track_url];
                        if(!data.__hasTrackedUrl && _.size(itemTrackUrls)) {
                            if(!fp.disableHasTracked) data.__hasTrackedUrl = true;
                            _.each(itemTrackUrls, function (item) {
                                if (item && (!hash || (hash && !hash[data.id || data.banner_id]))) {
                                    trackUrls.push(item);
                                    hasBaseUrl = S(item).startsWith(fp.apiBaseUrl);
                                    if (enableMultiplex && hasBaseUrl) {
                                        multiplexTrackUrls.push(item);
                                    }
                                    else if (enableTrackUrl) {
                                        if(hasBaseUrl) {
                                            fp.api(item, {token: null}, {apiKey: null, ignoreErrors: true});
                                        }
                                        else fpUi.preloadImage(item);
                                    }
                                    if(hash && !hash[data.id || data.banner_id]) hash[data.id || data.banner_id] = true;
                                }
                            });

                            if(data.product_id) {
                                _.find(data.items || data.products, function (item) {
                                    if (item.product_id == data.product_id) {
                                        if(item.track_url && !fp.disableHasTracked) item.__hasTrackedUrl = true;
                                        return true;
                                    }
                                });
                            }
                        }
                    });
                    if (!enableTrackUrl) {
                        fp.log('Product Ad Track Urls:', trackUrls);
                    }
                    else if(enableMultiplex && multiplexTrackUrls.length) {
                        fpService.multiplexService.run(multiplexTrackUrls, {enableMultiplex: true, ignoreErrors: true});
                    }
                }
                if(obj.items) fpUi.beaconOnLoadProduct(obj);
            }
        },
        // trigger product beacon on load
        beaconOnLoadProduct: function(obj){
            if(obj.isBecaonOnLoadTriggered) return;

            var multiplexBeacons = [],
                urlParams = fpUi.router.routeManager.urlParams,
                enableTrackUrl = !fp.isDev() || fpUtil.getBoolean(urlParams.enable_track_url),
                enableMultiplex = fpConfig.enableMultiplex && urlParams.enable_multiplex != 'false';

            if (!enableTrackUrl) {
                _.each(obj.items, function(item){
                    if(item.product_on_load_beacon) multiplexBeacons.push(item.product_on_load_beacon);
                });
                fp.log('Product Ad Beacons On Load Urls:', multiplexBeacons);
            }
            else{
                _.each(obj.items, function(item){
                    if(item.product_on_load_beacon){
                        if(enableMultiplex){
                            multiplexBeacons.push(item.product_on_load_beacon);
                        }else{
                            fp.api(item.product_on_load_beacon, {token: null}, {apiKey: null, ignoreErrors: true});
                        }
                    }
                });
                if(enableMultiplex) fpService.multiplexService.run(multiplexBeacons, {enableMultiplex: true, ignoreErrors: true});
            }
            obj.isBecaonOnLoadTriggered = true;
        },
        // trigger product beacon on click
        beaconOnClick: function(data, $element){
            if(_.isObject(data)) {
                const urlParams = fpUi.router.routeManager.urlParams,
                    enableTrackUrl = !fp.isDev() || fpUtil.getBoolean(urlParams.enable_track_url);

                if(!data.isAdProductsOnClick) data.isAdProductsOnClick = {};
        
                _.each(data.items, function(item){
                    if(item.product_on_click_beacon && item.product_id){
                        $element.on('click', ".fp-item[data-product-id='"+ item.product_id +"']", function(event){
                            if(!data.isAdProductsOnClick[item.product_id]) {
                                if(!enableTrackUrl) fp.log('Product Ad Beacons On Click Urls', item.product_on_click_beacon);
                                else fp.api(item.product_on_click_beacon, {token: null}, {apiKey: null, ignoreErrors: true});
                            }
                            data.isAdProductsOnClick[item.product_id] = true;
                        });
                    }
                });
            }
        },
        // detect scroll and resize on modal and screen, to trigger beacon on view
        beaconOnView: function(data, $element, options){
            if(_.isObject(data)) {
                var options = _.getObject(options); 

                if(options.parentClass) $element = $(document).find(options.parentClass);
                
                // product on view
                fpUi.productsBeaconOnView(data, $element, data.items);

                // page on view
                fpUi.pageBeaconOnView(data, $element);
            }
        },
        // trigger page beacon on view
        pageBeaconOnView: function(data, $element){
            if(!data?.page_load_beacons?.on_view_beacon) return;

            const urlParams = fpUi.router.routeManager.urlParams,
                enableTrackUrl = !fp.isDev() || fpUtil.getBoolean(urlParams.enable_track_url);

            if(data.onResizeScrollPageBeacon){
                $element.off('resize scroll', data.onResizeScrollPageBeacon);
                $(window).off('resize scroll', data.onResizeScrollPageBeacon);
            }

            // checking if it is on view when loaded
            if(fpUi.isPageInView(data.items, $element) && !data.isPageViewed){
                data.isPageViewed = true;
                if(data.page_load_beacons && data.page_load_beacons.on_view_beacon){
                    if (!enableTrackUrl) {
                        fp.log('Page Beacons On View Urls:', data.page_load_beacons.on_view_beacon);
                    }
                    else{
                        fp.api(data.page_load_beacons.on_view_beacon, {token: null}, {apiKey: null, ignoreErrors: true});
                    }
                }
                return;
            }

            // fn for window and element physical changes
            data.onResizeScrollPageBeacon = function() {
                fpUi.pageBeaconOnView(data, $element);
            };

            $element.on('resize scroll', data.onResizeScrollPageBeacon);
            $(window).on('resize scroll', data.onResizeScrollPageBeacon);
        },
        productsBeaconOnView: function(data, $element, items){
            if(!data) return;

            let $productAdDiv;

            const urlParams = fpUi.router.routeManager.urlParams,
                enableTrackUrl = !fp.isDev() || fpUtil.getBoolean(urlParams.enable_track_url);

            if(data.onResizeScrollProductBeacon){
                $element.off('resize scroll', data.onResizeScrollProductBeacon);
                $(window).off('resize scroll', data.onResizeScrollProductBeacon);
            }

            if(!data.isProductsViewed) data.isProductsViewed = {};

            if(!items || items.length < 1) items = data.items;

            _.each(items, function(item){
                if(item.product_on_view_beacon && !data.isProductsViewed[item.product_id]){
                    $productAdDiv = $element.find(".fp-item[data-product-id='"+ item.product_id +"']");
                    if($productAdDiv.length > 0 && fpUtil.isInViewport($productAdDiv)){
                        if (!enableTrackUrl) {
                            fp.log('Product Ad Beacons On View Urls:', item.product_on_view_beacon);
                        }
                        else{
                            fp.api(item.product_on_view_beacon, {token: null}, {apiKey: null, ignoreErrors: true});
                        }
                        data.isProductsViewed[item.product_id] = true;
                    }
                };
            });

            // fn for window and element physical changes
            data.onResizeScrollProductBeacon = function() {
                fpUi.productsBeaconOnView(data, $element, items);
            };

            $element.on('resize scroll', data.onResizeScrollProductBeacon);
            $(window).on('resize scroll', data.onResizeScrollProductBeacon);
        },
        isPageInView(items, $element){
            let $productAdDiv,
                isView = false;

            _.each(items, function(item){
                $productAdDiv = $element.find(".fp-item[data-product-id='"+ item.product_id +"']");
                if($productAdDiv.length > 0 && fpUtil.isInViewport($productAdDiv)){
                    isView =  true;
                }
            });
        
            return isView;
        }
        ,getTreeifiedCategoryExts: function(categoryExts, categoryHash) {
            let treeifiedExts,
                topCategoryExt;

            if(_.size(categoryExts) && _.isObject(categoryHash)) {
                let topCategoryExts = [],
                    categoryExt,
                    category;

                for (var n = 0; n < categoryExts.length; n++) {
                    categoryExt = categoryExts[n];
                    if (!_.isString(categoryExt.id)) continue;

                    if (fpUtil.isNull(categoryExt.parent_id)) {
                        topCategoryExts.push(categoryExt);
                        continue;
                    }
                }

                if (categoryExts.length) {
                    let hashedCategoryExts = _.indexBy(categoryExts, 'id');

                    treeifiedExts = fpUtil.treeify(categoryExts, {
                        childrenField: 'items',
                        sortBy: 'sequence',
                        asHash: true
                    });

                    if (topCategoryExts.length > 1) {
                        let topCategory = categoryHash[topCategoryExts[0].id],
                            hashedCategory;

                        for(var n=1;n<topCategoryExts.length; n++) {
                            categoryExt = topCategoryExts[n];
                            hashedCategory = categoryHash[categoryExt.id];
                            if(_.size(hashedCategory?.items) > _.size(topCategory?.items)) {
                                topCategory = hashedCategory;
                                topCategoryExt = categoryExt;
                            }
                        }
                    }

                    //fallback if we can't find a top level category
                    if (!topCategoryExt) {
                        topCategoryExt = fpUtil.sort(categoryExts, 'parent_id')[0];
                    }

                    topCategoryExt = _.getObject(treeifiedExts[topCategoryExt.id]);
                }
            }

            return {
                treeifiedExts: _.getObject(treeifiedExts),
                topCategoryExt: _.getObject(topCategoryExt)
            };
        }
        ,loadCategories: function(multiplexId) {
            var categories,
                hashedCategories;

            return this.getCategories(null, null, multiplexId)
                .done(function(data) {
                    categories = data.categories;
                    hashedCategories = data.hashedCategories;
                })
                .always(function() {
                    fp.defaultDepartment = _.firstObject(categories, fp.defaultDepartment);
                    fp.departments = _.getArray(categories);
                    fp.departmentHash = _.getObject(hashedCategories);

                    // fpUtil.setActiveDepartments(hashedCategories);
                    fpUtil.initDepartment();
                    
                    fp.trigger(fp.events.DEPARTMENTS_LOADED, fp.defaultDepartment);
                });

        }
        ,getCategories: function(storeId, type, multiplexId) {
            //removeIf(!debug)

            // if(fpUi.router.routeManager.urlParams.disable_categories === 'true') {
            //     return $.Deferred().resolve({
            //         categories: [],
            //         hashedCategories: {}
            //     });
            // }

            //endRemoveIf(!debug)


            //fp.log('getCategories', 'type:', type || 'product:', 'storeId', storeId);

            storeId = fpUtil.getUndefinedIfEmpty(storeId);

            let categoryMetaResp,
                promiseCategories,
                promiseCategoriesMeta,
                categoryKey,
                // categoryOptions,
                enableRunMultiplex;

            if(!multiplexId) {
                multiplexId = _.uniqueId();
                enableRunMultiplex = true;
            }

            if(type === 'recipe') {
                categoryKey = 'categories';

                promiseCategoriesMeta = fpUtil.map.load({
                    service: fpService.recipeService,
                    cacheKey: 'recipeCategory',
                    itemsKey: 'categories',
                    payload: {
                        fields: null,
                        include_categories: true,
                        category_id_cascade: true,
                        no_limit: null,
                        limit: 0,
                    },
                    options: {
                        multiplexId: multiplexId
                    }
                })
                .done(function (resp) {
                    categoryMetaResp = {
                        categories: fpUtil.map.get('recipeCategory').items()
                    };
                });
            }
            else {
                type = 'product';
                categoryKey = 'departments';

                if(!storeId && !fp.store.id && fpConfig.topShopStoreId) {
                    storeId = fpConfig.topShopStoreId;
                }

                promiseCategoriesMeta = fpService.productService
                    .get({
                        store_id: storeId,
                        include_departments: true,
                        department_id_cascade: true,
                        limit: 0
                    }, {
                        handleErrors: false,
                        prepareJsonData: false,
                        multiplexId: multiplexId
                    })
                    .done(function (resp) {
                        categoryMetaResp = resp;
                    });
            }

            if(enableRunMultiplex) fpService.multiplexService.run(multiplexId);

            return $.when(
                promiseCategories,
                promiseCategoriesMeta
            )
            .then(function () {
                var items = [],
                    topCategories = [],
                    categoryExts = categoryMetaResp && categoryMetaResp[categoryKey],
                    hashedCategories;

                if(_.size(categoryExts)) {
                    var hashedCategoryExts = _.indexBy(categoryExts, 'id'),
                        circularReferenceIds = {},
                        defaultJsNavPath = type === 'recipe' ? '/recipe' : fpConfig.urls.shopping,
                        categoryCandidates = hashedCategoryExts,
                        jsNavPath,
                        referenceIds,
                        category,
                        childCategory;

                    //back fill any parents
                    _.each(categoryExts, function (item) {
                        category = item;
                        if (!category) return;

                        //check if more than one top level category has been returned by api
                        if(!category.parent_id) {
                            topCategories.push(category);
                        }
                        else items.push(category);

                        childCategory = category;

                        referenceIds = {};
                        while (category) {
                            //if we've hit this id before we have a circular reference and need to exit
                            if(referenceIds[category.id]) {
                                if(!circularReferenceIds[category.id]) {
                                    circularReferenceIds[category.id] = 1;

                                    //disable logging of CategoryError
                                    // fp.notifier.notify({
                                    //     name: 'CategoryError',
                                    //     message: fpUtil.formatString('CategoryError: Circular reference detected for {0} category ({1})', type, category.id)
                                    // }, {
                                    //     severity: 'error'
                                    // });
                                }

                                category = null;
                                continue;
                            }

                            referenceIds[category.id] = 1;
                            category = category.parent_id ? categoryCandidates[category.parent_id] : null;
                            if (category) {
                                if(!hashedCategoryExts[category.id]) {

                                    //check if more than one top level category has been returned by api
                                    if(!category.parent_id) {
                                        topCategories.push(category);
                                    }
                                    else items.push(category);

                                    hashedCategoryExts[category.id] = category;
                                }

                                if(!fpConfig.enableKiosk && fpConfig.enableMobile && type === 'product') {
                                    //overwrite department landing page paths for mobile site
                                    jsNavPath = category.__origJsNavPath;
                                    if(!jsNavPath) {
                                        jsNavPath = category.__origJsNavPath = category.js_navigation_path;
                                    }

                                    if(jsNavPath) {
                                        if(category.canonical_url) {
                                            category.canonical_url = category.canonical_url.replace(jsNavPath, defaultJsNavPath);
                                        }

                                        if(childCategory.js_navigation_path) {
                                            jsNavPath = childCategory.__origJsNavPath;
                                            if(!jsNavPath) {
                                                jsNavPath = childCategory.__origJsNavPath = childCategory.js_navigation_path;
                                            }
                                        }

                                        if(childCategory.canonical_url) {
                                            childCategory.canonical_url = childCategory.canonical_url.replace(jsNavPath, defaultJsNavPath);
                                        }

                                        category.js_navigation_path = childCategory.js_navigation_path = undefined;
                                    }
                                }
                            }
                        }
                    });

                    for(var n=topCategories.length-1; n >= 0; n--) {
                        items.unshift(topCategories[n]);
                    }

                    hashedCategories = fpUtil.treeify(items, {
                        childrenField: 'items',
                        sortBy: 'sequence',
                        asHash: true
                    });

                    //error case, API is returning more than one category that does not have a parent_id
                    if (topCategories.length > 1) {
                        var moveIndex = -1,
                            category = items[0],
                            topCategory = hashedCategories[category.id],
                            topCategoryIds = category.id,
                            hashedCategory;

                        for(var n=1;n<topCategories.length; n++) {
                            category = items[n];
                            topCategoryIds += ',' + category.id;
                            hashedCategory = hashedCategories[category.id];
                            if(_.size(hashedCategory && hashedCategory.items) > _.size(topCategory && topCategory.items)) {
                                moveIndex = n;
                            }
                        }
                        if(moveIndex >= 0) _.move(items, moveIndex, 0);

                        //disable logging of CategoryError
                        // fp.notifier.notify({
                        //     name: 'CategoryError',
                        //     message: fpUtil.formatString('CategoryError: More than one top level {0} category detected ({1})', type, topCategoryIds)
                        // }, {
                        //     severity: 'error',
                        //     metaData: {
                        //         'meta data': {
                        //             'API Url': categoryOptions && fpUtil.getApiUrl(categoryOptions.url, categoryOptions.data, categoryOptions.method)
                        //         }
                        //     }
                        // });
                    }

                    //if(fp.isDev()) {
                    //    _.each(categoryCandidates, function(item) {
                    //        if(!hashedCategories[item.id]) {
                    //            fp.warn(fpUtil.formatString('Discarding department {0} - {1} (Does not exist in product meta)', item.id, item.name));
                    //        }
                    //    });
                    //}
                }

                return {
                    categories: items,
                    hashedCategories: _.getObject(hashedCategories)
                };
            })
            .promise();
        }
        ,getActiveCategory: function() {
            var module = fp.Module.getViewModule({
                    configAttrs: {name: 'product-detail'},
                    attrs: {enabled: true, initialized: true}
                }),
                topDepartment = _.getObject(fpUtil.getTopDepartment(fp.department.id)),
                categoryId,
                category;

            if(module) {
                var product = fpUtil.getValueFromNamespace('scope.item', module);
                categoryId = product && _.first(product.department_id);
            }


            categoryId = fpUtil.getItemId(categoryId, fpUi.router.stateManager.stateParams.department_id || fp.moduleDepartmentId);
            category = _.getObject(categoryId && fp.departmentHash[categoryId]);
            return (category.id && category.id != topDepartment.id) ? category : {};
        }
        ,loadStoreDependencies: function (refresh) {
            if(fpConfig.disableInitializeShopping) {
                fp.__promiseLoadStoreDependencies = fpUtil.map.load({
                    refresh: fp.loaded,
                    service: fpService.serviceProviderConfigurationService,
                    payload: {
                        service_provider_type: 'user_authentication_type'
                    }
                });
            }
            else {
                var promises = [],
                    serviceProvideType = 'ad_network,digital_coupons,store_card,store_setting,review_target_type,product_data,user_authentication_type,product_configuration,user_analytics',
                    multiplexId = _.uniqueId(),
                    tagType = '',
                    promiseMap,
                    stateManager = fp.ui.router.stateManager;

                if(fpConfig.enableAddressTypeahead) {
                    serviceProvideType += ',location_autocomplete';
                }
                
                _.empty(fp.digitalCouponsSettings);
                _.empty(fp.storeCardSettings);
                _.empty(fp.productConfigurationConfig);

                _.each([
                    'hasDigitalCoupon',
                    'myCouponTitle',
                    'distanceUnit',
                    'hasRewardHistory',
                    'hasReward',
                    'hasInStoreReceipt',
                    'hasInStoreOrder',
                    'hasSavedPayment',
                    'productReviewSettings',
                    'hasProductSubscriptions'
                ], function(key) {
                    delete fp[key];
                });

                promises.push(fpUi.loadCategories(multiplexId));

                if(fp.store.id && fp.store.id != fp.topStore.id) {
                    if(tagType) tagType += ',';
                    tagType += 'fulfillment_type';
                }

                if(fpUtil.isAuthenticated()) {
                    if(stateManager.contains(stateManager.current, fp.config.routeStates.account)) {
                        if(tagType) tagType += ',';
                        tagType += 'payment_type';
                    }
                    serviceProvideType += ',reward_history,reward,order_data,in_store_orders,payment_type,product_subscription';
                }

                if(fpConfig.modules.groupCarousel) {
                    serviceProvideType += ',product_recommendation';
                }

                tagType = S(tagType);

                _.each(['fulfillment_type', 'payment_type'], function(key) {
                    if(!tagType.contains(key)) {
                        promiseMap = fpUtil.map.load({
                            cacheKey: S('store_' + key).camelize().s,
                            refresh: true,
                            data: {},
                            options: {
                                multiplexId: multiplexId
                            }
                        });

                        promises.push(promiseMap);
                    }
                });

                if(tagType.length) {
                    promiseMap = fpUtil.map.load({
                        service: fpService.tagService,
                        cacheKeyPrefix: 'store_',
                        refresh: refresh || fp.loaded,
                        payload: {
                            type: tagType.s,
                            store_id: fp.store.id
                        },
                        options: {
                            multiplexId: multiplexId
                        }
                    });

                    promises.push(promiseMap);
                }

                promiseMap = fpUtil.map.load({
                    refresh: fp.loaded,
                    service: fpService.serviceProviderConfigurationService,
                    payload: {
                        service_provider_type: serviceProvideType
                    },
                    options: {
                        multiplexId: multiplexId
                    }
                })
                .then(function () {
                    var spcDigitalCoupon = fpUtil.map.get('spcDigitalCoupon'),
                        spcStoreCard = fpUtil.map.get('spcStoreCard'),
                        spcStoreSetting = fpUtil.map.get('spcStoreSetting');

                    $.extend(fpConfig.localePhone, fpUtil.getObjectFromNamespace('config.phone', spcStoreSetting.get('store_locale')));
                    
                    fp.hasDigitalCoupon = spcDigitalCoupon.items().length > 0;
                    fp.digitalCouponsSettings = fpUtil.getObjectFromNamespace('config', _.firstObject(spcDigitalCoupon.items()));
                    fp.myCouponTitle = fp.digitalCouponsSettings.my_coupon_title || fpConfig.myCouponTitle;
                    fpConfig.enableCouponClipping = fp.digitalCouponsSettings.has_product_filter;
                    fp.storeCardSettings = fpUtil.getObjectFromNamespace('config.store_card', _.firstObject(spcStoreCard.items()));
                    fp.productReviewSettings = fpUtil.map.get('spcReviewTargetType').get('product').config;
                    fp.sponsoredAdConfig = {};
                    fp.popUpSettings = spcStoreSetting.get('pop_up');

                    fp.productConfigurationConfig = _.getObject(fpUtil.map.get('spcProductConfiguration').get('product_find').config);
                    const rewardHistoryItems = fpUtil.map.get('spcRewardHistory', null, true).items();
                    fp.rewardHistoryConfig = _.getObject(_.firstObject(rewardHistoryItems).config);
                    fp.hasRewardHistory = rewardHistoryItems.length > 0;

                    if(fp.productConfigurationConfig.disallow_substitutions) fpConfig.hasSubstitutions = false;
                    if(fp.productConfigurationConfig.allow_search_substitutions) fpConfig.hasSearchSubstitutions = true;

                    fpConfig.enableUserAnalytics = fpUtil.map.get('spcUserAnalytic').items().length > 0;
                
                    _.find(fpUtil.map.get('spcAdNetwork', null, true).items(), function (item) {
                        if(item.config) {
                            fp.sponsoredAdConfig = item.config;
                            return true;
                        }
                    });

                    if(fpUtil.isAuthenticated()) {
                        var rewardConfig = _.first(fpUtil.map.get('spcReward').items());
                        if ((fp.hasReward = rewardConfig != null)) {
                            fp.hasReward = _.getObject(rewardConfig.config).reward_menu != fp.constants.cardFieldStatus.HIDE && !_.getObject(rewardConfig.config).hide_rewards;
                        }
                        fp.hasInStoreReceipt = fpUtil.map.get('spcOrderData').get('in_store_receipt').id != null;
                        fp.hasInStoreOrder = fpUtil.map.get('spcInStoreOrder').items().length > 0;
                        fp.hasSavedPayment = fpUtil.map.get('spcPaymentType').get('saved_payment').id != null;
                        fp.hasProductSubscriptions = fpUtil.map.get('spcProductSubscription').items().length > 0;
                        fp.hideProductSubscriptionMenu = fp.config.hideProductSubscriptionMenu;
                    }

                    //only for testing purposes
                    // if(!fp.isProd() && S(location.href).contains('sedanos.com:8686')) {
                    //     fpUtil.map.get('spcStoreSetting').get('site_url').config.home_url = 'http://shop.sedanos.com:8787';
                    // }

                    //if(fp.isLocal()) {
                    //    fpUtil.map.load({
                    //        service: fpService.serviceProviderConfigurationService,
                    //        payload: {
                    //            service_provider_type: 'user_authentication_type'
                    //        },
                    //        data: {items: [fpUtil.map.get('spcUserAuthenticationType').get('sm_retail')]},
                    //        cacheKey: 'spcUserAuthenticationType',
                    //        refresh: true
                    //    });
                    //}

                    return fpService.currencyService.get();
                });

                promises.push(promiseMap);

                if(fp.store.timezone && fp.timeZone && fp.timeZone != fp.store.timezone) {
                    promises.push(fpUi.loadFileDependencies({
                        src: 'date-fns-tz.js'
                    }));
                }

                fp.__promiseLoadStoreDependencies = $.when.apply($, promises);

                fpService.multiplexService.run(multiplexId);
            }

            return fp.__promiseLoadStoreDependencies;
        }
        ,preloadImage: function(src, timeout) {
            var $img = _.isString(src) && src.length ? $('<img/>') : src,
                deferred;

            src = null;

            if(fpUtil.isJQuery($img) && S($img.prop('nodeName')).eq('img', true)) {
                deferred = $.Deferred();
                $img
                    .one('load', deferred.resolve)
                    .one('error', deferred.resolve);
                
                if(src) $img.attr('src', src);

                if($img[0].complete) deferred.resolve();
                else if(timeout) {
                    _.delay(function() {
                        deferred.resolve();
                    }, timeout);
                }
            }
            else $img = $();

            return $.when(deferred)
                .then(function() {
                    return $img;
                })
                .promise();
        }
        ,updateImageGridItemWidth: function($itemList) {
            if($($itemList).length) {
                var matches = fp.S($itemList.prop('className')).match(/fp-image-(?!md)\S+/gim),
                    jssSelector = fpUtil.formatString('.fp-item-list-image{0} .fp-item', matches ? '.' + matches[0] : ''),
                    $item = $itemList.addClass('fp-transition-none').find('> .fp-item:first');

                fp.jss.remove(jssSelector);

                var listWidth = $itemList.outerWidth(),
                    itemWidth = $item.outerWidth();

                if(itemWidth) {
                    var itemsPerRow = Math.floor(listWidth / itemWidth),
                    itemCss = fp.jss.get(jssSelector);
                
                    if(listWidth % itemWidth >= itemWidth * 0.33) {
                        itemsPerRow++;
                    }
                    
                    itemCss.width = itemCss.height = fp.numeralInstance.set(listWidth).divide(itemsPerRow).add(1).round(3).value() + 'px';
                    fp.jss.set(jssSelector, itemCss);
                }

                _.delay(function() {
                    $itemList.removeClass('fp-transition-none');
                }, 500);
            }
        }
        ,clipOffer: function(offer, options) {
            options = _.getObject(options);

            var router = fpUi.router,
                stateParams = router.stateManager.stateParams,
                storeCardConfig = fpConfig.storeCard,
                customCouponError = storeCardConfig.customCouponError ? storeCardConfig.customCouponError : fp.ui.locale('custom-coupon-error', 'phone number and click the Update button at the bottom of the page');

            if(!fpUtil.isAuthenticated() && !stateParams.card) {
                var deferred = $.Deferred(),
                    title = 'Please sign in',
                    content = S.getString(storeCardConfig.signInContent, 'Please sign in to add coupons.'),
                    confirmButtonLabel = 'Sign In',
                    cancelButtonLabel = 'Cancel';

                if(options.enableAnonymous) {
                    title = 'Customer card number';
                    content = 'Please enter a customer card number.';
                    confirmButtonLabel = cancelButtonLabel = '';
                }

                fp.trigger(fp.events.CONFIRM_MODAL_SHOW, {
                    title: title,
                    content: content,
                    confirmButtonLabel: confirmButtonLabel,
                    cancelButtonLabel: cancelButtonLabel,
                    callback: function(answer) {
                        if(!answer) {
                            deferred.resolve();
                            return;
                        }

                        if(!options.enableAnonymous){
                            router.routeManager.redirect(fpConfig.routeStates.login, {error: fpUi.locale('ui-sign-continue', 'Please sign in to continue.')});
                        }
                    }
                });

                return deferred.promise();
            }

            var disableCouponUpSell = options.disableCouponUpSell;
            if(!_.has(options, 'disableCouponUpSell')) {
                disableCouponUpSell = fpConfig.disableCouponUpSell;
            }

            var promise,
                error;

            if(!offer.is_clipped || offer.clipped_count) {
                var payload = {id: offer.reference_id || offer.id},
                    apiOptions = $.extend(_.getObject(options.apiOptions), {
                        formatForRestfulId: true,
                        errorFadeOutMs: 10000,
                        childServiceCall: 'clip'
                    }),
                    handleErrors = fpUtil.getBoolean(apiOptions.handleErrors, true);

                apiOptions.handleErrors = false;

                if (options.enableAnonymous && stateParams.card) {
                    payload.card_number = stateParams.card;
                }

                fp.formLoader.show($(options.$button));

                //if(fp.isLocal()) {
                //    disableCouponUpSell = false;
                //    payload.spill = true;
                //    payload.status_code = 400;
                //}

                //this can be uncommented when API supports POST on offer service
                promise = fpService.offerService
                    .post(payload, apiOptions)
                    .catch(function(jqXHR, textStatus, errorThrown) {
                        if (fpUtil.isAuthenticated()) {
                            error = errorThrown;
                            var resp = fpUtil.getXhrErrorResponse(jqXHR);
                            

                            switch (resp.error_code) {
                                case 'store_card_required':
                                case 'store_card_invalid':
                                    if(!apiOptions.enableStoreCardModalError) {
                                        error = fpUtil.formatString('{0} Please go to <a href="{1}">My Account</a>, then add a valid ', S(resp.error_message).ensureEnd().s, router.stateManager.href(fpConfig.routeStates.account));
                                        if (fp.storeCardSettings.store_virtual_card == fpConstants.cardFieldStatus.REQUIRED) {
                                            error += S(customCouponError).ensureEnd().s;
                                        }
                                        else {                                            
                                            error += customCouponError ? customCouponError : fpUtil.formatString('card/key tag number under the {0} section.', S.getString(storeCardConfig.profileCardTitle, 'Store Card'));
                                        }
                                    }
                                    else error = resp.error_message;

                                    break;
                                //no default
                            }

                            if (disableCouponUpSell && handleErrors) {
                                fpUtil.showError(error, apiOptions.errorSelector, {
                                    fadeOutMs: 10000
                                });
                            }
                        }

                        return fpUtil.getRejectedPromise(arguments);
                    })
                    .done(function(resp) {
                        offer.is_clipped = true;
                        fp.trigger(fp.events.OFFER_ITEM_CLIPPED, {item: offer});
                    });
            }

            return $.when(promise)
                .always(function() {
                    fp.formLoader.hide();

                    if(fp.isUnloading || disableCouponUpSell) return;
                    
                    if(apiOptions.enableStoreCardModalError && error) {
                        fpUi.showCardSettingsModal({
                            error: error
                        });
                        return;
                    }

                    //this can cause a loop as fpUi.clipOffer calls fpUi.showOfferModal so pass enableClipOfferOnShown=false
                    fpUi.showOfferModal(offer, {
                        disableCouponUpSell: disableCouponUpSell,
                        enableClipOfferOnShown: false,
                        error: error
                    });
                });
        }
        ,showCardSettingsModal: function(options) {
            if(options && !options.error) return;

            var loc = window.location,
                next = loc.pathname,
                $modal,
                storeCard = fp.config.storeCard,
                storeCardSettings = fp.storeCardSettings,
                renderStoreCardSettings = {},
                createCardLinkCopy = storeCard.linkCopy,
                cardMaxLength = 12,
                cardFieldStatus = fp.constants.cardFieldStatus,
                userAddress = fp.user.address,
                hasAddress = userAddress && userAddress.address_1 && userAddress.postal_code && userAddress.phone;

            if(hasAddress) {
                if(storeCard.linkCopyPerStore && storeCard.linkCopyPerStore[storeId]){
                    createCardLinkCopy = storeCard.linkCopyPerStore[storeId];
                }

                if(storeCardSettings.card_number_length) {
                    if(_.size(storeCardSettings.card_number_length) > 0) cardMaxLength = _.max(storeCardSettings.card_number_length);
                }

                storeCardSettings.user_date_of_birth = cardFieldStatus.HIDE;

                renderStoreCardSettings.hasDOBYear = storeCard.showDOBYear != null ? storeCard.showDOBYear : true;
                renderStoreCardSettings.phoneLabel = fp.config.formLabels && fp.config.formLabels.phone != null ? fp.config.formLabels.phone : fp.ui.locale('shared-phone', 'Phone');
                renderStoreCardSettings.phoneLabelInstructions = fp.config.formLabels && fp.config.formLabels.phoneLabelInstructions != null ? fp.config.formLabels.phoneLabelInstructions : '';
                renderStoreCardSettings.storeCardLabel = storeCard.linkLabel || fp.ui.locale('profile-store-card', 'Store Card or Key Tag #');
                renderStoreCardSettings.newCardLabel = storeCardSettings.store_request_new_card_label || storeCard.newCardLabel || fp.ui.locale('profile-request-card', 'Request New Card');
                renderStoreCardSettings.createCardLinkCopy = createCardLinkCopy;
                renderStoreCardSettings.cardMaxLength = cardMaxLength;
                renderStoreCardSettings.storeCardNumberRequired = true;


                $modal = fpUi.showModal({
                    name: 'Store Card Settings',
                    template: 'component/0/modal.html',
                    className: 'fp-store-card-settings-modal',
                    title: options.title || 'Store Card',
                    content: fp.ui.renderTemplate('component/0/animated-loading.html'),
                    buttons: [{
                        title: fpUi.locale('shared-submit', 'Submit'),
                        className: 'fp-btn-submit',
                        action: 'submit'
                    }]
                })
                .on('shown.bs.modal.storeCardSettingsModal', function () {
                    var defaultModalContent = fpUi.renderTemplate('component/0/store-card-settings.html', {
                            config: options, 
                            storeCardSettings: storeCardSettings, 
                            renderStoreCardSettings: renderStoreCardSettings, 
                            storeCardConfig: storeCard,
                            intent: 'modal'
                        }),
                        $modalContent = $modal.find('[data-role="modal-content"]');

                    $modalContent.html(defaultModalContent).find('[data-role="animated-loading"]').remove();
                    fpUtil.showError(options.error, $modal.find('[data-role="error"]'));
                })
                .on('submit', 'form[name="fp-store-card-form"]', function (event){
                    event.preventDefault();

                    var $form = $(this);
                    if(fp.util.validateForm($form)) formSubmit($form);
                })
                .on('click', '[data-action="submit"]', function(event) {
                    var $form = $modal.find('form[name="fp-store-card-form"]');
                    if(fp.util.validateForm($form)) formSubmit($form);                
                });

                function formSubmit($formCard) {
                    var payload = {},
                        $error = $formCard.find('[data-role="error"]').hide();

                    if(storeCardSettings.store_virtual_card == cardFieldStatus.REQUIRED){
                        payload.need_store_card = true;
                    }

                    payload.card_number = fp.S($formCard.find('[name="input-card_number"]').val()).trim().s;

                    fpService.userStoreCardService
                        .create(payload, {errorSelector: $error})
                        .then(function(resp) {
                            fp.ui.closeActiveModal();
                            window.location.reload();
                        });
                }
            }
            else {
                var loc = window.location,
                    next = loc.pathname,
                    profileConfig = $.extend({intent: 'modal', next: next}, fp.config.modules.account.modules.profile),
                    $profileModal = fp.ui.showModal({
                        name: 'fp-my-account-modal',
                        className: 'fp-my-account-modal',
                        size: 'lg',
                        title: fp.ui.locale('shared-my-account', 'My Account'),
                        content: fp.ui.renderTemplate('component/0/animated-loading.html')
                    })
                    .on('shown.bs.modal.storeCardSettingsModal', function () {
                        var $modalContent = $profileModal.find('[data-role="modal-content"]');
                        
                        profileConfig.name = 'profile';
                        profileConfig.intent = 'modal';
                        profileConfig.elementSelector = $('<div id="profile-modal"></div>').appendTo($profileModal.find('[data-role="modal-content"]'));

                        fp.ui.loadModule(profileConfig)
                            .then(function (module) {
                                return module.init();
                            })
                            .always(function() {
                                $modalContent.find('[data-role="animated-loading"]').remove();
                                fpUtil.showError(options.error, $profileModal.find('[name="fp-form-profile"] [data-role="error"]'));
                            });
                    });
            }
        }
        ,showOfferModal: function(offer, options) {
            if(!(offer && offer.id)) return;

            options = _.getObject(options);

            //this can cause a loop as fpUi.clipOffer calls fpUi.showOfferModal so make sure options.enableClipOfferOnShown != false
            if(((options.enableClipOfferOnShown != false && fpConfig.enableClipOfferOnShown) || options.clip) && (!offer.is_clipped || offer.clipped_count)) {
                var $button = $(options.target).closest('.fp-item, .fp-item-clippable-offer').find('[data-action="clip-offer"]');
                this.clipOffer(offer, {
                    $button: $button
                })
                .done(function() {
                    $button.toggleClass('fp-is-offer-clipped', fpUtil.getBoolean(offer.is_clipped));
                });

                return;
            }

            var stateManager = fpUi.router.stateManager,
                disableCouponUpSell = fpUtil.getBoolean(options.disableCouponUpSell, fpConfig.disableCouponUpSell),
                productIds = fpUtil.getStateValue(!disableCouponUpSell, offer.product_ids),
                $introContent = $(fpUi.renderTemplate('component/1/clippable-offer.html', {item: offer}, null, true))
                    .on('click', '[data-action="show-disclaimer"]', function(event) {
                        event.preventDefault();

                        fpUi.showModal({
                            name: 'offer-disclaimer',
                            className: 'fp-offer-disclaimer-modal',
                            title: S.getString(offer.brand, 'Disclaimer'),
                            content: offer.offer_disclaimer
                        });
                    })
                    .on('click', '[data-action="clip-offer"]', function(event) {
                        event.preventDefault();

                        var $this = $(this);

                        if(!offer.clipped_count && offer.is_clipped) return;

                        fpUi.clipOffer(offer, {
                                $button: $this,
                                disableCouponUpSell: true,
                                apiOptions: {
                                    errorSelector: $introContent.find('[data-role="notification"]').hide(),
                                    handleErrors: true
                                }
                            })
                            .done(function() {
                                $this.toggleClass('fp-is-offer-clipped', fpUtil.getBoolean(offer.is_clipped));
                            });
                    });

            fp.trigger(fp.events.PRODUCTS_MODAL_SHOW, {
                title: productIds ? 'Would you like to add it to your shopping list?' : offer.name,
                mode: fpUtil.getStateValue(!disableCouponUpSell, 'search'),
                disableSearchForNoProducts: true,
                productIds: productIds,
                allowGenericItem: false,
                disableNoProductsFound: true,
                introContent: $introContent,
                listManager: options.listManager
            });

            fp.$productsModal
                .one('shown.bs.modal.offer', function() {
                    if(options.error) {
                        var fadeOutMs = !fpConfig.enableCouponErrorLongTerm ? 10000 : null;
                        fpUtil.showError(options.error, $introContent.find('[data-role="notification"]'), {fadeOutMs: fadeOutMs, handleScroll: false});
                    }
                })
                .one('hidden.bs.modal.offer', function() {
                    stateManager.go(stateManager.current, {offer_id: null, clip: null}, {preventDefault: true, inherit: true});
                });

            stateManager.go(stateManager.current, {offer_id: offer.id}, {preventDefault: true, inherit: true, enableSearchParams: options.enableSearchParams});
        }
        ,showOfferDetailModal: function(offer) {
            if(_.size(offer && offer.product_ids)) {
                fp.trigger(fp.events.PRODUCTS_MODAL_SHOW, {
                    title: offer.name,
                    subTitle: offer.description,
                    productIds: offer.product_ids,
                    closeWhenNoProductsFound: true,
                    //listName: fp.S(this.scope.activeCircular.name).getString(this.config.title).trimLeft('View ', true).s,
                    //listPosition: $item && ($item.index() + 1),
                    //note: offer.name
                    //mode: 'search'
                    //notFoundTemplate: this.config.productsNotFound,
                    //onRefreshUI: function(event, payload) {
                    //    self.__refreshProductAction($item, payload);
                    //},
                    onClose: function (event) {
                        var stateManager = fpUi.router.stateManager;
                        stateManager.go(stateManager.current, {
                            modal: null,
                            modal_action_id: null
                        }, {preventDefault: true, inherit: true});
                    }
                });
            }
        }
        ,showPopUpModal: function(options, name) {
            if(options.trigger) {
                var currentHref = window.location.href,
                    disableClose = S(name).contains('age'),
                    modalName = name + '_modal',
                    buttons = [{
                        title: fpUi.locale('shared-submit', 'Submit'),
                        className: 'fp-btn-submit',
                        action: 'submit-modal-fields'
                    }],
                    hideModal = true;

                if(!disableClose) {
                    buttons.push({title: fpUi.locale('shared-cancel', 'Cancel'),
                        action: 'cancel',
                        className: 'fp-btn-cancel'
                    });
                }

                if(currentHref.match(options.trigger)) {
                    const cookieName = `fp-popup-${name}`,
                        popUpCookie = fp.getCookie(cookieName),
                        saveValues = [],
                        savedValues = _.filter(popUpCookie, function (item) {
                            return item?.pop_up === name;
                        });

                    if(_.size(savedValues)) {
                        _.each(options.fields, function(key) {
                            var answeredQuestion = _.findWhere(savedValues, {'identifier': key.identifier});
                            if(!answeredQuestion && hideModal) hideModal = false;
                        });
                    }
                    else hideModal = false;


                    if(hideModal) {
                        fp.ui.displayPopUpModal(savedValues, options);
                    }
                    else {
                        fp.ui.closeActiveModal();
                        
                        const $modal = fpUi.showModal({
                            name: modalName,
                            template: 'component/0/modal.html',
                            className: 'fp-popup-modal' + modalName,
                            title: options.title,
                            disableClose: disableClose,
                            content: fp.ui.renderTemplate('component/0/animated-loading.html'),
                            buttons: buttons
                        })
                        .on('shown.bs.modal.popUpModal', function () {
                            const defaultModalContent = fpUi.renderTemplate('component/0/modal-fields.html', {config: options, fields: options.fields }),
                                $modalContent = $modal.find('[data-role="modal-content"]');

                            $modalContent.html(defaultModalContent).find('[data-role="animated-loading"]').remove();
                        })
                        .on('click', '[data-action="submit-modal-fields"]', function(event) {
                            if(!fp.util.validateForm($modal.find('form[name="fp-modal-fields"]'))) return;

                            $modal.find('input').each(function(event) {
                                var $input = $(this);

                                if($input.attr('checked') == "checked" || $input.attr('radio') == "checked") {
                                    saveValues.push({
                                        pop_up: name,
                                        identifier: $input.attr('name').replace('input-', ''),
                                        value: $input.attr('data-value')
                                    });
                                }

                                if($input.attr('type') === 'text') {
                                    saveValues.push({
                                        pop_up: name,
                                        identifier: $input.attr('name').replace('fp-input-', ''),
                                        value: $input.val()
                                    });
                                }
                            });

                            fp.setCookie(cookieName, saveValues, fpUtil.getInteger(options.cookie_expires, 365));

                            fpUi.displayPopUpModal(saveValues, options);
                        })
                        .on('change', 'input[type="radio"]', function(event) {
                            var $input = $(this);
                            $input.siblings().attr('checked', false);
                            $input.attr('checked', true);
                        });
                    }
                }
            }
        }
        ,displayPopUpModal: function(popUpModalCookieValues, options) {
            var viewPage = true;
            if(!popUpModalCookieValues) return viewPage;

            _.each(popUpModalCookieValues, function(saveValue) {
                if(saveValue.identifier == 'age' && saveValue.value == 'no') viewPage = false;
            });

            if(viewPage) fp.ui.closeActiveModal();
            else {
                if(options.trigger_false) window.location.href = options.trigger_false;
                else window.location.href = fpConfig.urls.shopping;
            }
        }
        ,showRewardProductModal: function(gift, options) {
            if(!(gift && gift.id)) return;

            options = _.getObject(options);

            var $introContent = $(fpUi.renderTemplate('component/0/reward-redemption-options-product-highlight.html', {item: gift}, null, true));

            if(options.error) {
                fpUtil.showError(options.error, $introContent.find('[data-role="notification"]'), {fadeOutMs: 10000, handleScroll: false});
            }

            var stateManager = fpUi.router.stateManager,
                productIds = gift.product_ids;

            fp.trigger(fp.events.PRODUCTS_MODAL_SHOW, {
                title: productIds ? 'Reward Details' : gift.name,
                productIds: productIds,
                allowGenericItem: false,
                disableNoProductsFound: true,
                introContent: $introContent,
                mode:'search'
            });

            stateManager.go(stateManager.current, {gift_id: gift.id}, {preventDefault: true, inherit: true});

            fp.$productsModal
                .one('hidden.bs.modal', function() {
                    stateManager.go(stateManager.current, {gift_id: null}, {preventDefault: true, inherit: true});
                });
        }
        ,postMetric: function(duration, apiTotalDuration, apiSumDuration, apiCallTotalCount, viewModuleDuration) {
            //removeIf(!debug)

            var enablePostMetric = fpUi.router.routeManager.urlParams.enable_post_metric == 'true';
            if(!fp.isProd() && !enablePostMetric) {
                fp.log(fpUtil.formatString('Total API Call Count: {0}', apiCallTotalCount));
                fp.log(fpUtil.formatString('Sum of API Durations: {0}s (sum of time spent making API calls)', apiSumDuration));
                fp.log(fpUtil.formatString('Total API Duration: {0}s (time between start of first API call and end of last API call)', apiTotalDuration));
                if(viewModuleDuration) fp.log(fpUtil.formatString('UI View Module Metric: {0}s', viewModuleDuration));
                fp.log(fpUtil.formatString('UI Load Metric: {0}s', duration));
                return;
            }

            //endRemoveIf(!debug)

            fpService.metricService
                .post({
                    url: window.location.href,
                    store_id: fp.store.id,
                    duration: duration,
                    view_module_duration: fpUtil.getUndefinedIfEmpty(viewModuleDuration),
                    api_total_duration: apiTotalDuration,
                    api_sum_duration: apiSumDuration,
                    api_call_total_count: apiCallTotalCount,
                    pretty: undefined
                }, {
                    childServiceCall: 'page_load' + (fp.isProd() && !enablePostMetric ? '' : '?view_module_duration=' + viewModuleDuration),
                    handleErrors: false,
                    ignoreErrors: true
                });
        }
        ,initGoogleMapApi: function(storeId, libraries, timeout, intent) {
            if(!intent) intent = fpConfig.intent;
            if(fpConfig.intent != 'admin' && !_.contains(['location_map', 'location_autocomplete'], intent)) {
                return $.when();
            }

            if (fpUtil.isNull(libraries)) libraries = 'places';
            if (libraries) libraries = '&libraries=' + libraries;

            var $gmApiScript;
            if(this.__deferredGmApi && this.__deferredGmApi.__libriaries == libraries) {
                return this.__deferredGmApi.promise();
            }
            else {
                $gmApiScript = $(document.head).find('script[data-role^="gm-api-"]');
                if($gmApiScript.length && (!libraries || S($gmApiScript.attr('src')).contains(libraries))) {
                    return $.when();
                }
            }

            var self = this,
                callbackKey = '_gmApi',
                googleApiKey;

            //check to see if loaded google.maps.Geocoder object has a non-noop function signature
            //if(!this.__hasGoogleMaps && fpUtil.getValueFromNamespace('google.maps', window)) {
            //    try {
            //        this.__hasGoogleMaps = (new google.maps.Geocoder()).geocode.toString() == $.noop.toString();
            //        if(!this.__hasGoogleMaps) delete window.google.maps;
            //    }
            //    catch(exc){}
            //}


            //if there is an existing google.maps object delete it as we will load using Freshop's API key
            if(fpUtil.getValueFromNamespace('google.maps', window)) delete window.google.maps;

            this.__deferredGmApi = $.Deferred();
            this.__deferredGmApi.__libriaries = libraries;

            if(!storeId) storeId = fp.store.id;
            if(storeId || intent != 'admin') {
                var serviceProviderType = _.contains(['location_map', 'location_autocomplete'], intent) ? intent : 'location';
                fpUtil.map.load({
                    service: fpService.serviceProviderConfigurationService,
                    payload: {
                        store_id: storeId,
                        service_provider_type: serviceProviderType
                    }
                })
                .done(function () {
                    googleApiKey = fpUtil.getValueFromNamespace('config.public_api_key', fpUtil.map.get(fp.S('spc_' + serviceProviderType).camelize().s).items()[0]);
                    if (googleApiKey) {
                        window[callbackKey] = function () {
                            //self.__hasGoogleMaps = true;
                            clearTimeout(self.__gmApiTimeoutId);
                            if (self.__deferredGmApi) self.__deferredGmApi.resolve();
                        };

                        //give Google Maps API script 3s to load
                        clearTimeout(self.__gmApiTimeoutId);

                        timeout = fpUtil.getInteger(timeout, 3000);
                        if (timeout > 0) self.__gmApiTimeoutId = _.delay(window[callbackKey], timeout);

                        fpUi.loadScript(fpUtil.formatString('https://maps.googleapis.com/maps/api/js?key={0}{1}&callback={2}',
                            googleApiKey,
                            libraries,
                            callbackKey), {
                            'data-role': 'gm-api-' + $gmApiScript.length
                        });

                        //$('head').append(fpUtil.formatString(
                        //    '<script data-role="gm-api" type="text/javascript" src="https://maps.googleapis.com/maps/api/js?key={0}{1}&callback={2}"></script>',
                        //    googleApiKey,
                        //    libraries,
                        //    callbackKey)
                        //);
                    }
                    else if (self.__deferredGmApi) {
                        // var error = fpUtil.formatString('config.public_api_key not found for store_id "{0}".', storeId);
                        //if (fpConfig.intent == 'admin') {
                        //    self.__deferredGmApi.reject({
                        //        error: error
                        //    });
                        //}
                        //else self.__deferredGmApi.resolve();

                        self.__deferredGmApi.resolve();

                        // fp.notifier.notify({
                        //     name: 'GoogleMapApiWarning',
                        //     message: fpUtil.formatString('GoogleMapApiWarning: {0}', error)
                        // }, {
                        //     severity: 'warning'
                        // });
                    }
                });
            }
            else self.__deferredGmApi.resolve();

        return this.__deferredGmApi
            .promise()
            .always(function() {
                clearTimeout(self.__gmApiTimeoutId);
                delete self.__gmApiTimeoutId;
                delete self.__deferredGmApi;
            });
        }
        ,getMarkerLabel: function(options) {
            var gmapsNS = fpUtil.getValueFromNamespace('google.maps', window);
            if(!gmapsNS) return;

            if(!this.MarkerLabel) {
                function MarkerLabel(options) {
                    this.options = options;
                    this.setMap(options.map);
                }
                this.MarkerLabel = MarkerLabel;

                MarkerLabel.prototype = new gmapsNS.OverlayView();
                MarkerLabel.prototype.draw = function () {
                    if (!this.$element) {
                        this.$element = $(fpUtil.formatString(' \
                            <div class="fp-icon fp-icon-map-marker{2}" data-id="{0}"> \
                                <span class="fp-badge-icon">{1}</span> \
                            </div>',
                            this.options.id,
                            this.options.text,
                            this.options.className
                        ));

                        this.getPanes().overlayImage.appendChild(this.$element[0]);

                        self = this;
                        gmapsNS.event.addDomListener(this.$element[0], 'click', function(event) {
                            event.preventDefault();
                            event.stopImmediatePropagation();

                            if(_.isFunction(self.options.clickHandler)) {
                                self.options.clickHandler(event)
                            }
                        });
                    }

                    this.setPosition(this.options.position);
                };

                MarkerLabel.prototype.remove = function () {
                    if (!this.$element) return;

                    this.$element.remove();
                    delete this.$element;
                };

                MarkerLabel.prototype.getPosition = function () {
                    return this.options.position;
                };

                MarkerLabel.prototype.setPosition = function (position) {
                    if(!this.$element) return;

                    var point = this.getProjection().fromLatLngToDivPixel(position);

                    if (point) {
                        this.$element
                            .css({
                                display: 'block',
                                top: point.y - this.$element.height(),
                                left: point.x - this.$element.width() * 0.5
                            });
                    }
                    else {
                        this.$element.hide();
                    }

                    this.options.position = position;
                };
            }

            return new this.MarkerLabel(options);
        }
        ,initMapBoxApi: function() {
            if(fpUtil.getValueFromNamespace('mapboxgl', window)) return $.when();
            if(this.__promiseMbApi) return this.__promiseMbApi;

            this.__promiseMbApi = fpUi.loadScript('https://api.mapbox.com/mapbox-gl-js/v0.54.0/mapbox-gl.js', {'data-role': 'mb-api'});

            return this.__promiseMbApi
                .always(function() {
                    delete fpUi.__promiseMbApi;
                });
        }
        ,getAssetCdnUrl: function(url, options) {
            options = _.getObject(options);
            var temp = S(url),
                imageConfig = _.getObject(options.imageConfig, fp.store.image_config),
                hasExt = temp.contains('.jpg') || temp.contains('.png'),
                size = options.size,
                origSize;

            if(imageConfig.prefix && !temp.startsWith('http', true)) url = imageConfig.prefix + url;
            if(!temp.startsWith('http://localhost') && fpUtil.getBoolean(options.enableImageOptimization, fpConfig.enableImageOptimization)) {
                var type = options.type;
                if(!type && imageConfig == fp.store.circular_pdf_config) type = 'circular';

                if(hasExt) {
                    _.find(imageConfig.suffixes, function(value, key) {
                        if(temp.endsWith(value, true)) {
                            url = url.replace(value, '');
                            if(!size) size = key;
                            hasExt = false;
                            return true;
                        }
                    });
                }

                if(!_.isObject(size)) {
                    origSize = size;
                    //convert medium -> md, etc
                    size = fpConfig.imageSizes.map[size || 'medium'];
                    if (!_.has(fpConfig.imageSizes, type)) type = 'product';
                    size = {
                        width: fpConfig.imageSizes[type][size]
                    };
                }
                else origSize = 'medium';

                if(options.otherAttributes && (size.width || size.height)) {
                    if(size.width && options.otherAttributes.width < size.width) {
                        size.width = options.otherAttributes.width;
                        if(size.height) size.height = options.otherAttributes.height;
                    }
                    else if(size.height && options.otherAttributes.height < size.height) {
                        size.height = options.otherAttributes.height;
                        if(size.width) size.width = options.otherAttributes.width;
                    }
                }

                var width = size.width ? '&width=' + size.width : '',
                    height = size.height ? '&height=' + size.height : '';

                if(temp.startsWith('http') && (temp.contains('width') || temp.contains('height'))) {
                    url = url.replace(/&width=\d+/, width);
                    url = url.replace(/&height=\d+/, height);
                }
                else if(hasExt || imageConfig.suffixes) {
                    var assetCdnImageUrl = fp.assetCdnImageUrl,
                        enableWebp = fp.hasWebp && options.type !== 'jpeg',
                        suffix = options.otherAttributes?.suffix || (options.otherAttributes ? 'original' : 'large');

                    if(!options.otherAttributes && (type == 'circular' || imageConfig == fp.store.circular_pdf_config)) {
                        assetCdnImageUrl += 'convert';
                        width = height = '';
                    }
                    else assetCdnImageUrl += 'resize';

                    var imageQuality;
                    if(enableWebp) {
                        if(type == 'product') {
                            var placeHolder = fp.productConfigurationConfig.place_holder_cover_image;
                            if(placeHolder && placeHolder.default_s3_key == temp.s) {
                                imageQuality = placeHolder.quality;
                            }
                        }
                        if(!imageQuality) {
                            imageQuality = fpConfig.imageQuality[type + '_' + origSize] || fpConfig.imageQuality[type] || 40;
                        }
                    }
                    else imageQuality = 90;

                    url = assetCdnImageUrl + '?url=' +
                        url + (hasExt ? '' : imageConfig.suffixes[suffix]) +
                        width +
                        height +
                        '&type=' + (enableWebp ? 'webp' : 'jpeg') +
                        '&quality=' + imageQuality;
                }
            }
            else if(!hasExt && imageConfig.suffixes) {
                size = S.getString(size, 'medium');
                url += imageConfig.suffixes[size];
            }
                
            return url;
        }
        ,bindAddressAutoComplete: function($container, selector, options) {
            if(!fpConfig.enableAddressTypeahead) return;

            if (_.isFunction(options)) {
                options = {
                    callback: options
                };
            }
            else options = _.getObject(options);

            _.defaults(options, {intent: 'location_autocomplete'});

            $container = $($container);
            selector = S.getString(selector, '[name="fp-input-{0}"]');

            //fp.log(fpUtil.formatString(selector, 'address_1'));
            var $address = $container.find(fpUtil.formatString(selector, 'address_1'));
            if(!$address.length) return;

            var prevQuery,
                lastQuery,
                lastAyncResults,
                $country = $container.find(fpUtil.formatString(selector, 'country')),
                typeaheadSource = function (query, syncResults, asyncResults, isIdle) {
                    lastQuery = query;
                    lastAyncResults = asyncResults;

                    if(!isIdle) return;
                    if(S(query).eq(prevQuery)) return;

                    var countryCode = S($country.val()).trim().s,
                        queryResults;

                    countryCode = (countryCode.length == 2 && countryCode) || (_.has(options, 'countryCode') && options.countryCode) || fpConfig.countryCode;

                    prevQuery = query;
                    fpService.locationService
                        .get({
                                address: query
                            }, {
                            places: true,
                            types: options.types,
                            countryCode: countryCode,
                            intent: options.intent
                        })
                        .done(function (resp) {
                            queryResults = resp;
                        })
                        .always(function () {
                            asyncResults(queryResults);
                        });
                };

            if(!options.enableMaxLength) {
                $address.removeAttr('maxlength');
            }

            $address
                .attr('autocomplete', 'off')
                .off('keypress.typeahead typeahead:open typeahead:close typeahead:select')
                .on('keypress.typeahead', function(event) {
                    if(event.keyCode == fp.constants.keycode.RETURN) {
                        $(this).typeahead('close');
                    }
                })
                .on('typeahead:open', function(event) {
                    $address.parent().addClass('fp-tt-wrapper-open');
                })
                .on('typeahead:close', function(event) {
                    prevQuery = lastQuery = lastAyncResults = null;
                    $address.parent().removeClass('fp-tt-wrapper-open');
                })
                .on('typeahead:select', function(event, item, dataSetName) {
                    var place,
                        promisePlace;

                    if(item && item.place_id) {
                        promisePlace = fpService.locationService
                            .get({
                                placeId: item.place_id
                            }, {
                                places: true,
                                intent: options.intent
                            });
                    }

                    $.when(promisePlace)
                        .done(function (resp) {
                            place = _.firstObject(resp);
                        })
                        .always(function () {
                            if(!options.disableApplyPlaceAddress) {
                                fpUi.applyPlaceAddress($container, selector, place);
                            }

                            if(_.isFunction(options.callback)) options.callback(place);
                        });
                })
                .idle('destroy')
                .idle({
                    onIdle: function(){
                        if(!lastQuery) return;
                        typeaheadSource(lastQuery, null, lastAyncResults, true);
                    },
                    idle: 300
                })
                .typeahead({
                    minLength: fpUtil.getInteger(fpUtil.getValueFromNamespace('config.min_length', fpUtil.map.get('spcLocationAutocomplete').items()[0]), 3),
                    highlight: true,
                    limit: 5,
                    hint: false,
                    classNames: {
                        wrapper: 'fp-typeahead-wrapper',
                        menu: 'fp-dropdown-menu',
                        dataset: 'fp-dropdown-list',
                        suggestion: 'fp-dropdown-list-item',
                        input: 'fp-tt-input',
                        hint: 'fp-tt-hint',
                        selectable: 'fp-tt-selectable',
                        empty: 'fp-tt-empty',
                        open: 'fp-tt-open',
                        cursor: 'fp-tt-cursor',
                        highlight: 'fp-tt-highlight'
                    }
                }, {
                    display: function(item) {
                        return item.description;
                    },
                    templates: {
                        suggestion: function(item) {
                            //fp.log('item', item);
                            return fpUtil.formatString(
                                '<div><a href="javascript:;" class="fp-tt-q" data-place-id="{0}"><span class="fp-icon fp-icon-map-marker"></span><span class="fp-tt-value">{1}</span></a></div>',
                                item.place_id,
                                item.description
                            );
                        }
                    },
                    source: typeaheadSource
                });

            $address
                .prev('.fp-tt-hint')
                .removeAttr('fp-validate fp-autofocus');
        }
        ,applyPlaceAddress: function($container, selector, place) {
            $container = $($container);
            selector = S.getString(selector, '[name="fp-input-{0}"]');
            //fp.log('place', place);

            var $address = $container.find(fpUtil.formatString(selector, 'address_1'));
            if(!$address.length) return;

            var address = this.getAddressFromPlace(place),
                address1 = S.getString(address.address_1),
                typeahead = $address.data('tt-typeahead'),
                $changedInputs = [],
                $input,
                oldValue,
                value,
                dropdown,
                event,
                prevEvent;

            //fp.log('place', place);
            //fp.log('address', $.extend({}, address));
            //fp.log('address1', '|' + address1 + '|' + $address.val() + '|');

            _.each(['country', 'address_2', 'city', 'state', 'postal_code'], function(key) {
                $input = $container.find(fpUtil.formatString(selector, key));
                if(!$input.length) return;

                if(key == 'country' && S($input.prop('nodeName')).eq('select', true)) {
                    value = S(address.country_abbreviation).toLowerCase().s;
                }
                else value = S.getString(address[key]);

                oldValue = $input.val();
                $input.val(value);
                //fp.log(key, '|' + value + '|' + oldValue + '|');
                if(value != oldValue) {
                    $changedInputs.push($input);

                    if($input.parent().hasClass('fp-dropdown')) {
                        //until we switch to utilize select2 we need to specifically call setValue for dropdowns
                        dropdown = $input.parent().data('fp.ui.Component');
                        if(dropdown) dropdown.setValue(value);
                    }
                }
            });

            $address.val(address1);
            if(typeahead) typeahead.input.query = address1;

            _.each($changedInputs, function($input) {
                event = $.Event('change');

                if(!prevEvent) prevEvent = event;
                event.handled = prevEvent.handled;

                $input.trigger(event);

            });

        }
        ,getAddressFromPlace: function(place) {
            var address = {},
                formattedAddress = '',
                street = '',
                streetNumber = '',
                premise,
                city,
                neighborhood,
                subLocality;

            if(place) {
                formattedAddress = S(place.formatted_address);
                _.each(place && place.address_components, function (item) {
                    switch (item.types[0]) {
                        case 'street_number':
                            streetNumber = item.long_name;
                            break;
                        case 'premise':
                            premise = item.long_name;
                            break;
                        case 'route':
                            street = item.long_name;
                            break;
                        case 'neighborhood':
                            neighborhood = item.long_name;
                            break;
                        case 'locality':
                            city = item.long_name;
                            break;
                        case 'administrative_area_level_1':
                            address.state = item.short_name;
                            break;
                        case 'postal_code':
                            address.postal_code = item.long_name;
                            break;
                        case 'country':
                            address.country = item.long_name;
                            address.country_abbreviation = item.short_name;
                            break;
                        //no default
                    }

                    switch (item.types[2]) {
                        case 'sublocality_level_1':
                            subLocality = item.long_name;
                            break;
                        //no default
                    }
                });

                if(neighborhood && formattedAddress.contains(' ' + neighborhood, true)) {
                    city = neighborhood;
                }
            }

            address.city = S.getString(city || subLocality);
            address.address_1 = S(streetNumber).append(' ' + street).trim().getString(premise).s;

            return address;
        }
        ,getCenterLatLng: function(items) {
            var center = {
                    minLat: null,
                    maxLat: null,
                    minLng: null,
                    maxLng: null
                },
                lat,
                lng;

            _.each(items, function(item) {
                lat = item.lat || item.latitude;
                lng = item.lng || item.longitude;

                if(fpUtil.isNull(lat) || fpUtil.isNull(lng)) return;

                center.minLat = Math.min(center.minLat != null ? center.minLat : lat, lat);
                center.maxLat = Math.max(center.maxLat != null ? center.maxLat : lat, lat);
                center.minLng = Math.min(center.minLng != null ? center.minLng : lng, lng);
                center.maxLng = Math.max(center.maxLng != null ? center.maxLng : lng, lng);
            });

            _.each(center, function(value, key) {
                center[key] = (value != null) ? value : 0;
            });

            center.lat = center.minLat + (center.maxLat - center.minLat) * 0.5;
            center.lng = center.minLng + (center.maxLng - center.minLng) * 0.5;

            return center;
        }
        ,setZoomAndCenterLatLng: function(mapOptions, items) {
            var gmapsNS = fpUtil.getValueFromNamespace('google.maps', window);
            if(!gmapsNS) return;

            var center = this.getCenterLatLng(items);

            if(center.minLat && center.minLng && center.maxLat && center.maxLng) {
                mapOptions.zoom = this.getMapZoom(center);
                mapOptions.center = new gmapsNS.LatLng(center.lat, center.lng);
            }
        },
        getMapZoom: function(center) {
            var zoom = 5,
                miles = (
                    3958.75 * Math.acos(Math.sin(center.minLat / 57.2958)
                    * Math.sin(center.maxLat / 57.2958) + Math.cos(center.minLat / 57.2958)
                    * Math.cos(center.maxLat / 57.2958)
                    * Math.cos(center.maxLng / 57.2958 - center.minLng / 57.2958))
                );

            if(miles < 0.2) zoom = 16;
            else if(miles < 0.5) zoom = 15;
            else if(miles < 1) zoom = 14;
            else if(miles < 2) zoom = 13;
            else if(miles < 3) zoom = 12;
            else if(miles < 7) zoom = 11;
            else if(miles < 15) zoom = 10;
            else if(miles < 50) zoom = 9;
            else if(miles < 100) zoom = 8;
            else if(miles < 200) zoom = 7;
            else if(miles < 400) zoom = 6;
            else if(miles < 500) zoom = 5;
            else if(miles < 600) zoom = 4;
            else if(miles < 3000) zoom = 3;

            return zoom;
        },
        loadScript: function(src, attrs, props, options) {
            options = _.getObject(options);

            var deferred = $.Deferred(),
                promise = deferred.promise(),
                $element;

            if(options.type == 'css') {
                if(fp.bowser.msie && fp.bowser.version == 10) {
                    return fp.api(
                        src,
                        null,
                        $.extend({
                            dataType: 'text',
                            apiKey: null,
                            cache: true
                        }, _.defaults(options.apiOptions, {ignoreErrors: true}))
                    )
                    .then(function (data) {
                        $element = $(fpUtil.formatString('<style type="text/css">{0}</style>', data));

                        if(options.insertBefore) $element.insertBefore(options.insertBefore);
                        else if(options.insertAfter) $element.insertAfter(options.insertAfter);
                        else $element.appendTo($('head')[0]);

                        if(attrs) delete attrs.crossorigin;

                        $element
                            .attr(_.getObject(attrs))
                            .prop(_.getObject(props));
                    });
                }
                else {
                    $element = $('<link rel="stylesheet" type="text/css">');
                    props = $.extend({
                        href: src
                    }, props);

                    promise = promise
                        .then(function() {
                            fpUi.processStyleSheets();
                        });
                }
            }
            else {
                $element = $('<script></script>');
                props = $.extend({
                    async: true,
                    src: src
                }, props);

                attrs = $.extend({
                    type: 'text/javascript'
                }, attrs);
            }

            if(options.insertBefore) $element.insertBefore(options.insertBefore);
            else if(options.insertAfter) $element.insertAfter(options.insertAfter);
            else $element.appendTo($('head')[0]);

            $element
                .attr(_.getObject(attrs))
                .prop(props);

            $element[0].onload = deferred.resolve;
            $element[0].onerror = deferred.reject;

            return promise;
        },
        generateFreshopPlugin: function(name, constructor, ns) {
            $.fn[name] = function (options, template, parent) {
                var $this,
                    item,
                    config;

                return this.each(function () {
                    $this = $(this);
                    item = $this.data(ns);

                    if (item) item.destroy();

                    config = $.extend(true, {autoInit: true}, constructor.defaults, options);
                    item = new constructor($this, config, template, parent);
                    if(config.autoInit) item.init(config.autoRender);

                    $this.data('fp.ui.Component', item);
                });
            };
        },
        renderModules: function(selector, pageChanged) {
            var promise;

            if(selector) {
                var $parent = $(selector);
                if($parent.length) {
                    fpUi.preInitModules(fpConfig.modules, $parent);
                    promise = fpUi.loadModules(fpConfig.modules, $parent, pageChanged);
                }
            }

            return $.when(promise);
        },
        changePage: function(selector) {
            fp.trigger(fp.events.PAGE_CHANGE);

            return $.when(this.renderModules(selector, true))
                .always(function() {
                    fp.trigger(fp.events.PAGE_CHANGED);
                });
        },
        locale: function(key, defaultValue) {
            key = S.getString(key);
            var value;
            if(key && $.i18n) {
                value = $.i18n(key);
                if (value === key) value = null;
            }
            return value || defaultValue;
        },
        localef: function(key, defaultValue) {
            var value = this.locale(key, defaultValue),
                matchToken = /{[^}]*}|\[[^\]]*\]/,
                placeholder;

            _.each(_.toArray(arguments).slice(2), function(item) {
                item = S.getString(item);
                placeholder = _.first(matchToken.exec(value));
                if(placeholder) {
                    if (placeholder.charAt(0) == '[') {
                        value = value.replace(placeholder, item + placeholder.substr(1, placeholder.length - 2) + '</a>');
                    }
                    else {
                        value = value.replace(placeholder, item);
                    }
                }
            });

            return value;
        },
        processRouteIntent: function(urlParams) {
            var promise;
            if(!fpConfig.disableInitializeShopping) {
                if(!_.isObject(urlParams)) urlParams = fpUi.router.routeManager.urlParams;

                switch(urlParams.action) {
                    case 'addToCart':
                        if(fp.loaded && urlParams.reference_id) {
                            promise = fpService.productService
                                .get({
                                    reference_id: urlParams.reference_id,
                                    fields: fp.productFields
                                })
                                .then(function(resp) {
                                    if(_.size(resp.items)) {
                                        if(urlParams.quantity){
                                            var listQuantities = urlParams.quantity.split(','),
                                                hashedItems = _.indexBy(resp.items, 'reference_id'),
                                                item;

                                            _.each(urlParams.reference_id.split(','), function(key, index) {
                                                item = hashedItems[key];
                                                if(item) item.__product_quantity = fpUtil.getFloat(listQuantities[index]);
                                            });
                                        }

                                        if(urlParams.redirect == 'checkout') {
                                            var promises = [];
                                            _.each(resp.items, function (item) {
                                                promises.push(fp.listManager.listItemAdd(null, {item: item}));
                                            });

                                            return $.when.apply($, promises)
                                                .then(function() {
                                                    return fp.listManager.getSelectedList(true)
                                                        .then(function () {
                                                            fp.trigger(fp.events.LIST_CHECKOUT, {
                                                                listManager: fp.listManager,
                                                                selectedList: fp.listManager.selectedList
                                                            });

                                                            if(urlParams.action_redirect == 'checkout') {
                                                                stateManager.go(states.checkout, null, {reload: true});
                                                            }
                                                        });
                                                });
                                        }
                                        else {
                                            fp.trigger(fp.events.PRODUCTS_MODAL_SHOW, {
                                                title: urlParams.title ? urlParams.title : "Please select which products you'd like to add",
                                                products: resp.items,
                                                enableAddAll: true,
                                                mode:'search'
                                            });
                                        }
                                    }
                                });
                        }
                        break;
                    case 'add-to-list':
                        if(!fp.loaded && urlParams.action_redirect && urlParams.action_product_id) {
                            //add to list
                            var product = fpUtil.getProduct(fp.listManager.getItem(urlParams.action_product_id, true)),
                                stateManager = fpUi.router.stateManager,
                                states = stateManager.states;

                            if(!_.size(product)) {
                                promise = fpService.productService
                                    .get({
                                        id: urlParams.action_product_id
                                    }, {
                                        handleErrors: false
                                    });
                            }

                            promise = $.when(promise)
                                .then(function (resp) {
                                    var products = _.size(product) ? [product] : resp && resp.items,
                                        promises = [];
                                    _.each(products, function (item) {
                                        promises.push(fp.listManager.listItemAdd(null, {item: item}));
                                    });

                                    return  $.when.apply($, promises);
                                })
                                .then(function () {
                                    if(urlParams.action_redirect == 'checkout') {
                                        return fp.listManager.getSelectedList(true)
                                            .then(function () {
                                                fp.trigger(fp.events.LIST_CHECKOUT, {
                                                    listManager: fp.listManager,
                                                    selectedList: fp.listManager.selectedList
                                                });

                                                if(urlParams.action_redirect == 'checkout') {
                                                    stateManager.go(states.checkout, null, {reload: true});
                                                }
                                            });
                                    }
                                });
                        }
                        break;
                    //no default
                }
            }

            return $.when(promise);
        },
        setFulfillmentType: function(identifier, enableReset) {
            if(identifier || enableReset) {
                var oldFulfillmentTypeId = fpUi.getPreference('fulfillmentTypeId'),
                    fulfillmentTypeId = oldFulfillmentTypeId,
                    fulfillmentType;
                return fpUtil.map.load(fpService.fulfillmentTypeService)
                    .then(function() {
                        fulfillmentType = fpUtil.map.get('fulfillmentType', null, true).get(identifier);
                        fulfillmentTypeId = fulfillmentType.id;
                        if(fulfillmentTypeId || enableReset) {
                            var preference = {
                                fulfillmentTypeId: fulfillmentTypeId
                            };

                            fp.setPrefCookie(preference);

                            return fpService.preferenceService
                                .update(preference);
                        }

                        return $.Deferred().reject('Invalid fulfillment type').promise();
                    })
                    .then(function() {
                        if(fulfillmentType && fulfillmentType.id) return fulfillmentType;
                    })
                    .done(function() {
                        if(S(fulfillmentTypeId).ne(oldFulfillmentTypeId)) {
                            fp.trigger(fp.events.FULFILLMENT_TYPE_CHANGED);
                        }
                    });
            }

            return $.Deferred().reject('Invalid fulfillment type').promise();
        },
        getPreference: function(key) {
            var value,
                fallback;

            if(key == 'fulfillmentTypeId') {
                value = fp.session.order_fulfillment_type_id;
                fallback = fp.user.preferred_fulfillment_type_id
            }
            return value || fp.getPrefCookie()[key] || fp.session.preference[key] || fp.user.preference[key] || fallback;
        },
        triggerMfa: function(options) {
            let deferred;

            if(options?.intent || fp.user.mfa_mode === 'required') {
                let mfaModule = fp.Module.get('mfa'),
                    promise;
                deferred = $.Deferred();
                if(!mfaModule) {
                    promise = fpUi.loadModule($.extend(options, {
                        elementSelector: $('<div id="fp-mfa"></div>').appendTo(fp.__$freshop),
                        name: 'mfa'
                    }))
                    .then(function (module) {
                        mfaModule = module;
                    });
                }

                promise = $.when(promise)
                    .then(function () {
                        mfaModule.config.mode = options?.mode;
                        mfaModule.config.intent = options?.intent;
                        return mfaModule.init();
                    })
                    .then(deferred.resolve, deferred.reject);
            }
            return $.when(deferred);
        },
        applyErrorMeta: function(report, error) {
            var uiLocation = fpUi.router.location;
            report.metaData = _.getObject(report.metaData);
            metaData = report.metaData['meta data'] = _.getObject(report.metaData['meta data']);
            metaData.deploy_id = fp.deployId;
            metaData.utc = fpUtil.formatDate(dateFns.utc(), 'MM/DD/YYYY h:mm:ss.SS a');
            metaData['Base Url'] = uiLocation.origin() + uiLocation.pathname();
            metaData['Referrer'] = window.document.referrer;

            if(error && _.isObject(error.__metaData)) {
                $.extend(metaData, error.__metaData);
                delete error.__metaData;
            }
        },
        getMobilePhoneHtml: function(value) {
            if(_.isString(value) && !/<a\s.*?href=["']tel:/gim.test(value)) {
                var matchPhone = fpUtil.regExp.matchPhone,
                    matchNumeric = fpUtil.regExp.matchNumeric,
                    formatString = fpUtil.formatString,
                    template = '<a href="tel:{0}">{1}</a>';
                matchPhone.lastIndex = 0;
                value = value.replace(matchPhone, function(match) {
                    matchNumeric.lastIndex = 0;
                    return formatString(template, match.match(matchNumeric).join(''), match);
                });
            }
            return value;
        },
        getYouTubeEmbedUrl: function(url) {
            var match = _.isString(url) && url.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/),
                value;
            if(match && match[2].length == 11) {
                value = fpUtil.formatString('https://www.youtube.com/embed/{0}', match[2]);
            }
            return value;
        },
        intializeToolTip: function($popOver, options) {
            if(!$popOver && options) return;

            if($popOver.length) {
                $popOver.popover({
                    html: true,
                    placement: options.placement,
                    trigger: options.trigger || 'manual',
                    content: options.content,
                    template: '<div class="popover fp-popover-product-info fp-popover-disclaimer ' + options.className + '"><div class="arrow"></div><div class="popover-content"></div></div>',
                    animation: false,
                    clickableContent: fpUtil.getBoolean(options.clickableContent, true)
                })
                .on('show.bs.popover', function(event) {
                    //small/touch devices do not get popovers
                    if(fp.device.xs || fp.device.hasTouch) event.preventDefault();
                });

                if(fp.device.xs || fp.device.hasTouch) {
                   $popOver
                       .on('click', function (event) {
                            fpUi.showModal({
                                name: 'information-modal',
                                template: 'component/0/modal.html',
                                className: 'fp-confirm-modal fp-information-modal',
                                title: options.title,
                                content: options.content
                            });
                        });
                }
            }
        },
        handleApiResponseModal: function (modalContent, type, config) {
            var modalOptions = {
                name: 'reward-modal',
                template: 'component/0/modal.html',
                className: "fp-reward-response-modal",
                title: modalContent.title,
                content: fp.markdownConverter.makeHtml(modalContent.body_md),
                buttons: [modalContent.button_label]
            };

            if(config && config.modalSuccessPreventBodyClick && type == 'success')  modalOptions.modal = { backdrop: 'static', keyboard: false };

            fpUi.showModal(modalOptions)
                .on('click', '[data-action="confirm"]', function (event) {
                    event.preventDefault();

                    if(modalContent.button_url != 'close') {
                        window.location.href = modalContent.button_url;
                    }
                    else fpUi.closeActiveModal();
                });
        },
        initSiteUrls: function(storeId, options) {
            var promise;

            if(!storeId && fpConfig.intent != 'admin') storeId = fp.store.id;
            if(storeId) {
                promise = fpService.serviceProviderConfigurationService
                    .get({
                        service_provider_type: 'store_setting',
                        service_provider: 'site_url',
                        store_id: storeId,
                        store_id_cascade: options?.storeIdCascade,
                        store_id_rollup: true,
                        as_of_date: undefined //explicitly set as_of_date as js api will auto add from state param
                    }, {ignoreErrors: true})
                    .then(function (resp) {
                        var siteUrls = fp.cache.hashedStoreSettings.siteUrls,
                            siteConfig,
                            shoppingUrlPath;

                        _.each(resp.items, function (item) {
                            if (_.isObject(item.config)) {
                                siteConfig = siteUrls[item.store_id] = _.getObject(item.config);

                                shoppingUrlPath = siteConfig.product_url;
                                if(shoppingUrlPath) {
                                    if(siteConfig.home_url) shoppingUrlPath = S(shoppingUrlPath).trimLeft(siteConfig.home_url);
                                    else shoppingUrlPath = S(shoppingUrlPath).trimRight('/').split('/').pop();
                                    shoppingUrlPath = S(shoppingUrlPath).ensureLeft('/').trimRight('/').s;
                                }

                                siteConfig.shopping_url_path = shoppingUrlPath || '/shop';
                            }
                        });

                        return resp;
                    });
            }
            return $.when(promise);
        },
        getSiteUrls: function(store) {
            if(fpConfig.intent == 'admin') {
                if(_.isString(store)) store = fp.cache.hashedAuthorizedStores[store];
            }
            var siteUrls,
                lineage = (store || fp.store).lineage;
            if (_.size(lineage)) {
                var hashedSiteUrls = fp.cache.hashedStoreSettings.siteUrls;
                for (var n = lineage.length - 1; n >= 0; n--) {
                    siteUrls = hashedSiteUrls[lineage[n]];
                    if (siteUrls) break;
                }
            }
            return _.getObject(siteUrls);
        },
        initBodyEvents: function() {
            var $doc = $(document),
                touched = false,
                detectMouse = function(event){
                    if(event.type === 'touchstart') touched = true;
                    else if(!touched && event.type === 'mousemove') fp.device.usingMouse = true;

                    $doc.off(event.type, detectMouse);
                };

            //prevent Freshop forms from submitting to server
            //all form submissions will be handled via XHR
            //prevent default for modal click events
            $doc
                .off('.modal.fp .dismiss.fp .changeStore.fp')
                .on('touchstart mousemove', detectMouse)
                .on('submit.fp', '.fp-core form.fp-form', fpUi.preventDefault)
                .on('click.showShopIntent.modal.fp', '[data-action^="show-shop-intent-modal"], [href^="#show-shop-intent-modal"], [data-action^="show-address-modal"], [href^="#show-address-modal"], [data-action^="show-store-locator-modal"]', fpUi.preventDefault);

            $(document.body)
                .find('.fp-clickable-phone').each(function () {
                    const $this = $(this);
                    $this.html(fpUi.getMobilePhoneHtml($this.html()));
                });
        },
        bindBodyEvents: function() {
            $(document)
                .off('.modal.fp .dismiss.fp .changeStore.fp')
                .on('click.showShopIntent.modal.fp', '[data-action^="show-shop-intent-modal"], [href^="#show-shop-intent-modal"], [data-action^="show-store-locator-modal"]', function(event) {
                    event.preventDefault();
                    
                    var modalOptions = {
                        force: true,
                        fulfillmentIdentifier: $(this).attr('data-modal-action')
                    };

                    if(S($(this).attr('data-action')).s == 'show-store-locator-modal') {
                        modalOptions.next = '/';
                        modalOptions.fulfillmentIdentifier = 'store-locator';
                    }

                    fpUi.showShopIntentModal(modalOptions);
                })
                .on('click.showAddress.modal.fp', '[data-action^="show-address-modal"], [href^="#show-address-modal"]', function(event) {
                    event.preventDefault();
                    fpUi.showAddressModal(true);
                })
                .on('click.alert.dismiss.fp', '[data-dismiss="alert"]', function(event) {
                    var $target = $(event.target),
                        $alert = $target.closest('[data-role].alert-dismissible'),
                        dataRole;

                    if (dataRole = $alert.attr('data-role')) {
                        var pref = {};
                        pref[fpUtil.formatString('dismiss-{0}', dataRole)] = true;
                        fp.setPrefCookie(pref);
                    }
                })
                .on('click.showIframe.modal.fp', '[data-action="show-iframe-modal"]', function(event) {
                    event.preventDefault();

                    var $this = $(this);

                    // if(fp.isLocal()) $this.attr('href', 'http://localhost:8585/congratulations');

                    fpUi.showModal({
                        name: 'iframe',
                        className: 'fp-modal-iframe',
                        template: 'component/0/modal-iframe.html',
                        title: $this.text(),
                        content: fpUtil.formatString('<div class="embed-responsive embed-responsive-vh"><iframe class="embed-responsive-item" src="{0}" allowfullscreen></iframe></div>', $this.attr('href'))
                    });
                })
                .on('click.changeStore.fp', '[data-action="change-store"]', function(event) {
                    event.preventDefault();
    
                    var $this = $(this),
                        storeId = $this.attr('data-store-id'),
                        storeNumber = $this.attr('data-store-number');

                    if(storeId || storeNumber) {
                        fp.storeChange({
                            storeId: storeId,
                            storeNumber: storeNumber,
                            next: $this.attr('data-next')
                        });
                    }
                })
                .on('click.reloadPage.fp', '[data-action="reload-page"]', function(event) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    window.location.reload();
                });
        },
        getBarcodeFormat: function(format, defaultFormat) {
            var barcodeFormat = fpConstants.barcodeFormat;
            return barcodeFormat[S(format).toLowerCase().s] || barcodeFormat[S(defaultFormat).toLowerCase().s] || barcodeFormat.upc;
        },
        getHash: function(value, seed) {
            if(!_.isString(value)) value = '';
            /*jshint bitwise:false */
            var i, l,
                hval = (seed === undefined) ? 0x811c9dc5 : seed;

            for (i = 0, l = value.length; i < l; i++) {
                hval ^= value.charCodeAt(i);
                hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
            }
            return ("0000000" + (hval >>> 0).toString(16)).substr(-8);
        },
        getOauthTypes: function(returnUrl) {
            var authenticationTypes = fpUtil.map.get('spcUserAuthenticationType').items(),
                oauthTypes = [];

            if (authenticationTypes.length) {
                if(!returnUrl) {
                    var stateManager = fpUi.router.stateManager;
                    returnUrl = stateManager.stateParams.next;

                    if(returnUrl) {
                        returnUrl = fpUi.router.location.origin() + fpUi.router.routeManager.relativeUrl(returnUrl);
                    }
                    else if(!returnUrl && stateManager.is(fpConfig.routeStates.login)) {
                        returnUrl = fpUi.router.location.origin();
                    }
                }

                var payload = {
                    app_key: fp.appKey,
                    token: fp.session.token,
                    return_url: returnUrl || window.location.href
                };

                _.each(authenticationTypes, function(item) {
                    if (item.config && item.config.is_oauth) {
                        oauthTypes.push({
                            identifier: item.service_provider.identifier,
                            name: item.service_provider.name,
                            url: fpUtil.getApiUrl(fpUtil.formatString('oauth2/{0}/start', item.service_provider.identifier), payload, null, false, true),
                            logout_url: item.config.delete_external_session ? fpUtil.getApiUrl(fpUtil.formatString('oauth2/{0}/end', item.service_provider.identifier), payload, null, false, true) : null
                        });
                    }
                });
            }

            return oauthTypes;
        },
        loaded: function() {
            return fpUtil.getPromiseFromEvent(fp.events.LOADED);
        },
        initRecaptcha: function() {
            let promise;

            if(!fp.grecaptchaReady) {
                var googleRecaptchaConfig;
                promise = fpUtil.map.load({
                    service: fpService.serviceProviderConfigurationService,
                    payload: {
                        service_provider_type: 'captcha',
                        store_id: fpUtil.getStateValue(fpConfig.intent == 'admin', fpConfig.adminStoreId, fp.store.id)
                    }
                })
                .then(function () {
                    var googleRecaptcha = _.find(fpUtil.map.get('spcCaptcha').items(), function(item) {
                            return item.service_provider &&
                                item.service_provider.identifier == 'google_recaptcha_enterprise' &&
                                item.config &&
                                item.config.site_key;
                        });

                        if(googleRecaptcha) {
                            fp.enableCaptchaEnterprise = true;
                        }
                        else{
                            googleRecaptcha = _.find(fpUtil.map.get('spcCaptcha').items(), function(item) {
                                return item.service_provider &&
                                    item.service_provider.identifier == 'google_recaptcha' &&
                                    item.config &&
                                    item.config.version === 'v3' &&
                                    item.config.site_key;
                            });
                        }

                    googleRecaptchaConfig = googleRecaptcha && googleRecaptcha.config;

                    if(!window.grecaptcha && googleRecaptchaConfig && googleRecaptchaConfig.site_key) {
                        // window.onRecaptchaSuccess = function() {
                        //     debugger;
                        // };
                        // googleRecaptcha = _.find(fpUtil.map.get('spcCaptcha').items(), function(item) {
                        //     return item.service_provider &&
                        //         item.service_provider.identifier == 'google_recaptcha' &&
                        //         item.config &&
                        //         item.config.version === 'v2' &&
                        //         item.config.site_key;
                        // }),
                        // $(document.body)
                        //     .append(fpUtil.formatString('<form action="?" method="POST"><div id="recaptcha-demo" class="g-recaptcha" data-sitekey="{0}" data-callback="onRecaptchaSuccess" data-action="action" data-bind="recaptcha-demo-submit"></div><button id="recaptcha-demo-submit" type="submit">Test Captcha</button></form>', googleRecaptcha.config.site_key));
                        return fp.enableCaptchaEnterprise ? fpUi.loadScript(fpUtil.formatString('https://www.google.com/recaptcha/enterprise.js?render={0}', googleRecaptchaConfig.site_key)) : fpUi.loadScript(fpUtil.formatString('https://www.google.com/recaptcha/api.js?render={0}', googleRecaptchaConfig.site_key));
                    }
                })
                .done(function () {
                    if (window.grecaptcha && googleRecaptchaConfig && googleRecaptchaConfig.site_key) {
                        if(fp.enableCaptchaEnterprise) grecaptcha = grecaptcha.enterprise;
                        grecaptcha.ready(function () {
                            fp.grecaptchaReady = true;
                            fp.trigger(fp.events.CAPTCHA_READY);
                        });
                        setTimeout(function() {
                            if(!fp.grecaptchaReady) {
                                fp.grecaptchaReady = false;
                                fp.trigger(fp.events.CAPTCHA_READY);
                            }
                        }, 300);
                    }
                });
            }
            return $.when(promise);
        },
        verifyRecaptcha: function(payload, options) {
            var deferredRecaptcha;
            if(window.grecaptcha) {
                var googleRecaptcha = _.find(fpUtil.map.get('spcCaptcha').items(), function(item) {
                    return item.service_provider &&
                        item.service_provider.identifier == 'google_recaptcha' &&
                        item.config &&
                        item.config.version === 'v3' &&
                        item.config.site_key;
                });

                if (googleRecaptcha.config && googleRecaptcha.config.site_key) {
                    deferredRecaptcha = $.Deferred();
                    grecaptcha.ready(function () {
                        options = _.getObject(options);
                        try {
                            grecaptcha
                                .execute(googleRecaptcha.config.site_key, {
                                    action: options.action || 'submit'
                                })
                                .then(function (token) {
                                    //fp.log('https://pre-prod-api.freshop.com/2/webhook/recaptcha/verify?_method=POST&app_key=demo');
                                    //fp.log(fpUtil.formatString('&captcha_response={0}&service_provider_configuration_id=2333036639284107932&store_id=903&token=b349d8e8265244ca6c4ddedc25b3bf21', token));
                                    //
                                    //return;

                                    fpService.webhookService
                                        .post(_.defaults(payload, {
                                            service_provider_configuration_id: googleRecaptcha.id,
                                            captcha_response: token,
                                            store_id: googleRecaptcha.store_id || fp.topStore.id,/* ,
                                            spill: true,
                                            error_code: 'captcha_required',
                                            status_code: 400 */
                                        }), {
                                            childServiceCall: 'recaptcha/verify',
                                            ignoreErrors: ['invalid_operation', 'captcha_required']

                                        })
                                        .then(function(resp) {
                                            resp.token = token;
                                            return resp;
                                        }, function(jqXHR, textStatus, errorThrown, options) {
                                            var xhrResp = fpUtil.getXhrErrorResponse(jqXHR);
                                            if (_.contains(options.ignoreErrors, xhrResp.error_code)) {
                                                return fpUi.showRecaptchaChallenge();
                                            }
                                            else {
                                                return $.Deferred().reject(jqXHR, textStatus, errorThrown, options);
                                            }
                                        })
                                        .then(deferredRecaptcha.resolve, deferredRecaptcha.reject);
                                        // .then(function() {
                                        //     if(fp.isLocal()) return fpUi.showRecaptchaChallenge();
                                        // });
                            });
                        }
                        catch(exc){
                            deferredRecaptcha.reject(exc.toString());

                            fp.notifier.notify(exc, {
                                severity: 'error'
                            });
                        }
                    });
                }
                else {
                    fp.warn('Google Recaptcha v3 has not been configured');
                }
            }

            return $.when(deferredRecaptcha);
        },
        showRecaptchaChallenge: function(selector) {
            var deferredRecaptcha;
            grecaptcha = grecaptcha?.enterprise ? grecaptcha.enterprise : grecaptcha;
            if(window.grecaptcha) {
                let googleRecaptcha;

                if(fp.enableCaptchaEnterprise) {
                    googleRecaptcha = _.find(fpUtil.map.get('spcCaptcha').items(), function(item) {
                        return item.service_provider &&
                            item.service_provider.identifier == 'google_recaptcha_enterprise' &&
                            item.config &&
                            item.config.site_key;
                    });
                }
                else {
                    googleRecaptcha = _.find(fpUtil.map.get('spcCaptcha').items(), function(item) {
                        return item.service_provider &&
                            item.service_provider.identifier == 'google_recaptcha' &&
                            item.config &&
                            item.config.version === 'v2' &&
                            item.config.site_key;
                    });
                }

                if (googleRecaptcha) {
                    deferredRecaptcha = $.Deferred();

                    var $element;
                    if(selector && ($element = $(selector)).length) {
                        grecaptcha.render($element[0], {
                            sitekey: googleRecaptcha.config.site_key,
                            callback: deferredRecaptcha.resolve
                        });
                    }
                    else {
                        var $modal = fpUi.showModal({
                            name: 'recaptcha',
                            template: 'component/0/modal.html',
                            className: 'fp-recaptcha-modal',
                            title: fpUi.locale('shared-verify', 'Verify'),
                            disableClose: true,
                            content: fp.ui.renderTemplate('component/0/animated-loading.html')
                        })
                        .on('shown.bs.modal.recaptchaModal', function () {
                            var $recaptchaWrapper = $('<div class="fp-text-center"><div class="fp-display-inline-block" data-role="recaptcha" style="margin:0 auto;"></div></div>');
                            $modalContent = $modal
                                .find('[data-role="modal-content"]')
                                .addClass('fp-text-center');

                            $modalContent
                                .find('[data-role="animated-loading"]')
                                .replaceWith($recaptchaWrapper);

                            grecaptcha.ready(function () {
                                var $recaptcha = $recaptchaWrapper.find('[data-role="recaptcha"]');
                                grecaptcha.render($recaptcha[0], {
                                    sitekey: googleRecaptcha.config.site_key,
                                    callback: function(token) {
                                        if(fp.enableCaptchaEnterprise) {
                                            _.delay(function(){
                                                deferredRecaptcha.resolve(token);
                                                fpUi.hideModal($modal);
                                            }, 500);
                                            return;
                                        }
                                        fpService.webhookService
                                            .post({
                                                service_provider_configuration_id: googleRecaptcha.id,
                                                captcha_response: token,
                                                store_id: googleRecaptcha.store_id || fp.topStore.id
                                            }, {
                                                childServiceCall: 'recaptcha/verify',
                                                ignoreErrors: true
                                            })
                                            .done(function(resp) {
                                                // if(!$recaptchaWrapper.find('[data-role="verify-continue"]').length) {
                                                //     $recaptchaWrapper
                                                //         .append('<div class="fp-margin-top" data-role="verify-continue">' + fpUi.localef('shared-verified', 'You have been verified. [Click here to continue].', '<a href="javascript:;" data-action="continue">') + '</div>');
                                                // }

                                                resp.token = token;
                                                _.delay(function(){
                                                    deferredRecaptcha.resolve(resp);
                                                    fpUi.hideModal($modal);
                                                }, 500);
                                            })
                                            .fail(function(jqXHR, textStatus, errorThrown) {
                                                fpUtil.showError(errorThrown, $modalContent.find('[data-role="alert"]'));
                                                grecaptcha.reset($recaptcha[0]);
                                            });
                                    }
                                });
                            });
                        });
                        // .on('click.bs.modal.recaptchaModal', '[data-action="continue"]', function(event) {
                        //     event.preventDefault();

                        //     new fpUi.Loading({
                        //         appendTo: $modal.find('[data-role="modal-content"]'),
                        //         showOnInstantiate: true
                        //     });

                        //     fp.isUnloading = freshop.unloading = true;
                        //     window.location.reload();
                        // });
                    }
                }
                else {
                    fp.notifier.notify({
                        name: 'GrecaptchaWarning',
                        message: 'GrecaptchaWarning: window.grecaptcha not found'
                    }, {
                        severity: 'warning'
                    });
                }
            }

            return $.when(deferredRecaptcha);
        },
        processStyleSheets: function() {
            const replaceCssColor = _.size(fpConfig.replaceCssColor) && fpConfig.replaceCssColor;

            if (replaceCssColor) {
                // Loop through each stylesheet
                let cssRules,
                    isLocalSheet;

                _.each(document.styleSheets, function(sheet) {
                    cssRules = null;
                    isLocalSheet = replaceCssColor ? S(sheet.href).startsWith(fp.assetCdnBaseUrl) : false;

                    if (isLocalSheet) {
                        try {
                            cssRules = sheet.cssRules || sheet.rules;
                        }
                        catch (exc) {}
                    }
                    
                    if(cssRules && !sheet.__processed) {
                        sheet.__processed = true;
                        _.each(cssRules, function(rule) {
                            if (replaceCssColor && isLocalSheet && rule.style) {
                                let color;

                                _.each([
                                    'color',
                                    'backgroundColor',
                                    'borderColor',
                                    'borderTopColor',
                                    'borderRightColor',
                                    'borderBottomColor',
                                    'borderLeftColor',
                                    'boxShadow'
                                ], function(key) {
                                    if(color = rule.style[key]) {
                                        _.each(replaceCssColor, function(item) {
                                            if(color.indexOf(item.start) >= 0) {
                                                rule.style[key] = color.replace(item.start, item.end);
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },
        updateProductSubscription: function(updateInfo) {
           if(!_.size(updateInfo)) return;

           var $button = $(updateInfo.button),
                product = updateInfo.product,                
                action = fp.S($button.attr('data-action')).trimRight('-product-subscription').s,
                $productSubscriptionForm = $button.closest('.fp-subscription-prog-item'),
                $quantityDdl = $productSubscriptionForm.find('.fp-dropdown-subscription-quantity'),
                $frequencyDdl = $productSubscriptionForm.find('.fp-dropdown-subscription-frequency'),
                subscribeObj = {
                    quantity: $quantityDdl.data('fp.ui.Component').getValue() || $quantityDdl.attr('data-default'),
                    days_in_effect: $frequencyDdl.data('fp.ui.Component').getValue() || $frequencyDdl.attr('data-default')
                },
                serviceProvideTypeId = $productSubscriptionForm.attr('data-id'),
                listManager = updateInfo.listManager || fp.listManager,
                listItem = listManager.getItem(product.id, {isProductId: true}),
                $errorSelector = $button.closest('.fp-form').find('.fp-error'),
                promise;             

            switch(action) {
                case 'submit':
                    subscribeObj.store_id = fp.store.id;
                    subscribeObj.product_id = product.id;
                    subscribeObj.service_provider_configuration_id = serviceProvideTypeId;
                    subscribeObj.fulfillment_type_id = $frequencyDdl.find('> input').attr('data-fulfillment-id');

                    // check if item is in cart, otherwise add
                    if(!listItem) {
                        fp.trigger(fp.events.LIST_ITEM_ADD, {
                            listManager: listManager,
                            item: product,
                            formValues: {}
                        });
                    }

                    promise = fpService.userProductSubscriptionService
                        .post(subscribeObj, {
                            childServiceCall: fpUtil.formatString('{0}/initiate', fp.user.id),
                            errorSelector: $errorSelector
                        });       
                    break;
                case 'update':
                    subscribeObj.id = fp.user.id;
                    promise = fpService.userProductSubscriptionService
                        .update(subscribeObj, {
                            childServiceCall: serviceProvideTypeId,
                            errorSelector: $errorSelector
                        });
                    break;
                case 'cancel':
                    promise = fpService.userProductSubscriptionService
                        .post({
                            id: fp.user.id
                        }, {
                            childServiceCall: fpUtil.formatString('{0}/cancel', serviceProvideTypeId),
                            errorSelector: $errorSelector
                        });
                    break;
                case 'void':
                    promise = fpService.userProductSubscriptionService
                        .delete(fp.user.id, {
                            childServiceCall: serviceProvideTypeId,
                            errorSelector: $errorSelector
                        });
                    break;
                //no default
            }

            if(promise) {
                if($button.length) {
                    new fp.ui.Loading({
                        appendTo: $button,
                        promiseHide: promise,
                        enableEvents: true,
                        showOnInstantiate: true,
                        destroyOnHide: true
                    });
                }

                if(listItem) {
                    promise
                        .done(function(resp) {
                            listItem.my_current_subscription = resp;
                            fp.trigger(fp.events.LIST_ITEM_CHANGED, {
                                listManager: fp.listManager, 
                                item: listItem,
                                itemChangeSuccess: true,
                                itemChangeType: fp.constants.listItemChangeType.SUBSCRIPTION
                            }, null, true);
                        });
                }
            }

            return promise;
        },
        preventTabOnKeydown: function(event) {
            //prevent tabbing until module is rendered
            if (event.keyCode === 0 || event.keyCode === 9) {
                event.preventDefault();
            }
        }
    });

    function getNavigation(state, menuItemHash) {
        menuItemHash = _.getObject(menuItemHash);

        var stateManager = fpUi.router.stateManager,
            state = _.getObject(state),
            childMenu = state.abstract ? state.children : state.menu,
            nav = {};

        if(!_.size(childMenu)) return nav;

        var isAuthenticated = fpUtil.isAuthenticated();
        //    currentStateData = _.getObject(stateManager.current.data),
        //    parentStateData = _.getObject(stateManager.getTopParent(stateManager.current).data);
        //
        ////don't display child menu if current state explicitly
        ////does not require validation but parent does
        //if (isAuthenticated && currentStateData.authenticate === false && parentStateData.authenticate) {
        //    return nav;
        //}

        nav.children = state.abstract ? {} : [];

        var isPending = fp.user.user_status_identifier == 'registration_pending',
            data,
            menuItem,
            menuItemSubNav,
            includeInMenu,
            activeMenuItem;

        _.each(childMenu, function (item) {
            includeInMenu = _.result(item, 'includeInMenu');
            if(includeInMenu) {
                data = _.getObject(item.data);

                if (data.authenticate && !isAuthenticated) return;
                if (data.authorize && (!fpUtil.isAuthorized(data) || isPending)) return;
            }

            if(item == stateManager.current) nav.active = true;

            if(!includeInMenu) return;

            menuItem = {
                id: item.name,
                title: fpUi.locale('route-' + item.name, _.result(item.data, 'title')),
                url: stateManager.href(item)
            };

            if(item == stateManager.current) menuItem.active = true;
            menuItemHash[menuItem.id] = menuItem;

            if(item.parent && !item.parent.abstract) {
                menuItem.parent_id = item.parent.name;
            }

            if(item == stateManager.current) {
                activeMenuItem = menuItem;

                do {
                    activeMenuItem = activeMenuItem.parent_id && menuItemHash[activeMenuItem.parent_id];
                    if(activeMenuItem) activeMenuItem.active = true;
                }
                while(activeMenuItem);
            }

            //it's possible to have a child menu item that is the same as a parent
            //in this case do not add it's children (it would be an endless recursive loop)
            if(item.menuParent != state.name) {
                menuItemSubNav = getNavigation(item, menuItemHash);
                //handle active menu item cases where child menu has the same id as parent menu
                if(menuItemSubNav.active) menuItem.active = true;
                if(menuItemSubNav.children) menuItem.children = menuItemSubNav.children;
            }

            if (state.abstract) {
                nav.children[S(item.name).underscore().s] = menuItem;
            }
            else {
                menuItem.sequence = item.menuSequence;
                nav.children.push(menuItem);
            }
        });

        return nav;
    }
})();
